/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../src/routes/~__root';
import { Route as IndexRouteImport } from './../src/routes/~index';
import { Route as AdminConsentRouteImport } from './../src/routes/~admin-consent';
import { Route as AttestationRouteRouteImport } from './../src/routes/~attestation/~route';
import { Route as InviteRouteRouteImport } from './../src/routes/~invite/~route';
import { Route as LodgeRouteRouteImport } from './../src/routes/~lodge/~route';
import { Route as MaintenanceRouteImport } from './../src/routes/~maintenance';
import { Route as NotFoundRouteImport } from './../src/routes/~not-found';
import { Route as NotSupportedRouteImport } from './../src/routes/~not-supported';
import { Route as OauthRouteRouteImport } from './../src/routes/~oauth/~route';
import { Route as OrgSwitchedRouteImport } from './../src/routes/~org-switched';
import { Route as PublicRouteRouteImport } from './../src/routes/~public/~route';
import { Route as StatusRouteImport } from './../src/routes/~status';
import { Route as TermsAcceptanceRouteRouteImport } from './../src/routes/~terms-acceptance/~route';
import { Route as authenticationAdminLoginRouteImport } from './../src/routes/~(authentication)/~admin-login';
import { Route as authenticationCallbackRouteImport } from './../src/routes/~(authentication)/~callback';
import { Route as authenticationLoginRouteImport } from './../src/routes/~(authentication)/~login';
import { Route as authenticationLogoutRouteImport } from './../src/routes/~(authentication)/~logout';
import { Route as authenticationLogoutinRouteImport } from './../src/routes/~(authentication)/~logoutin';
import { Route as authenticationOrgMismatchRouteImport } from './../src/routes/~(authentication)/~org-mismatch';
import { Route as authenticationPaymentPendingRouteImport } from './../src/routes/~(authentication)/~payment-pending';
import { Route as authenticationTrialExpiredRouteImport } from './../src/routes/~(authentication)/~trial-expired';
import { Route as AttestationTokenRouteImport } from './../src/routes/~attestation/~$token';
import { Route as ConsoleOrgIdRouteRouteImport } from './../src/routes/~console.$orgId/~route';
import { Route as DocumentSourcesConsentRouteImport } from './../src/routes/~document-sources.consent';
import { Route as LodgeKeyRouteRouteImport } from './../src/routes/~lodge/~$key/~route';
import { Route as OauthAuthorizeRouteImport } from './../src/routes/~oauth/~authorize';
import { Route as PasswordResetRequestRouteImport } from './../src/routes/~password-reset/~request';
import { Route as PasswordResetResetRouteImport } from './../src/routes/~password-reset/~reset';
import { Route as PublicOrgIdRouteRouteImport } from './../src/routes/~public/~$orgId/~route';
import { Route as WhatsNewReleaseIdRouteImport } from './../src/routes/~whats-new.$releaseId';
import { Route as authenticationChangeOrgOrgIdRouteImport } from './../src/routes/~(authentication)/~change-org.$orgId';
import { Route as ConsoleOrgIdIndexRouteImport } from './../src/routes/~console.$orgId/~index';
import { Route as ConsoleOrgIdAttestationsRouteRouteImport } from './../src/routes/~console.$orgId/~attestations/~route';
import { Route as ConsoleOrgIdClaimsRouteRouteImport } from './../src/routes/~console.$orgId/~claims/~route';
import { Route as ConsoleOrgIdComplianceRouteRouteImport } from './../src/routes/~console.$orgId/~compliance/~route';
import { Route as ConsoleOrgIdComponentShowcaseRouteRouteImport } from './../src/routes/~console.$orgId/~component-showcase/~route';
import { Route as ConsoleOrgIdConfigurationRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~route';
import { Route as ConsoleOrgIdControlsRouteRouteImport } from './../src/routes/~console.$orgId/~controls/~route';
import { Route as ConsoleOrgIdDashboardRouteRouteImport } from './../src/routes/~console.$orgId/~dashboard/~route';
import { Route as ConsoleOrgIdDocumentsRouteRouteImport } from './../src/routes/~console.$orgId/~documents/~route';
import { Route as ConsoleOrgIdFaqRouteRouteImport } from './../src/routes/~console.$orgId/~faq/~route';
import { Route as ConsoleOrgIdFleetPortalRouteRouteImport } from './../src/routes/~console.$orgId/~fleet-portal/~route';
import { Route as ConsoleOrgIdGetFileRouteRouteImport } from './../src/routes/~console.$orgId/~get-file/~route';
import { Route as ConsoleOrgIdMsprRouteRouteImport } from './../src/routes/~console.$orgId/~mspr/~route';
import { Route as ConsoleOrgIdReportingRouteRouteImport } from './../src/routes/~console.$orgId/~reporting/~route';
import { Route as ConsoleOrgIdRiskRouteRouteImport } from './../src/routes/~console.$orgId/~risk/~route';
import { Route as ConsoleOrgIdToolsRouteRouteImport } from './../src/routes/~console.$orgId/~tools/~route';
import { Route as ConsoleOrgIdToolsOnlyHomePageRouteImport } from './../src/routes/~console.$orgId/~tools-only-home-page';
import { Route as ConsoleOrgIdUserSettingsRouteRouteImport } from './../src/routes/~console.$orgId/~user-settings/~route';
import { Route as ConsoleOrgIdWorkloadManagerRouteRouteImport } from './../src/routes/~console.$orgId/~workload-manager/~route';
import { Route as LodgeResumePublicIdRouteRouteImport } from './../src/routes/~lodge/~resume.$publicId/~route';
import { Route as LodgeSummaryPublicIdRouteRouteImport } from './../src/routes/~lodge/~summary.$publicId/~route';
import { Route as PublicLodgementSummaryAccessKeyRouteRouteImport } from './../src/routes/~public/~lodgement-summary.$accessKey/~route';
import { Route as PublicNewComplaintByKeyKeyRouteRouteImport } from './../src/routes/~public/~new-complaint-by-key.$key/~route';
import { Route as PublicNewComplaintOrgIdRouteRouteImport } from './../src/routes/~public/~new-complaint.$orgId/~route';
import { Route as ConsoleOrgIdAttestationsIndexRouteImport } from './../src/routes/~console.$orgId/~attestations/~index';
import { Route as ConsoleOrgIdAttestationsOverviewRouteRouteImport } from './../src/routes/~console.$orgId/~attestations/~overview/~route';
import { Route as ConsoleOrgIdAttestationsScheduledAttestationsRouteRouteImport } from './../src/routes/~console.$orgId/~attestations/~scheduled-attestations/~route';
import { Route as ConsoleOrgIdAttestationsUserAttestationsRouteRouteImport } from './../src/routes/~console.$orgId/~attestations/~user-attestations/~route';
import { Route as ConsoleOrgIdClaimsIndexRouteImport } from './../src/routes/~console.$orgId/~claims/~index';
import { Route as ConsoleOrgIdClaimsLodgeFromDocumentsRouteImport } from './../src/routes/~console.$orgId/~claims/~lodge-from-documents';
import { Route as ConsoleOrgIdClaimsLodgementsRouteRouteImport } from './../src/routes/~console.$orgId/~claims/~lodgements/~route';
import { Route as ConsoleOrgIdComplianceIndexRouteImport } from './../src/routes/~console.$orgId/~compliance/~index';
import { Route as ConsoleOrgIdComplianceCoiRouteRouteImport } from './../src/routes/~console.$orgId/~compliance/~coi/~route';
import { Route as ConsoleOrgIdComplianceComplaintsRouteRouteImport } from './../src/routes/~console.$orgId/~compliance/~complaints/~route';
import { Route as ConsoleOrgIdComplianceIncidentsRouteRouteImport } from './../src/routes/~console.$orgId/~compliance/~incidents/~route';
import { Route as ConsoleOrgIdComplianceIntakeRouteRouteImport } from './../src/routes/~console.$orgId/~compliance/~intake/~route';
import { Route as ConsoleOrgIdComplianceObligationsRouteRouteImport } from './../src/routes/~console.$orgId/~compliance/~obligations/~route';
import { Route as ConsoleOrgIdComplianceRegistersRouteRouteImport } from './../src/routes/~console.$orgId/~compliance/~registers/~route';
import { Route as ConsoleOrgIdComplianceTrainingRouteRouteImport } from './../src/routes/~console.$orgId/~compliance/~training/~route';
import { Route as ConsoleOrgIdComponentShowcaseIndexRouteImport } from './../src/routes/~console.$orgId/~component-showcase/~index';
import { Route as ConsoleOrgIdComponentShowcaseAiChatTestRouteImport } from './../src/routes/~console.$orgId/~component-showcase/~ai-chat-test';
import { Route as ConsoleOrgIdComponentShowcaseButtonIconTestRouteImport } from './../src/routes/~console.$orgId/~component-showcase/~button-icon-test';
import { Route as ConsoleOrgIdComponentShowcaseButtonVariantsRouteImport } from './../src/routes/~console.$orgId/~component-showcase/~button-variants';
import { Route as ConsoleOrgIdComponentShowcaseComponentShowcaseRouteImport } from './../src/routes/~console.$orgId/~component-showcase/~component-showcase';
import { Route as ConsoleOrgIdComponentShowcaseDatePickerTestRouteImport } from './../src/routes/~console.$orgId/~component-showcase/~date-picker-test';
import { Route as ConsoleOrgIdComponentShowcaseFitOnPageRouteImport } from './../src/routes/~console.$orgId/~component-showcase/~fit-on-page';
import { Route as ConsoleOrgIdComponentShowcaseMarkdownShowcaseRouteImport } from './../src/routes/~console.$orgId/~component-showcase/~markdown-showcase';
import { Route as ConsoleOrgIdComponentShowcaseTableShowcaseRouteImport } from './../src/routes/~console.$orgId/~component-showcase/~table-showcase';
import { Route as ConsoleOrgIdComponentShowcaseTagVariantsRouteImport } from './../src/routes/~console.$orgId/~component-showcase/~tag-variants';
import { Route as ConsoleOrgIdComponentShowcaseTiptapTestRouteImport } from './../src/routes/~console.$orgId/~component-showcase/~tiptap-test';
import { Route as ConsoleOrgIdConfigurationIndexRouteImport } from './../src/routes/~console.$orgId/~configuration/~index';
import { Route as ConsoleOrgIdConfigurationApiIntegrationsRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~api-integrations/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~route';
import { Route as ConsoleOrgIdConfigurationClientDatabaseRouteImport } from './../src/routes/~console.$orgId/~configuration/~client-database';
import { Route as ConsoleOrgIdConfigurationComplianceRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~route';
import { Route as ConsoleOrgIdConfigurationFinancialsRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~financials/~route';
import { Route as ConsoleOrgIdConfigurationFleetRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~fleet/~route';
import { Route as ConsoleOrgIdConfigurationMonitoringRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~monitoring/~route';
import { Route as ConsoleOrgIdConfigurationOrgSettingsRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~org-settings/~route';
import { Route as ConsoleOrgIdConfigurationRiskRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~risk/~route';
import { Route as ConsoleOrgIdConfigurationVendorManagementRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~vendor-management/~route';
import { Route as ConsoleOrgIdControlsIndexRouteImport } from './../src/routes/~console.$orgId/~controls/~index';
import { Route as ConsoleOrgIdControlsActivitiesRouteRouteImport } from './../src/routes/~console.$orgId/~controls/~activities/~route';
import { Route as ConsoleOrgIdControlsRegisterRouteRouteImport } from './../src/routes/~console.$orgId/~controls/~register/~route';
import { Route as ConsoleOrgIdControlsTestsRouteRouteImport } from './../src/routes/~console.$orgId/~controls/~tests/~route';
import { Route as ConsoleOrgIdDashboardIndexRouteImport } from './../src/routes/~console.$orgId/~dashboard/~index';
import { Route as ConsoleOrgIdDashboardClaimsRouteImport } from './../src/routes/~console.$orgId/~dashboard/~claims';
import { Route as ConsoleOrgIdDashboardComplaintsRouteImport } from './../src/routes/~console.$orgId/~dashboard/~complaints';
import { Route as ConsoleOrgIdDashboardIncidentsRouteImport } from './../src/routes/~console.$orgId/~dashboard/~incidents';
import { Route as ConsoleOrgIdDashboardManagementRouteImport } from './../src/routes/~console.$orgId/~dashboard/~management';
import { Route as ConsoleOrgIdDashboardPeopleAndCultureRouteImport } from './../src/routes/~console.$orgId/~dashboard/~people-and-culture';
import { Route as ConsoleOrgIdDashboardRisksRouteImport } from './../src/routes/~console.$orgId/~dashboard/~risks';
import { Route as ConsoleOrgIdDebugIndexRouteImport } from './../src/routes/~console.$orgId/~debug/~index';
import { Route as ConsoleOrgIdFleetPortalIndexRouteImport } from './../src/routes/~console.$orgId/~fleet-portal/~index';
import { Route as ConsoleOrgIdFleetPortalAuthorisationsRouteImport } from './../src/routes/~console.$orgId/~fleet-portal/~authorisations';
import { Route as ConsoleOrgIdFleetPortalClaimsRouteRouteImport } from './../src/routes/~console.$orgId/~fleet-portal/~claims/~route';
import { Route as ConsoleOrgIdFleetPortalDashboardRouteImport } from './../src/routes/~console.$orgId/~fleet-portal/~dashboard';
import { Route as ConsoleOrgIdFleetPortalFleetRouteImport } from './../src/routes/~console.$orgId/~fleet-portal/~fleet';
import { Route as ConsoleOrgIdFleetPortalReportingRouteImport } from './../src/routes/~console.$orgId/~fleet-portal/~reporting';
import { Route as ConsoleOrgIdFleetPortalSlaRouteImport } from './../src/routes/~console.$orgId/~fleet-portal/~sla';
import { Route as ConsoleOrgIdMsprMspExceptionsRouteRouteImport } from './../src/routes/~console.$orgId/~mspr/~msp-exceptions/~route';
import { Route as ConsoleOrgIdMsprServiceProvidersRouteRouteImport } from './../src/routes/~console.$orgId/~mspr/~service-providers/~route';
import { Route as ConsoleOrgIdReportingAddRouteImport } from './../src/routes/~console.$orgId/~reporting/~add';
import { Route as ConsoleOrgIdRiskIndexRouteImport } from './../src/routes/~console.$orgId/~risk/~index';
import { Route as ConsoleOrgIdRiskRasRouteRouteImport } from './../src/routes/~console.$orgId/~risk/~ras/~route';
import { Route as ConsoleOrgIdRiskRegisterRouteRouteImport } from './../src/routes/~console.$orgId/~risk/~register/~route';
import { Route as ConsoleOrgIdToolsIndexRouteImport } from './../src/routes/~console.$orgId/~tools/~index';
import { Route as ConsoleOrgIdToolsAutoDetectRouteRouteImport } from './../src/routes/~console.$orgId/~tools/~auto-detect/~route';
import { Route as ConsoleOrgIdToolsComplianceAuditRouteRouteImport } from './../src/routes/~console.$orgId/~tools/~compliance-audit/~route';
import { Route as ConsoleOrgIdToolsDocumentAnalyzerRouteRouteImport } from './../src/routes/~console.$orgId/~tools/~document-analyzer/~route';
import { Route as ConsoleOrgIdToolsPdsCompareRouteRouteImport } from './../src/routes/~console.$orgId/~tools/~pds-compare/~route';
import { Route as ConsoleOrgIdToolsWebsiteCheckerRouteRouteImport } from './../src/routes/~console.$orgId/~tools/~website-checker/~route';
import { Route as ConsoleOrgIdUserSettingsIndexRouteImport } from './../src/routes/~console.$orgId/~user-settings/~index';
import { Route as ConsoleOrgIdUserSettingsNotificationsRouteImport } from './../src/routes/~console.$orgId/~user-settings/~notifications';
import { Route as ConsoleOrgIdUserSettingsProfileRouteImport } from './../src/routes/~console.$orgId/~user-settings/~profile';
import { Route as ConsoleOrgIdWorkloadManagerIndexRouteImport } from './../src/routes/~console.$orgId/~workload-manager/~index';
import { Route as ConsoleOrgIdWorkloadManagerComplaintsRouteImport } from './../src/routes/~console.$orgId/~workload-manager/~complaints';
import { Route as ConsoleOrgIdWorkloadManagerEmailsRouteRouteImport } from './../src/routes/~console.$orgId/~workload-manager/~emails/~route';
import { Route as ConsoleOrgIdWorkloadManagerTasksRouteRouteImport } from './../src/routes/~console.$orgId/~workload-manager/~tasks/~route';
import { Route as PublicOrgIdComplaintNewRouteRouteImport } from './../src/routes/~public/~$orgId/~complaint.new/~route';
import { Route as ConsoleOrgIdAttestationsRoundsRoundIdRouteRouteImport } from './../src/routes/~console.$orgId/~attestations/~rounds/~$roundId/~route';
import { Route as ConsoleOrgIdAttestationsScheduledAttestationsScheduleIdRouteRouteImport } from './../src/routes/~console.$orgId/~attestations/~scheduled-attestations/~$scheduleId/~route';
import { Route as ConsoleOrgIdAttestationsScheduledAttestationsNewRouteImport } from './../src/routes/~console.$orgId/~attestations/~scheduled-attestations/~new';
import { Route as ConsoleOrgIdAttestationsUserAttestationsAttestationIdRouteRouteImport } from './../src/routes/~console.$orgId/~attestations/~user-attestations/~$attestationId/~route';
import { Route as ConsoleOrgIdAttestationsUserAttestationsSendRouteImport } from './../src/routes/~console.$orgId/~attestations/~user-attestations/~send';
import { Route as ConsoleOrgIdClaimsDetailsIdRouteRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~route';
import { Route as ConsoleOrgIdClaimsLodgeLinkIdRouteImport } from './../src/routes/~console.$orgId/~claims/~lodge.$linkId';
import { Route as ConsoleOrgIdComplianceCoiIndexRouteImport } from './../src/routes/~console.$orgId/~compliance/~coi/~index';
import { Route as ConsoleOrgIdComplianceCoiAddRouteRouteImport } from './../src/routes/~console.$orgId/~compliance/~coi/~add/~route';
import { Route as ConsoleOrgIdComplianceComplaintsIndexRouteImport } from './../src/routes/~console.$orgId/~compliance/~complaints/~index';
import { Route as ConsoleOrgIdComplianceComplaintsAddRouteRouteImport } from './../src/routes/~console.$orgId/~compliance/~complaints/~add/~route';
import { Route as ConsoleOrgIdComplianceIncidentsIndexRouteImport } from './../src/routes/~console.$orgId/~compliance/~incidents/~index';
import { Route as ConsoleOrgIdComplianceIncidentsAddRouteImport } from './../src/routes/~console.$orgId/~compliance/~incidents/~add';
import { Route as ConsoleOrgIdComplianceObligationsIndexRouteImport } from './../src/routes/~console.$orgId/~compliance/~obligations/~index';
import { Route as ConsoleOrgIdComplianceObligationsAddRouteRouteImport } from './../src/routes/~console.$orgId/~compliance/~obligations/~add/~route';
import { Route as ConsoleOrgIdComplianceRegistersRegisterIdRouteRouteImport } from './../src/routes/~console.$orgId/~compliance/~registers/~$registerId/~route';
import { Route as ConsoleOrgIdComplianceRegistersListRouteRouteImport } from './../src/routes/~console.$orgId/~compliance/~registers/~_list/~route';
import { Route as ConsoleOrgIdComplianceTrainingIndexRouteImport } from './../src/routes/~console.$orgId/~compliance/~training/~index';
import { Route as ConsoleOrgIdComplianceTrainingSearchRouteRouteImport } from './../src/routes/~console.$orgId/~compliance/~training/~search/~route';
import { Route as ConsoleOrgIdConfigurationApiIntegrationsApiTokensRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~api-integrations/~api-tokens/~route';
import { Route as ConsoleOrgIdConfigurationApiIntegrationsDocumentSourcesRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~api-integrations/~document-sources/~route';
import { Route as ConsoleOrgIdConfigurationApiIntegrationsMcpAccessRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~api-integrations/~mcp-access/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimIntakeLinksRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~claim-intake-links/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~claims/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsContactRolesRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~contact-roles/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsFormsRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~forms/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsInsurersRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~insurers/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~product-types/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductsV2RouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~products-v2/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsQuestionnaireRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~questionnaire/~route';
import { Route as ConsoleOrgIdConfigurationClientDatabaseSplatRouteImport } from './../src/routes/~console.$orgId/~configuration/~client-database.$';
import { Route as ConsoleOrgIdConfigurationComplianceIndexRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~index';
import { Route as ConsoleOrgIdConfigurationComplianceAttestationsRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~attestations/~route';
import { Route as ConsoleOrgIdConfigurationComplianceAutoDetectRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~auto-detect/~route';
import { Route as ConsoleOrgIdConfigurationComplianceComplaintsRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~complaints/~route';
import { Route as ConsoleOrgIdConfigurationComplianceComplianceAuditRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~compliance-audit/~route';
import { Route as ConsoleOrgIdConfigurationComplianceGeneralRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~general/~route';
import { Route as ConsoleOrgIdConfigurationComplianceIncidentsRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~incidents/~route';
import { Route as ConsoleOrgIdConfigurationComplianceMsprRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~mspr/~route';
import { Route as ConsoleOrgIdConfigurationComplianceObligationsRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~obligations';
import { Route as ConsoleOrgIdConfigurationComplianceTrainingRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~training/~route';
import { Route as ConsoleOrgIdConfigurationFinancialsBankAccountRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~financials/~bank-account/~route';
import { Route as ConsoleOrgIdConfigurationFinancialsBillingRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~financials/~billing/~route';
import { Route as ConsoleOrgIdConfigurationFinancialsExpensesBillingRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~financials/~expenses-billing/~route';
import { Route as ConsoleOrgIdConfigurationFleetIndexRouteImport } from './../src/routes/~console.$orgId/~configuration/~fleet/~index';
import { Route as ConsoleOrgIdConfigurationFleetClientDatabaseRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~fleet/~client-database/~route';
import { Route as ConsoleOrgIdConfigurationFleetDelegatedAuthorityRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~fleet/~delegated-authority/~route';
import { Route as ConsoleOrgIdConfigurationFleetEscalationsRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~fleet/~escalations/~route';
import { Route as ConsoleOrgIdConfigurationFleetPortalClaimPageRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~fleet/~portal-claim-page/~route';
import { Route as ConsoleOrgIdConfigurationMonitoringAuditTrailRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~monitoring/~audit-trail/~route';
import { Route as ConsoleOrgIdConfigurationMonitoringEmailActivityRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~monitoring/~email-activity/~route';
import { Route as ConsoleOrgIdConfigurationMonitoringStatisticsRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~monitoring/~statistics/~route';
import { Route as ConsoleOrgIdConfigurationOrgSettingsCommunicationRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~org-settings/~communication/~route';
import { Route as ConsoleOrgIdConfigurationOrgSettingsFleetEscalationsRouteImport } from './../src/routes/~console.$orgId/~configuration/~org-settings/~fleet-escalations';
import { Route as ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~org-settings/~handling-parties/~route';
import { Route as ConsoleOrgIdConfigurationOrgSettingsSupportSessionsRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~org-settings/~support-sessions/~route';
import { Route as ConsoleOrgIdConfigurationOrgSettingsSystemRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~org-settings/~system/~route';
import { Route as ConsoleOrgIdConfigurationOrgSettingsTrashRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~org-settings/~trash/~route';
import { Route as ConsoleOrgIdConfigurationOrgSettingsUsersRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~org-settings/~users/~route';
import { Route as ConsoleOrgIdConfigurationRiskIndexRouteImport } from './../src/routes/~console.$orgId/~configuration/~risk/~index';
import { Route as ConsoleOrgIdConfigurationRiskAppetiteRouteImport } from './../src/routes/~console.$orgId/~configuration/~risk/~appetite';
import { Route as ConsoleOrgIdConfigurationRiskCategoriesRouteImport } from './../src/routes/~console.$orgId/~configuration/~risk/~categories';
import { Route as ConsoleOrgIdConfigurationRiskMatrixRouteImport } from './../src/routes/~console.$orgId/~configuration/~risk/~matrix';
import { Route as ConsoleOrgIdConfigurationVendorManagementRepairNetworksRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~vendor-management/~repair-networks/~route';
import { Route as ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~vendor-management/~suppliers/~route';
import { Route as ConsoleOrgIdControlsRegisterIndexRouteImport } from './../src/routes/~console.$orgId/~controls/~register/~index';
import { Route as ConsoleOrgIdControlsRegisterAddRouteRouteImport } from './../src/routes/~console.$orgId/~controls/~register/~add/~route';
import { Route as ConsoleOrgIdDocumentsDetailsFileIdRouteRouteImport } from './../src/routes/~console.$orgId/~documents/~details.$fileId/~route';
import { Route as ConsoleOrgIdFleetPortalClaimsIndexRouteImport } from './../src/routes/~console.$orgId/~fleet-portal/~claims/~index';
import { Route as ConsoleOrgIdMsprServiceProvidersIndexRouteImport } from './../src/routes/~console.$orgId/~mspr/~service-providers/~index';
import { Route as ConsoleOrgIdMsprServiceProvidersSearchRouteRouteImport } from './../src/routes/~console.$orgId/~mspr/~service-providers/~search/~route';
import { Route as ConsoleOrgIdRiskRasIndexRouteImport } from './../src/routes/~console.$orgId/~risk/~ras/~index';
import { Route as ConsoleOrgIdRiskRegisterIndexRouteImport } from './../src/routes/~console.$orgId/~risk/~register/~index';
import { Route as ConsoleOrgIdToolsAutoDetectDashboardRouteImport } from './../src/routes/~console.$orgId/~tools/~auto-detect/~dashboard';
import { Route as ConsoleOrgIdToolsAutoDetectInboxRouteRouteImport } from './../src/routes/~console.$orgId/~tools/~auto-detect/~inbox/~route';
import { Route as ConsoleOrgIdToolsComplianceAuditIndexRouteImport } from './../src/routes/~console.$orgId/~tools/~compliance-audit/~index';
import { Route as ConsoleOrgIdToolsComplianceAuditOverviewRouteRouteImport } from './../src/routes/~console.$orgId/~tools/~compliance-audit/~overview/~route';
import { Route as ConsoleOrgIdToolsDocumentAnalyzerIndexRouteImport } from './../src/routes/~console.$orgId/~tools/~document-analyzer/~index';
import { Route as ConsoleOrgIdToolsDocumentAnalyzerHistoryRouteRouteImport } from './../src/routes/~console.$orgId/~tools/~document-analyzer/~history/~route';
import { Route as ConsoleOrgIdToolsDocumentAnalyzerUploadRouteImport } from './../src/routes/~console.$orgId/~tools/~document-analyzer/~upload';
import { Route as ConsoleOrgIdToolsPdsCompareIndexRouteImport } from './../src/routes/~console.$orgId/~tools/~pds-compare/~index';
import { Route as ConsoleOrgIdToolsPdsComparePdsDocumentsRouteRouteImport } from './../src/routes/~console.$orgId/~tools/~pds-compare/~pds-documents/~route';
import { Route as ConsoleOrgIdToolsWebsiteCheckerIndexRouteImport } from './../src/routes/~console.$orgId/~tools/~website-checker/~index';
import { Route as ConsoleOrgIdUserSettingsAuthorisedAppsIndexRouteImport } from './../src/routes/~console.$orgId/~user-settings/~authorised-apps/~index';
import { Route as ConsoleOrgIdWorkloadManagerTasksIndexRouteImport } from './../src/routes/~console.$orgId/~workload-manager/~tasks/~index';
import { Route as ConsoleOrgIdWorkloadManagerTasksCalendarRouteRouteImport } from './../src/routes/~console.$orgId/~workload-manager/~tasks/~calendar/~route';
import { Route as ConsoleOrgIdWorkloadManagerTasksListRouteRouteImport } from './../src/routes/~console.$orgId/~workload-manager/~tasks/~list/~route';
import { Route as PublicOrgIdInvoiceViewAccessKeyRouteRouteImport } from './../src/routes/~public/~$orgId/~invoice.view.$accessKey/~route';
import { Route as ConsoleOrgIdAttestationsOverviewPeopleUserIdRouteImport } from './../src/routes/~console.$orgId/~attestations/~overview/~people.$userId';
import { Route as ConsoleOrgIdAttestationsRoundsRoundIdCoverageRouteImport } from './../src/routes/~console.$orgId/~attestations/~rounds/~$roundId/~coverage';
import { Route as ConsoleOrgIdClaimsDetailsIdActivityRouteRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~activity/~route';
import { Route as ConsoleOrgIdClaimsDetailsIdAiAssessmentRouteRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~ai-assessment/~route';
import { Route as ConsoleOrgIdClaimsDetailsIdCommsRouteRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~comms/~route';
import { Route as ConsoleOrgIdClaimsDetailsIdContactsRouteRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~contacts/~route';
import { Route as ConsoleOrgIdClaimsDetailsIdExpensesRouteRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~expenses/~route';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsRouteRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~financials/~route';
import { Route as ConsoleOrgIdClaimsDetailsIdHistoryRouteRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~history/~route';
import { Route as ConsoleOrgIdClaimsDetailsIdLibraryRouteRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~library/~route';
import { Route as ConsoleOrgIdClaimsDetailsIdManageRouteRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~manage/~route';
import { Route as ConsoleOrgIdClaimsDetailsIdPolicyInfoRouteRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~policy-info/~route';
import { Route as ConsoleOrgIdClaimsDetailsIdProductFieldsRouteRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~product-fields/~route';
import { Route as ConsoleOrgIdClaimsDetailsIdProductTypeDataRouteRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~product-type-data/~route';
import { Route as ConsoleOrgIdClaimsDetailsIdVehicleRouteRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~vehicle/~route';
import { Route as ConsoleOrgIdComplianceCoiDetailsIdRouteRouteImport } from './../src/routes/~console.$orgId/~compliance/~coi/~details.$id/~route';
import { Route as ConsoleOrgIdComplianceComplaintsDetailsIdRouteRouteImport } from './../src/routes/~console.$orgId/~compliance/~complaints/~details.$id/~route';
import { Route as ConsoleOrgIdComplianceIncidentsDetailsIdRouteRouteImport } from './../src/routes/~console.$orgId/~compliance/~incidents/~details.$id/~route';
import { Route as ConsoleOrgIdComplianceObligationsDetailsIdRouteRouteImport } from './../src/routes/~console.$orgId/~compliance/~obligations/~details.$id/~route';
import { Route as ConsoleOrgIdComplianceRegistersRegisterIdIndexRouteImport } from './../src/routes/~console.$orgId/~compliance/~registers/~$registerId/~index';
import { Route as ConsoleOrgIdComplianceRegistersListIndexRouteImport } from './../src/routes/~console.$orgId/~compliance/~registers/~_list/~index';
import { Route as ConsoleOrgIdComplianceRegistersListAddRouteImport } from './../src/routes/~console.$orgId/~compliance/~registers/~_list/~add';
import { Route as ConsoleOrgIdComplianceRegistersListNewRouteImport } from './../src/routes/~console.$orgId/~compliance/~registers/~_list/~new';
import { Route as ConsoleOrgIdComplianceTrainingSearchAddRouteImport } from './../src/routes/~console.$orgId/~compliance/~training/~search/~add';
import { Route as ConsoleOrgIdComplianceTrainingUserUserIdRouteRouteImport } from './../src/routes/~console.$orgId/~compliance/~training/~user.$userId/~route';
import { Route as ConsoleOrgIdConfigurationApiIntegrationsApiTokensCreateRouteImport } from './../src/routes/~console.$orgId/~configuration/~api-integrations/~api-tokens/~create';
import { Route as ConsoleOrgIdConfigurationApiIntegrationsDocumentSourcesConnectionIdRouteImport } from './../src/routes/~console.$orgId/~configuration/~api-integrations/~document-sources/~$connectionId';
import { Route as ConsoleOrgIdConfigurationApiIntegrationsDocumentSourcesAddRouteImport } from './../src/routes/~console.$orgId/~configuration/~api-integrations/~document-sources/~add';
import { Route as ConsoleOrgIdConfigurationApiIntegrationsFormDesignerIndexRouteImport } from './../src/routes/~console.$orgId/~configuration/~api-integrations/~form-designer/~index';
import { Route as ConsoleOrgIdConfigurationApiIntegrationsFormDesignerFormDefinitionIdRouteImport } from './../src/routes/~console.$orgId/~configuration/~api-integrations/~form-designer/~$formDefinitionId';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsIndexRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~claims/~index';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~claims/~catastrophe-events/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~claims/~claim-flags/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsClaimsAuthorityRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~claims/~claims-authority/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsDocumentsRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~claims/~documents';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~claims/~general/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsHandlingStandardsRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~claims/~handling-standards';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsIdRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~claims/~id';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~claims/~task-lists/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsContactRolesAddRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~contact-roles/~add';
import { Route as ConsoleOrgIdConfigurationClaimsProductsFormsIndexRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~forms/~index';
import { Route as ConsoleOrgIdConfigurationClaimsProductsFormsFormDefinitionIdRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~forms/~$formDefinitionId/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~product-types/~$productTypeId/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesAddRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~product-types/~add';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductsV2AddRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~products-v2/~add';
import { Route as ConsoleOrgIdConfigurationClaimsProductsQuestionnaireAddRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~questionnaire/~add';
import { Route as ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~attestations/~user-attestations/~route';
import { Route as ConsoleOrgIdConfigurationComplianceComplaintsIndexRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~complaints/~index';
import { Route as ConsoleOrgIdConfigurationComplianceComplaintsBrandsRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~complaints/~brands';
import { Route as ConsoleOrgIdConfigurationComplianceComplaintsCustomFieldsRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~complaints/~custom-fields';
import { Route as ConsoleOrgIdConfigurationComplianceComplaintsFlagsRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~complaints/~flags/~route';
import { Route as ConsoleOrgIdConfigurationComplianceComplaintsGeneralRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~complaints/~general/~route';
import { Route as ConsoleOrgIdConfigurationComplianceComplaintsRulesRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~complaints/~rules';
import { Route as ConsoleOrgIdConfigurationComplianceGeneralIndexRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~general/~index';
import { Route as ConsoleOrgIdConfigurationComplianceGeneralAsicProductsRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~general/~asic-products';
import { Route as ConsoleOrgIdConfigurationComplianceGeneralDocumentsRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~general/~documents';
import { Route as ConsoleOrgIdConfigurationComplianceIncidentsIndexRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~incidents/~index';
import { Route as ConsoleOrgIdConfigurationComplianceIncidentsCustomFieldsRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~incidents/~custom-fields';
import { Route as ConsoleOrgIdConfigurationComplianceIncidentsFlagsRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~incidents/~flags/~route';
import { Route as ConsoleOrgIdConfigurationComplianceIncidentsGeneralRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~incidents/~general/~route';
import { Route as ConsoleOrgIdConfigurationComplianceIncidentsRulesRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~incidents/~rules';
import { Route as ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~mspr/~critical-operations/~route';
import { Route as ConsoleOrgIdConfigurationComplianceMsprDefinitionsRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~mspr/~definitions/~route';
import { Route as ConsoleOrgIdConfigurationComplianceMsprDocumentsRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~mspr/~documents';
import { Route as ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~mspr/~governance-config/~route';
import { Route as ConsoleOrgIdConfigurationComplianceTrainingIndexRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~training/~index';
import { Route as ConsoleOrgIdConfigurationComplianceTrainingCustomFieldsRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~training/~custom-fields';
import { Route as ConsoleOrgIdConfigurationComplianceTrainingTrainingPeriodsRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~training/~training-periods';
import { Route as ConsoleOrgIdConfigurationFinancialsBankAccountAddRouteImport } from './../src/routes/~console.$orgId/~configuration/~financials/~bank-account/~add';
import { Route as ConsoleOrgIdConfigurationFinancialsBillingBalanceRouteImport } from './../src/routes/~console.$orgId/~configuration/~financials/~billing/~balance';
import { Route as ConsoleOrgIdConfigurationFinancialsBillingBillingInfoRouteImport } from './../src/routes/~console.$orgId/~configuration/~financials/~billing/~billing-info';
import { Route as ConsoleOrgIdConfigurationFinancialsBillingInvoicesRouteImport } from './../src/routes/~console.$orgId/~configuration/~financials/~billing/~invoices';
import { Route as ConsoleOrgIdConfigurationFinancialsBillingTransactionsRouteImport } from './../src/routes/~console.$orgId/~configuration/~financials/~billing/~transactions';
import { Route as ConsoleOrgIdConfigurationFinancialsBillingUsageRouteImport } from './../src/routes/~console.$orgId/~configuration/~financials/~billing/~usage';
import { Route as ConsoleOrgIdConfigurationFleetClientDatabaseAddRouteImport } from './../src/routes/~console.$orgId/~configuration/~fleet/~client-database/~add';
import { Route as ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~org-settings/~communication/~comm-signatures/~route';
import { Route as ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~org-settings/~communication/~comm-templates/~route';
import { Route as ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesAddRouteImport } from './../src/routes/~console.$orgId/~configuration/~org-settings/~handling-parties/~add';
import { Route as ConsoleOrgIdConfigurationOrgSettingsTrashIndexRouteImport } from './../src/routes/~console.$orgId/~configuration/~org-settings/~trash/~index';
import { Route as ConsoleOrgIdConfigurationOrgSettingsTrashFilesRouteImport } from './../src/routes/~console.$orgId/~configuration/~org-settings/~trash/~files';
import { Route as ConsoleOrgIdConfigurationOrgSettingsTrashRegistersRouteImport } from './../src/routes/~console.$orgId/~configuration/~org-settings/~trash/~registers';
import { Route as ConsoleOrgIdConfigurationOrgSettingsUsersIndexRouteImport } from './../src/routes/~console.$orgId/~configuration/~org-settings/~users/~index';
import { Route as ConsoleOrgIdConfigurationVendorManagementSuppliersIndexRouteImport } from './../src/routes/~console.$orgId/~configuration/~vendor-management/~suppliers/~index';
import { Route as ConsoleOrgIdConfigurationVendorManagementSuppliersAddRouteImport } from './../src/routes/~console.$orgId/~configuration/~vendor-management/~suppliers/~add';
import { Route as ConsoleOrgIdConfigurationVendorManagementSuppliersDefinitionsRouteImport } from './../src/routes/~console.$orgId/~configuration/~vendor-management/~suppliers/~definitions';
import { Route as ConsoleOrgIdControlsRegisterDetailsIdRouteRouteImport } from './../src/routes/~console.$orgId/~controls/~register/~details.$id/~route';
import { Route as ConsoleOrgIdFleetPortalClaimsDetailsClaimIdRouteImport } from './../src/routes/~console.$orgId/~fleet-portal/~claims/~details.$claimId';
import { Route as ConsoleOrgIdMsprMspExceptionsEditIdRouteImport } from './../src/routes/~console.$orgId/~mspr/~msp-exceptions/~edit.$id';
import { Route as ConsoleOrgIdMsprServiceProvidersDetailsIdRouteRouteImport } from './../src/routes/~console.$orgId/~mspr/~service-providers/~details.$id/~route';
import { Route as ConsoleOrgIdMsprServiceProvidersSearchAddRouteImport } from './../src/routes/~console.$orgId/~mspr/~service-providers/~search/~add';
import { Route as ConsoleOrgIdRiskRasDetailsIdRouteRouteImport } from './../src/routes/~console.$orgId/~risk/~ras/~details.$id/~route';
import { Route as ConsoleOrgIdRiskRegisterDetailsIdRouteRouteImport } from './../src/routes/~console.$orgId/~risk/~register/~details.$id/~route';
import { Route as ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdRouteImport } from './../src/routes/~console.$orgId/~tools/~compliance-audit/~details.$complianceAuditId';
import { Route as ConsoleOrgIdToolsComplianceAuditOverviewIndexRouteImport } from './../src/routes/~console.$orgId/~tools/~compliance-audit/~overview/~index';
import { Route as ConsoleOrgIdToolsComplianceAuditOverviewInsightsRouteImport } from './../src/routes/~console.$orgId/~tools/~compliance-audit/~overview/~insights';
import { Route as ConsoleOrgIdToolsComplianceAuditOverviewSearchRouteRouteImport } from './../src/routes/~console.$orgId/~tools/~compliance-audit/~overview/~search/~route';
import { Route as ConsoleOrgIdToolsWebsiteCheckerReportIdRouteRouteImport } from './../src/routes/~console.$orgId/~tools/~website-checker/~report.$id/~route';
import { Route as ConsoleOrgIdWorkloadManagerTasksCalendarAddRouteImport } from './../src/routes/~console.$orgId/~workload-manager/~tasks/~calendar/~add';
import { Route as ConsoleOrgIdWorkloadManagerTasksListAddRouteImport } from './../src/routes/~console.$orgId/~workload-manager/~tasks/~list/~add';
import { Route as PublicClaimLodgementOrgIdPdsVersionIdQuestionnaireIdProductTypeIdRouteRouteImport } from './../src/routes/~public/~claim-lodgement.$orgId.$pdsVersionId.$questionnaireId.$productTypeId/~route';
import { Route as ConsoleOrgIdAttestationsRoundsRoundIdPeopleUserIdRouteImport } from './../src/routes/~console.$orgId/~attestations/~rounds/~$roundId/~people.$userId';
import { Route as ConsoleOrgIdClaimsDetailsIdContactsAddRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~contacts/~add';
import { Route as ConsoleOrgIdClaimsDetailsIdExpensesAddRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~expenses/~add';
import { Route as ConsoleOrgIdComplianceCoiDetailsIdIndexRouteImport } from './../src/routes/~console.$orgId/~compliance/~coi/~details.$id/~index';
import { Route as ConsoleOrgIdComplianceCoiDetailsIdLibraryRouteImport } from './../src/routes/~console.$orgId/~compliance/~coi/~details.$id/~library';
import { Route as ConsoleOrgIdComplianceCoiDetailsIdManageRouteImport } from './../src/routes/~console.$orgId/~compliance/~coi/~details.$id/~manage';
import { Route as ConsoleOrgIdComplianceComplaintsDetailsIdIndexRouteImport } from './../src/routes/~console.$orgId/~compliance/~complaints/~details.$id/~index';
import { Route as ConsoleOrgIdComplianceComplaintsDetailsIdCommsRouteRouteImport } from './../src/routes/~console.$orgId/~compliance/~complaints/~details.$id/~comms/~route';
import { Route as ConsoleOrgIdComplianceComplaintsDetailsIdHistoryRouteRouteImport } from './../src/routes/~console.$orgId/~compliance/~complaints/~details.$id/~history/~route';
import { Route as ConsoleOrgIdComplianceComplaintsDetailsIdLibraryRouteRouteImport } from './../src/routes/~console.$orgId/~compliance/~complaints/~details.$id/~library/~route';
import { Route as ConsoleOrgIdComplianceComplaintsDetailsIdManageRouteRouteImport } from './../src/routes/~console.$orgId/~compliance/~complaints/~details.$id/~manage/~route';
import { Route as ConsoleOrgIdComplianceIncidentsDetailsIdIndexRouteImport } from './../src/routes/~console.$orgId/~compliance/~incidents/~details.$id/~index';
import { Route as ConsoleOrgIdComplianceIncidentsDetailsIdHistoryRouteRouteImport } from './../src/routes/~console.$orgId/~compliance/~incidents/~details.$id/~history/~route';
import { Route as ConsoleOrgIdComplianceIncidentsDetailsIdLibraryRouteRouteImport } from './../src/routes/~console.$orgId/~compliance/~incidents/~details.$id/~library/~route';
import { Route as ConsoleOrgIdComplianceIncidentsDetailsIdManageRouteRouteImport } from './../src/routes/~console.$orgId/~compliance/~incidents/~details.$id/~manage/~route';
import { Route as ConsoleOrgIdComplianceObligationsDetailsIdDebugRouteImport } from './../src/routes/~console.$orgId/~compliance/~obligations/~details.$id/~debug';
import { Route as ConsoleOrgIdComplianceObligationsDetailsIdManageRouteImport } from './../src/routes/~console.$orgId/~compliance/~obligations/~details.$id/~manage';
import { Route as ConsoleOrgIdComplianceRegistersRegisterIdRecordsRecordIdRouteImport } from './../src/routes/~console.$orgId/~compliance/~registers/~$registerId/~records.$recordId';
import { Route as ConsoleOrgIdComplianceTrainingUserUserIdAddRouteImport } from './../src/routes/~console.$orgId/~compliance/~training/~user.$userId/~add';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsAddRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~claims/~catastrophe-events/~add';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsAddRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~claims/~claim-flags/~add';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsIndexRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~claims/~task-lists/~index';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~claims/~task-lists/~search/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsContactRolesEditContactRoleIdRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~contact-roles/~edit.$contactRoleId';
import { Route as ConsoleOrgIdConfigurationClaimsProductsFormsFormDefinitionIdIndexRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~forms/~$formDefinitionId/~index';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdAddRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~product-types/~$productTypeId/~add';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~product-types/~$productTypeId/~decision-engine/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~product-types/~edit.$productTypeId/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~product-types/~financials.$id/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesStatesIdRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~product-types/~states.$id/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~products-v2/~details.$productId/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductsV2EditProductIdRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~products-v2/~edit.$productId';
import { Route as ConsoleOrgIdConfigurationClaimsProductsQuestionnaireEditQuestionnaireIdRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~questionnaire/~edit.$questionnaireId';
import { Route as ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsAddRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~attestations/~user-attestations/~add';
import { Route as ConsoleOrgIdConfigurationComplianceComplaintsFlagsAddRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~complaints/~flags/~add';
import { Route as ConsoleOrgIdConfigurationComplianceComplaintsGeneralIndexRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~complaints/~general/~index';
import { Route as ConsoleOrgIdConfigurationComplianceComplaintsGeneralLodgementRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~complaints/~general/~lodgement';
import { Route as ConsoleOrgIdConfigurationComplianceComplaintsGeneralTimelineRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~complaints/~general/~timeline/~route';
import { Route as ConsoleOrgIdConfigurationComplianceIncidentsFlagsAddRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~incidents/~flags/~add';
import { Route as ConsoleOrgIdConfigurationComplianceIncidentsGeneralIndexRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~incidents/~general/~index';
import { Route as ConsoleOrgIdConfigurationComplianceIncidentsGeneralIncidentDetailsRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~incidents/~general/~incident-details';
import { Route as ConsoleOrgIdConfigurationComplianceIncidentsGeneralLodgementRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~incidents/~general/~lodgement';
import { Route as ConsoleOrgIdConfigurationComplianceIncidentsGeneralRectificationRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~incidents/~general/~rectification';
import { Route as ConsoleOrgIdConfigurationComplianceIncidentsGeneralTimelineRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~incidents/~general/~timeline/~route';
import { Route as ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigAddRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~mspr/~governance-config/~add';
import { Route as ConsoleOrgIdConfigurationFinancialsBillingPaymentSuccessRouteImport } from './../src/routes/~console.$orgId/~configuration/~financials/~billing/~payment.success';
import { Route as ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~fleet/~client-database/~details.$id/~route';
import { Route as ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesAddRouteImport } from './../src/routes/~console.$orgId/~configuration/~org-settings/~communication/~comm-signatures/~add';
import { Route as ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesAddRouteImport } from './../src/routes/~console.$orgId/~configuration/~org-settings/~communication/~comm-templates/~add';
import { Route as ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesDetailsIdRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~org-settings/~handling-parties/~details.$id/~route';
import { Route as ConsoleOrgIdConfigurationOrgSettingsUsersDetailsUserIdRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~org-settings/~users/~details.$userId/~route';
import { Route as ConsoleOrgIdConfigurationVendorManagementRepairNetworksDetailsIdRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~vendor-management/~repair-networks/~details.$id/~route';
import { Route as ConsoleOrgIdConfigurationVendorManagementSuppliersListIndexRouteImport } from './../src/routes/~console.$orgId/~configuration/~vendor-management/~suppliers/~list/~index';
import { Route as ConsoleOrgIdConfigurationVendorManagementSuppliersSearchIndexRouteImport } from './../src/routes/~console.$orgId/~configuration/~vendor-management/~suppliers/~search/~index';
import { Route as ConsoleOrgIdConfigurationVendorManagementSuppliersSearchDefinitionsRouteImport } from './../src/routes/~console.$orgId/~configuration/~vendor-management/~suppliers/~search/~definitions';
import { Route as ConsoleOrgIdConfigurationVendorManagementSuppliersSearchListRouteImport } from './../src/routes/~console.$orgId/~configuration/~vendor-management/~suppliers/~search/~list';
import { Route as ConsoleOrgIdMsprServiceProvidersDetailsIdHistoryRouteRouteImport } from './../src/routes/~console.$orgId/~mspr/~service-providers/~details.$id/~history/~route';
import { Route as ConsoleOrgIdMsprServiceProvidersDetailsIdLibraryRouteRouteImport } from './../src/routes/~console.$orgId/~mspr/~service-providers/~details.$id/~library/~route';
import { Route as ConsoleOrgIdMsprServiceProvidersDetailsIdManageRouteRouteImport } from './../src/routes/~console.$orgId/~mspr/~service-providers/~details.$id/~manage/~route';
import { Route as ConsoleOrgIdRiskRegisterDetailsIdActionPlanRouteRouteImport } from './../src/routes/~console.$orgId/~risk/~register/~details.$id/~action-plan/~route';
import { Route as ConsoleOrgIdRiskRegisterDetailsIdAssessmentRouteRouteImport } from './../src/routes/~console.$orgId/~risk/~register/~details.$id/~assessment/~route';
import { Route as ConsoleOrgIdRiskRegisterDetailsIdHistoryRouteImport } from './../src/routes/~console.$orgId/~risk/~register/~details.$id/~history';
import { Route as ConsoleOrgIdToolsAutoDetectInboxIdReviewEmailClassificationRouteImport } from './../src/routes/~console.$orgId/~tools/~auto-detect/~inbox/~$id/~review-email-classification';
import { Route as ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdFindDocumentsRouteImport } from './../src/routes/~console.$orgId/~tools/~compliance-audit/~details.$complianceAuditId.find-documents';
import { Route as ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdStatisticsRouteImport } from './../src/routes/~console.$orgId/~tools/~compliance-audit/~details.$complianceAuditId.statistics';
import { Route as ConsoleOrgIdToolsComplianceAuditOverviewSearchAddRouteImport } from './../src/routes/~console.$orgId/~tools/~compliance-audit/~overview/~search/~add';
import { Route as ConsoleOrgIdToolsDocumentAnalyzerHistoryIdResultsRouteImport } from './../src/routes/~console.$orgId/~tools/~document-analyzer/~history/~$id/~results';
import { Route as ConsoleOrgIdToolsPdsComparePdsDocumentsEditIdRouteImport } from './../src/routes/~console.$orgId/~tools/~pds-compare/~pds-documents/~edit.$id';
import { Route as ConsoleOrgIdWorkloadManagerTasksCalendarDetailsIdRouteImport } from './../src/routes/~console.$orgId/~workload-manager/~tasks/~calendar/~details.$id';
import { Route as ConsoleOrgIdWorkloadManagerTasksListDetailsIdRouteImport } from './../src/routes/~console.$orgId/~workload-manager/~tasks/~list/~details.$id';
import { Route as PublicOrgIdClaimLodgementLookupPdsVersionIdQuestionnaireIdProductTypeIdRouteRouteImport } from './../src/routes/~public/~$orgId/~claim.lodgement-lookup.$pdsVersionId.$questionnaireId.$productTypeId/~route';
import { Route as PublicOrgIdClaimLodgementPdsVersionIdQuestionnaireIdProductTypeIdRouteRouteImport } from './../src/routes/~public/~$orgId/~claim.lodgement.$pdsVersionId.$questionnaireId.$productTypeId/~route';
import { Route as ConsoleOrgIdClaimsDetailsIdActivityAddPhoneRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~activity/~add.phone';
import { Route as ConsoleOrgIdClaimsDetailsIdCommsMessageMessageIdRouteRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~comms/~message.$messageId/~route';
import { Route as ConsoleOrgIdClaimsDetailsIdCommsReplyMessageIdRouteRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~comms/~reply.$messageId/~route';
import { Route as ConsoleOrgIdClaimsDetailsIdContactsEditContactIdRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~contacts/~edit.$contactId';
import { Route as ConsoleOrgIdClaimsDetailsIdExpensesEditExpenseItemIdRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~expenses/~edit.$expenseItemId';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddRouteRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~financials/~compensations/~add/~route';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsExcessesAddRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~financials/~excesses/~add';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsPaymentsCompensationIdRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~financials/~payments.$compensationId';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsPaymentsAddRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~financials/~payments.add';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsReserveChangesRequestIdRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~financials/~reserve-changes.$requestId';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsReservesAddRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~financials/~reserves/~add';
import { Route as ConsoleOrgIdClaimsDetailsIdLibraryPaymentsCompensationIdRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~library/~payments.$compensationId';
import { Route as ConsoleOrgIdClaimsDetailsIdManageStrategiesAddRouteRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~manage/~strategies.add/~route';
import { Route as ConsoleOrgIdClaimsDetailsIdManageSupplierJobsAddRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~manage/~supplier-jobs/~add';
import { Route as ConsoleOrgIdClaimsDetailsIdManageSupplierJobsAddSupplierRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~manage/~supplier-jobs/~add-supplier';
import { Route as ConsoleOrgIdClaimsDetailsIdVehicleReportInspectionIdRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~vehicle/~report.$inspectionId';
import { Route as ConsoleOrgIdComplianceComplaintsDetailsIdManageIncidentsRouteImport } from './../src/routes/~console.$orgId/~compliance/~complaints/~details.$id/~manage/~incidents';
import { Route as ConsoleOrgIdComplianceIncidentsDetailsIdManageComplaintsRouteImport } from './../src/routes/~console.$orgId/~compliance/~incidents/~details.$id/~manage/~complaints';
import { Route as ConsoleOrgIdComplianceTrainingUserUserIdEditRecordIdRouteImport } from './../src/routes/~console.$orgId/~compliance/~training/~user.$userId/~edit.$recordId';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsEditCatastropheEventIdRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~claims/~catastrophe-events/~edit.$catastropheEventId';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsEditClaimFlagIdRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~claims/~claim-flags/~edit.$claimFlagId';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsClaimsAuthorityInsurerLimitsAddRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~claims/~claims-authority/~insurer-limits.add';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsClaimsAuthorityLevelsAddRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~claims/~claims-authority/~levels.add';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralClaimStatusesAddRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~claims/~general/~claim-statuses/~add';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchAddRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~claims/~task-lists/~search/~add';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineConditionsRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~product-types/~$productTypeId/~decision-engine/~conditions';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineExclusionsRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~product-types/~$productTypeId/~decision-engine/~exclusions';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineGuideRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~product-types/~$productTypeId/~decision-engine/~guide';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineLimitsExcessesRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~product-types/~$productTypeId/~decision-engine/~limits-excesses';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineLossCausesRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~product-types/~$productTypeId/~decision-engine/~loss-causes';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineOverviewRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~product-types/~$productTypeId/~decision-engine/~overview';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEnginePolicyTriggerMappingRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~product-types/~$productTypeId/~decision-engine/~policy-trigger-mapping';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineProductInfoRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~product-types/~$productTypeId/~decision-engine/~product-info';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRedFlagsRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~product-types/~$productTypeId/~decision-engine/~red-flags';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdEditPdsIdRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~product-types/~$productTypeId/~edit.$pdsId';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdPdsTextPdsIdRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~product-types/~$productTypeId/~pds-text.$pdsId';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdPdsPdsIdRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~product-types/~$productTypeId/~pds.$pdsId/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdDataFieldsRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~product-types/~edit.$productTypeId/~data-fields';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdPolicyFieldsRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~product-types/~edit.$productTypeId/~policy-fields';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~product-types/~edit.$productTypeId/~third-party-contact-type/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdCostCodesRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~product-types/~financials.$id/~cost-codes';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdSectionsRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~product-types/~financials.$id/~sections';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTaxRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~product-types/~financials.$id/~tax';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~product-types/~financials.$id/~transaction-types/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdLodgementLinksRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~products-v2/~details.$productId/~lodgement-links/~route';
import { Route as ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsEditIdRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~attestations/~user-attestations/~edit.$id/~route';
import { Route as ConsoleOrgIdConfigurationComplianceComplaintsFlagsEditComplaintFlagIdRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~complaints/~flags/~edit.$complaintFlagId';
import { Route as ConsoleOrgIdConfigurationComplianceIncidentsFlagsEditIncidentFlagIdRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~incidents/~flags/~edit.$incidentFlagId';
import { Route as ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsIdentifiedAddRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~mspr/~critical-operations/~identified/~add';
import { Route as ConsoleOrgIdConfigurationComplianceMsprDefinitionsCategoriesAddRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~mspr/~definitions/~categories/~add';
import { Route as ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigEditIdRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~mspr/~governance-config/~edit.$id';
import { Route as ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdClientsRouteImport } from './../src/routes/~console.$orgId/~configuration/~fleet/~client-database/~details.$id/~clients';
import { Route as ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdDriversRouteImport } from './../src/routes/~console.$orgId/~configuration/~fleet/~client-database/~details.$id/~drivers';
import { Route as ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdHistoryRouteImport } from './../src/routes/~console.$orgId/~configuration/~fleet/~client-database/~details.$id/~history';
import { Route as ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdOverviewRouteImport } from './../src/routes/~console.$orgId/~configuration/~fleet/~client-database/~details.$id/~overview';
import { Route as ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdPortalAccessRouteImport } from './../src/routes/~console.$orgId/~configuration/~fleet/~client-database/~details.$id/~portal-access';
import { Route as ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRepairersRouteImport } from './../src/routes/~console.$orgId/~configuration/~fleet/~client-database/~details.$id/~repairers';
import { Route as ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdVehiclesRouteImport } from './../src/routes/~console.$orgId/~configuration/~fleet/~client-database/~details.$id/~vehicles';
import { Route as ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesEditCommSignatureIdRouteImport } from './../src/routes/~console.$orgId/~configuration/~org-settings/~communication/~comm-signatures/~edit.$commSignatureId';
import { Route as ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesEditCommunicationTemplateIdRouteImport } from './../src/routes/~console.$orgId/~configuration/~org-settings/~communication/~comm-templates/~edit.$communicationTemplateId';
import { Route as ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesDetailsIdUsersRouteImport } from './../src/routes/~console.$orgId/~configuration/~org-settings/~handling-parties/~details.$id/~users';
import { Route as ConsoleOrgIdConfigurationVendorManagementRepairNetworksDetailsIdClientsRouteImport } from './../src/routes/~console.$orgId/~configuration/~vendor-management/~repair-networks/~details.$id/~clients';
import { Route as ConsoleOrgIdConfigurationVendorManagementRepairNetworksDetailsIdMembersRouteImport } from './../src/routes/~console.$orgId/~configuration/~vendor-management/~repair-networks/~details.$id/~members';
import { Route as ConsoleOrgIdConfigurationVendorManagementRepairNetworksDetailsIdOverviewRouteImport } from './../src/routes/~console.$orgId/~configuration/~vendor-management/~repair-networks/~details.$id/~overview';
import { Route as ConsoleOrgIdConfigurationVendorManagementSuppliersDetailsIdIndexRouteImport } from './../src/routes/~console.$orgId/~configuration/~vendor-management/~suppliers/~details.$id/~index';
import { Route as ConsoleOrgIdConfigurationVendorManagementSuppliersDetailsIdSplatRouteImport } from './../src/routes/~console.$orgId/~configuration/~vendor-management/~suppliers/~details.$id/~$';
import { Route as ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~vendor-management/~suppliers/~list/~details.$id/~route';
import { Route as ConsoleOrgIdControlsRegisterDetailsIdActivityActivityIdRouteRouteImport } from './../src/routes/~console.$orgId/~controls/~register/~details.$id/~activity.$activityId/~route';
import { Route as ConsoleOrgIdControlsRegisterDetailsIdActivityAddRouteRouteImport } from './../src/routes/~console.$orgId/~controls/~register/~details.$id/~activity.add/~route';
import { Route as ConsoleOrgIdControlsRegisterDetailsIdTestTestIdRouteRouteImport } from './../src/routes/~console.$orgId/~controls/~register/~details.$id/~test.$testId/~route';
import { Route as ConsoleOrgIdControlsRegisterDetailsIdTestAddRouteRouteImport } from './../src/routes/~console.$orgId/~controls/~register/~details.$id/~test.add/~route';
import { Route as ConsoleOrgIdMsprServiceProvidersDetailsIdManageAddRouteImport } from './../src/routes/~console.$orgId/~mspr/~service-providers/~details.$id/~manage/~add';
import { Route as ConsoleOrgIdRiskRegisterDetailsIdAssessmentIncidentsRouteImport } from './../src/routes/~console.$orgId/~risk/~register/~details.$id/~assessment/~incidents';
import { Route as ConsoleOrgIdWorkloadManagerTasksCalendarDetailsControl_activityIdRouteImport } from './../src/routes/~console.$orgId/~workload-manager/~tasks/~calendar/~details.control_activity.$id';
import { Route as ConsoleOrgIdWorkloadManagerTasksCalendarDetailsControl_testIdRouteImport } from './../src/routes/~console.$orgId/~workload-manager/~tasks/~calendar/~details.control_test.$id';
import { Route as ConsoleOrgIdWorkloadManagerTasksCalendarDetailsMsp_governance_checkIdRouteImport } from './../src/routes/~console.$orgId/~workload-manager/~tasks/~calendar/~details.msp_governance_check.$id';
import { Route as ConsoleOrgIdWorkloadManagerTasksCalendarDetailsRisk_actionIdRouteImport } from './../src/routes/~console.$orgId/~workload-manager/~tasks/~calendar/~details.risk_action.$id';
import { Route as ConsoleOrgIdClaimsDetailsIdActivityEditPhoneCallLogIdRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~activity/~edit.phone.$callLogId';
import { Route as ConsoleOrgIdClaimsDetailsIdContactsSuppliersDetailsSupplierIdRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~contacts/~suppliers/~details.$supplierId';
import { Route as ConsoleOrgIdClaimsDetailsIdContactsSuppliersReassignSupplierIdRouteRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~contacts/~suppliers/~reassign.$supplierId/~route';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdRouteRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~financials/~compensations/~details.$compensationId/~route';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdRouteRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~financials/~excesses/~details.$excessId/~route';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsPaymentsCorrectCompensationIdRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~financials/~payments.correct.$compensationId';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdRouteRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~financials/~reserves/~details.$reserveId/~route';
import { Route as ConsoleOrgIdClaimsDetailsIdManageSupplierJobsEditJobIdRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~manage/~supplier-jobs/~edit.$jobId';
import { Route as ConsoleOrgIdComplianceComplaintsDetailsIdManageNoteAddRouteRouteImport } from './../src/routes/~console.$orgId/~compliance/~complaints/~details.$id/~manage/~note.add/~route';
import { Route as ConsoleOrgIdComplianceIncidentsDetailsIdManageNoteAddRouteRouteImport } from './../src/routes/~console.$orgId/~compliance/~incidents/~details.$id/~manage/~note.add/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsClaimsAuthorityLevelsEditLevelIdRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~claims/~claims-authority/~levels.edit.$levelId';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsClaimsAuthorityPeopleEditUserIdRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~claims/~claims-authority/~people.edit.$userId';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralClaimStatusesEditClaimStatusIdRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~claims/~general/~claim-statuses/~edit.$claimStatusId';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~claims/~task-lists/~search/~$taskListId/~tasks/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchEditIdRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~claims/~task-lists/~search/~edit.$id';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeAddRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~product-types/~edit.$productTypeId/~third-party-contact-type/~add';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesAddRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~product-types/~financials.$id/~transaction-types/~add';
import { Route as ConsoleOrgIdConfigurationComplianceComplaintsGeneralTimelineMilestonesAddRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~complaints/~general/~timeline/~milestones.add';
import { Route as ConsoleOrgIdConfigurationComplianceIncidentsGeneralTimelineMilestonesAddRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~incidents/~general/~timeline/~milestones.add';
import { Route as ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsExcludedEditIdRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~mspr/~critical-operations/~excluded/~edit.$id';
import { Route as ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsIdentifiedEditIdRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~mspr/~critical-operations/~identified/~edit.$id';
import { Route as ConsoleOrgIdConfigurationComplianceMsprDefinitionsCategoriesEditIdRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~mspr/~definitions/~categories/~edit.$id';
import { Route as ConsoleOrgIdMsprServiceProvidersDetailsIdManageCheckCheckIdRouteRouteImport } from './../src/routes/~console.$orgId/~mspr/~service-providers/~details.$id/~manage/~check.$checkId/~route';
import { Route as ConsoleOrgIdMsprServiceProvidersDetailsIdManageCheckAddRouteRouteImport } from './../src/routes/~console.$orgId/~mspr/~service-providers/~details.$id/~manage/~check.add/~route';
import { Route as ConsoleOrgIdMsprServiceProvidersDetailsIdManageEditArrangementIdRouteImport } from './../src/routes/~console.$orgId/~mspr/~service-providers/~details.$id/~manage/~edit.$arrangementId';
import { Route as ConsoleOrgIdRiskRegisterDetailsIdActionPlanActionPlanActionPlanIdRouteRouteImport } from './../src/routes/~console.$orgId/~risk/~register/~details.$id/~action-plan/~action-plan.$actionPlanId/~route';
import { Route as ConsoleOrgIdRiskRegisterDetailsIdActionPlanActionPlanAddRouteRouteImport } from './../src/routes/~console.$orgId/~risk/~register/~details.$id/~action-plan/~action-plan.add/~route';
import { Route as ConsoleOrgIdClaimsDetailsIdContactsSuppliersReassignSupplierIdAddRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~contacts/~suppliers/~reassign.$supplierId/~add';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddCompensationPaymentsAddRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~financials/~compensations/~add/~compensation-payments.add';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddExcessPaymentsAddRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~financials/~compensations/~add/~excess-payments.add';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddSuppliersAddRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~financials/~compensations/~add/~suppliers.add';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsRouteRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~financials/~compensations/~details.$compensationId/~financials/~route';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdLibraryRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~financials/~compensations/~details.$compensationId/~library';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdPayeeRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~financials/~compensations/~details.$compensationId/~payee';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdPaymentRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~financials/~compensations/~details.$compensationId/~payment';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdLibraryRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~financials/~excesses/~details.$excessId/~library';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdManageRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~financials/~excesses/~details.$excessId/~manage';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdPaymentsRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~financials/~excesses/~details.$excessId/~payments';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsPaymentsAddContactsAddRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~financials/~payments.add.contacts.add';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsPaymentsAddSuppliersAddRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~financials/~payments.add.suppliers.add';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdCompensationPaymentsRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~financials/~reserves/~details.$reserveId/~compensation-payments';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdLibraryRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~financials/~reserves/~details.$reserveId/~library';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdReserveAdjustmentsRouteRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~financials/~reserves/~details.$reserveId/~reserve-adjustments/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsClaimsAuthorityInsurerLimitsEditInsurerIdProductTypeIdRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~claims/~claims-authority/~insurer-limits.edit.$insurerId.$productTypeId';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksAddRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~claims/~task-lists/~search/~$taskListId/~tasks/~add';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeEditThirdPartyContactTypeIdRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~product-types/~edit.$productTypeId/~third-party-contact-type/~edit.$thirdPartyContactTypeId';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesEditTransactionTypeIdRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~product-types/~financials.$id/~transaction-types/~edit.$transactionTypeId';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~products-v2/~details.$productId/~product-versions/~details.$productVersionId/~route';
import { Route as ConsoleOrgIdConfigurationComplianceComplaintsGeneralTimelineMilestonesEditInternalNameRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~complaints/~general/~timeline/~milestones.edit.$internalName';
import { Route as ConsoleOrgIdConfigurationComplianceIncidentsGeneralTimelineMilestonesEditInternalNameRouteImport } from './../src/routes/~console.$orgId/~configuration/~compliance/~incidents/~general/~timeline/~milestones.edit.$internalName';
import { Route as ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdContactsAddRouteImport } from './../src/routes/~console.$orgId/~configuration/~vendor-management/~suppliers/~list/~details.$id/~contacts/~add';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdReserveAdjustmentsAddRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~financials/~reserves/~details.$reserveId/~reserve-adjustments/~add';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksEditIdRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~claims/~task-lists/~search/~$taskListId/~tasks/~edit.$id';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesRouteRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~products-v2/~details.$productId/~product-versions/~details.$productVersionId/~contact-types/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdDetailsRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~products-v2/~details.$productId/~product-versions/~details.$productVersionId/~details';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdDocumentsRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~products-v2/~details.$productId/~product-versions/~details.$productVersionId/~documents';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdFieldsRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~products-v2/~details.$productId/~product-versions/~details.$productVersionId/~fields';
import { Route as ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdContactsEditContactIdRouteImport } from './../src/routes/~console.$orgId/~configuration/~vendor-management/~suppliers/~list/~details.$id/~contacts/~edit.$contactId';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesAddRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~products-v2/~details.$productId/~product-versions/~details.$productVersionId/~contact-types/~add';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsCompensationPaymentsDetailsCompensationPaymentIdRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~financials/~compensations/~details.$compensationId/~financials/~compensation-payments.details.$compensationPaymentId';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsExcessPaymentsDetailsExcessPaymentIdRouteImport } from './../src/routes/~console.$orgId/~claims/~details.$id/~financials/~compensations/~details.$compensationId/~financials/~excess-payments.details.$excessPaymentId';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesEditContactTypeIdRouteImport } from './../src/routes/~console.$orgId/~configuration/~claims-products/~products-v2/~details.$productId/~product-versions/~details.$productVersionId/~contact-types/~edit.$contactTypeId';

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
});
const AdminConsentRoute = AdminConsentRouteImport.update({
  id: '/admin-consent',
  path: '/admin-consent',
  getParentRoute: () => rootRouteImport,
});
const AttestationRouteRoute = AttestationRouteRouteImport.update({
  id: '/attestation',
  path: '/attestation',
  getParentRoute: () => rootRouteImport,
});
const InviteRouteRoute = InviteRouteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => rootRouteImport,
});
const LodgeRouteRoute = LodgeRouteRouteImport.update({
  id: '/lodge',
  path: '/lodge',
  getParentRoute: () => rootRouteImport,
});
const MaintenanceRoute = MaintenanceRouteImport.update({
  id: '/maintenance',
  path: '/maintenance',
  getParentRoute: () => rootRouteImport,
});
const NotFoundRoute = NotFoundRouteImport.update({
  id: '/not-found',
  path: '/not-found',
  getParentRoute: () => rootRouteImport,
});
const NotSupportedRoute = NotSupportedRouteImport.update({
  id: '/not-supported',
  path: '/not-supported',
  getParentRoute: () => rootRouteImport,
});
const OauthRouteRoute = OauthRouteRouteImport.update({
  id: '/oauth',
  path: '/oauth',
  getParentRoute: () => rootRouteImport,
});
const OrgSwitchedRoute = OrgSwitchedRouteImport.update({
  id: '/org-switched',
  path: '/org-switched',
  getParentRoute: () => rootRouteImport,
});
const PublicRouteRoute = PublicRouteRouteImport.update({
  id: '/public',
  path: '/public',
  getParentRoute: () => rootRouteImport,
});
const StatusRoute = StatusRouteImport.update({
  id: '/status',
  path: '/status',
  getParentRoute: () => rootRouteImport,
});
const TermsAcceptanceRouteRoute = TermsAcceptanceRouteRouteImport.update({
  id: '/terms-acceptance',
  path: '/terms-acceptance',
  getParentRoute: () => rootRouteImport,
});
const authenticationAdminLoginRoute =
  authenticationAdminLoginRouteImport.update({
    id: '/(authentication)/admin-login',
    path: '/admin-login',
    getParentRoute: () => rootRouteImport,
  });
const authenticationCallbackRoute = authenticationCallbackRouteImport.update({
  id: '/(authentication)/callback',
  path: '/callback',
  getParentRoute: () => rootRouteImport,
});
const authenticationLoginRoute = authenticationLoginRouteImport.update({
  id: '/(authentication)/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
});
const authenticationLogoutRoute = authenticationLogoutRouteImport.update({
  id: '/(authentication)/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
});
const authenticationLogoutinRoute = authenticationLogoutinRouteImport.update({
  id: '/(authentication)/logoutin',
  path: '/logoutin',
  getParentRoute: () => rootRouteImport,
});
const authenticationOrgMismatchRoute =
  authenticationOrgMismatchRouteImport.update({
    id: '/(authentication)/org-mismatch',
    path: '/org-mismatch',
    getParentRoute: () => rootRouteImport,
  });
const authenticationPaymentPendingRoute =
  authenticationPaymentPendingRouteImport.update({
    id: '/(authentication)/payment-pending',
    path: '/payment-pending',
    getParentRoute: () => rootRouteImport,
  });
const authenticationTrialExpiredRoute =
  authenticationTrialExpiredRouteImport.update({
    id: '/(authentication)/trial-expired',
    path: '/trial-expired',
    getParentRoute: () => rootRouteImport,
  });
const AttestationTokenRoute = AttestationTokenRouteImport.update({
  id: '/$token',
  path: '/$token',
  getParentRoute: () => AttestationRouteRoute,
});
const ConsoleOrgIdRouteRoute = ConsoleOrgIdRouteRouteImport.update({
  id: '/console/$orgId',
  path: '/console/$orgId',
  getParentRoute: () => rootRouteImport,
});
const DocumentSourcesConsentRoute = DocumentSourcesConsentRouteImport.update({
  id: '/document-sources/consent',
  path: '/document-sources/consent',
  getParentRoute: () => rootRouteImport,
});
const LodgeKeyRouteRoute = LodgeKeyRouteRouteImport.update({
  id: '/$key',
  path: '/$key',
  getParentRoute: () => LodgeRouteRoute,
});
const OauthAuthorizeRoute = OauthAuthorizeRouteImport.update({
  id: '/authorize',
  path: '/authorize',
  getParentRoute: () => OauthRouteRoute,
});
const PasswordResetRequestRoute = PasswordResetRequestRouteImport.update({
  id: '/password-reset/request',
  path: '/password-reset/request',
  getParentRoute: () => rootRouteImport,
});
const PasswordResetResetRoute = PasswordResetResetRouteImport.update({
  id: '/password-reset/reset',
  path: '/password-reset/reset',
  getParentRoute: () => rootRouteImport,
});
const PublicOrgIdRouteRoute = PublicOrgIdRouteRouteImport.update({
  id: '/$orgId',
  path: '/$orgId',
  getParentRoute: () => PublicRouteRoute,
});
const WhatsNewReleaseIdRoute = WhatsNewReleaseIdRouteImport.update({
  id: '/whats-new/$releaseId',
  path: '/whats-new/$releaseId',
  getParentRoute: () => rootRouteImport,
});
const authenticationChangeOrgOrgIdRoute =
  authenticationChangeOrgOrgIdRouteImport.update({
    id: '/(authentication)/change-org/$orgId',
    path: '/change-org/$orgId',
    getParentRoute: () => rootRouteImport,
  });
const ConsoleOrgIdIndexRoute = ConsoleOrgIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ConsoleOrgIdRouteRoute,
});
const ConsoleOrgIdAttestationsRouteRoute =
  ConsoleOrgIdAttestationsRouteRouteImport.update({
    id: '/attestations',
    path: '/attestations',
    getParentRoute: () => ConsoleOrgIdRouteRoute,
  });
const ConsoleOrgIdClaimsRouteRoute = ConsoleOrgIdClaimsRouteRouteImport.update({
  id: '/claims',
  path: '/claims',
  getParentRoute: () => ConsoleOrgIdRouteRoute,
});
const ConsoleOrgIdComplianceRouteRoute =
  ConsoleOrgIdComplianceRouteRouteImport.update({
    id: '/compliance',
    path: '/compliance',
    getParentRoute: () => ConsoleOrgIdRouteRoute,
  });
const ConsoleOrgIdComponentShowcaseRouteRoute =
  ConsoleOrgIdComponentShowcaseRouteRouteImport.update({
    id: '/component-showcase',
    path: '/component-showcase',
    getParentRoute: () => ConsoleOrgIdRouteRoute,
  });
const ConsoleOrgIdConfigurationRouteRoute =
  ConsoleOrgIdConfigurationRouteRouteImport.update({
    id: '/configuration',
    path: '/configuration',
    getParentRoute: () => ConsoleOrgIdRouteRoute,
  });
const ConsoleOrgIdControlsRouteRoute =
  ConsoleOrgIdControlsRouteRouteImport.update({
    id: '/controls',
    path: '/controls',
    getParentRoute: () => ConsoleOrgIdRouteRoute,
  });
const ConsoleOrgIdDashboardRouteRoute =
  ConsoleOrgIdDashboardRouteRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => ConsoleOrgIdRouteRoute,
  });
const ConsoleOrgIdDocumentsRouteRoute =
  ConsoleOrgIdDocumentsRouteRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => ConsoleOrgIdRouteRoute,
  });
const ConsoleOrgIdFaqRouteRoute = ConsoleOrgIdFaqRouteRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => ConsoleOrgIdRouteRoute,
});
const ConsoleOrgIdFleetPortalRouteRoute =
  ConsoleOrgIdFleetPortalRouteRouteImport.update({
    id: '/fleet-portal',
    path: '/fleet-portal',
    getParentRoute: () => ConsoleOrgIdRouteRoute,
  });
const ConsoleOrgIdGetFileRouteRoute =
  ConsoleOrgIdGetFileRouteRouteImport.update({
    id: '/get-file',
    path: '/get-file',
    getParentRoute: () => ConsoleOrgIdRouteRoute,
  });
const ConsoleOrgIdMsprRouteRoute = ConsoleOrgIdMsprRouteRouteImport.update({
  id: '/mspr',
  path: '/mspr',
  getParentRoute: () => ConsoleOrgIdRouteRoute,
});
const ConsoleOrgIdReportingRouteRoute =
  ConsoleOrgIdReportingRouteRouteImport.update({
    id: '/reporting',
    path: '/reporting',
    getParentRoute: () => ConsoleOrgIdRouteRoute,
  });
const ConsoleOrgIdRiskRouteRoute = ConsoleOrgIdRiskRouteRouteImport.update({
  id: '/risk',
  path: '/risk',
  getParentRoute: () => ConsoleOrgIdRouteRoute,
});
const ConsoleOrgIdToolsRouteRoute = ConsoleOrgIdToolsRouteRouteImport.update({
  id: '/tools',
  path: '/tools',
  getParentRoute: () => ConsoleOrgIdRouteRoute,
});
const ConsoleOrgIdToolsOnlyHomePageRoute =
  ConsoleOrgIdToolsOnlyHomePageRouteImport.update({
    id: '/tools-only-home-page',
    path: '/tools-only-home-page',
    getParentRoute: () => ConsoleOrgIdRouteRoute,
  });
const ConsoleOrgIdUserSettingsRouteRoute =
  ConsoleOrgIdUserSettingsRouteRouteImport.update({
    id: '/user-settings',
    path: '/user-settings',
    getParentRoute: () => ConsoleOrgIdRouteRoute,
  });
const ConsoleOrgIdWorkloadManagerRouteRoute =
  ConsoleOrgIdWorkloadManagerRouteRouteImport.update({
    id: '/workload-manager',
    path: '/workload-manager',
    getParentRoute: () => ConsoleOrgIdRouteRoute,
  });
const LodgeResumePublicIdRouteRoute =
  LodgeResumePublicIdRouteRouteImport.update({
    id: '/resume/$publicId',
    path: '/resume/$publicId',
    getParentRoute: () => LodgeRouteRoute,
  });
const LodgeSummaryPublicIdRouteRoute =
  LodgeSummaryPublicIdRouteRouteImport.update({
    id: '/summary/$publicId',
    path: '/summary/$publicId',
    getParentRoute: () => LodgeRouteRoute,
  });
const PublicLodgementSummaryAccessKeyRouteRoute =
  PublicLodgementSummaryAccessKeyRouteRouteImport.update({
    id: '/lodgement-summary/$accessKey',
    path: '/lodgement-summary/$accessKey',
    getParentRoute: () => PublicRouteRoute,
  });
const PublicNewComplaintByKeyKeyRouteRoute =
  PublicNewComplaintByKeyKeyRouteRouteImport.update({
    id: '/new-complaint-by-key/$key',
    path: '/new-complaint-by-key/$key',
    getParentRoute: () => PublicRouteRoute,
  });
const PublicNewComplaintOrgIdRouteRoute =
  PublicNewComplaintOrgIdRouteRouteImport.update({
    id: '/new-complaint/$orgId',
    path: '/new-complaint/$orgId',
    getParentRoute: () => PublicRouteRoute,
  });
const ConsoleOrgIdAttestationsIndexRoute =
  ConsoleOrgIdAttestationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdAttestationsRouteRoute,
  });
const ConsoleOrgIdAttestationsOverviewRouteRoute =
  ConsoleOrgIdAttestationsOverviewRouteRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => ConsoleOrgIdAttestationsRouteRoute,
  });
const ConsoleOrgIdAttestationsScheduledAttestationsRouteRoute =
  ConsoleOrgIdAttestationsScheduledAttestationsRouteRouteImport.update({
    id: '/scheduled-attestations',
    path: '/scheduled-attestations',
    getParentRoute: () => ConsoleOrgIdAttestationsRouteRoute,
  });
const ConsoleOrgIdAttestationsUserAttestationsRouteRoute =
  ConsoleOrgIdAttestationsUserAttestationsRouteRouteImport.update({
    id: '/user-attestations',
    path: '/user-attestations',
    getParentRoute: () => ConsoleOrgIdAttestationsRouteRoute,
  });
const ConsoleOrgIdClaimsIndexRoute = ConsoleOrgIdClaimsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ConsoleOrgIdClaimsRouteRoute,
});
const ConsoleOrgIdClaimsLodgeFromDocumentsRoute =
  ConsoleOrgIdClaimsLodgeFromDocumentsRouteImport.update({
    id: '/lodge-from-documents',
    path: '/lodge-from-documents',
    getParentRoute: () => ConsoleOrgIdClaimsRouteRoute,
  });
const ConsoleOrgIdClaimsLodgementsRouteRoute =
  ConsoleOrgIdClaimsLodgementsRouteRouteImport.update({
    id: '/lodgements',
    path: '/lodgements',
    getParentRoute: () => ConsoleOrgIdClaimsRouteRoute,
  });
const ConsoleOrgIdComplianceIndexRoute =
  ConsoleOrgIdComplianceIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdComplianceRouteRoute,
  });
const ConsoleOrgIdComplianceCoiRouteRoute =
  ConsoleOrgIdComplianceCoiRouteRouteImport.update({
    id: '/coi',
    path: '/coi',
    getParentRoute: () => ConsoleOrgIdComplianceRouteRoute,
  });
const ConsoleOrgIdComplianceComplaintsRouteRoute =
  ConsoleOrgIdComplianceComplaintsRouteRouteImport.update({
    id: '/complaints',
    path: '/complaints',
    getParentRoute: () => ConsoleOrgIdComplianceRouteRoute,
  });
const ConsoleOrgIdComplianceIncidentsRouteRoute =
  ConsoleOrgIdComplianceIncidentsRouteRouteImport.update({
    id: '/incidents',
    path: '/incidents',
    getParentRoute: () => ConsoleOrgIdComplianceRouteRoute,
  });
const ConsoleOrgIdComplianceIntakeRouteRoute =
  ConsoleOrgIdComplianceIntakeRouteRouteImport.update({
    id: '/intake',
    path: '/intake',
    getParentRoute: () => ConsoleOrgIdComplianceRouteRoute,
  });
const ConsoleOrgIdComplianceObligationsRouteRoute =
  ConsoleOrgIdComplianceObligationsRouteRouteImport.update({
    id: '/obligations',
    path: '/obligations',
    getParentRoute: () => ConsoleOrgIdComplianceRouteRoute,
  });
const ConsoleOrgIdComplianceRegistersRouteRoute =
  ConsoleOrgIdComplianceRegistersRouteRouteImport.update({
    id: '/registers',
    path: '/registers',
    getParentRoute: () => ConsoleOrgIdComplianceRouteRoute,
  });
const ConsoleOrgIdComplianceTrainingRouteRoute =
  ConsoleOrgIdComplianceTrainingRouteRouteImport.update({
    id: '/training',
    path: '/training',
    getParentRoute: () => ConsoleOrgIdComplianceRouteRoute,
  });
const ConsoleOrgIdComponentShowcaseIndexRoute =
  ConsoleOrgIdComponentShowcaseIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdComponentShowcaseRouteRoute,
  });
const ConsoleOrgIdComponentShowcaseAiChatTestRoute =
  ConsoleOrgIdComponentShowcaseAiChatTestRouteImport.update({
    id: '/ai-chat-test',
    path: '/ai-chat-test',
    getParentRoute: () => ConsoleOrgIdComponentShowcaseRouteRoute,
  });
const ConsoleOrgIdComponentShowcaseButtonIconTestRoute =
  ConsoleOrgIdComponentShowcaseButtonIconTestRouteImport.update({
    id: '/button-icon-test',
    path: '/button-icon-test',
    getParentRoute: () => ConsoleOrgIdComponentShowcaseRouteRoute,
  });
const ConsoleOrgIdComponentShowcaseButtonVariantsRoute =
  ConsoleOrgIdComponentShowcaseButtonVariantsRouteImport.update({
    id: '/button-variants',
    path: '/button-variants',
    getParentRoute: () => ConsoleOrgIdComponentShowcaseRouteRoute,
  });
const ConsoleOrgIdComponentShowcaseComponentShowcaseRoute =
  ConsoleOrgIdComponentShowcaseComponentShowcaseRouteImport.update({
    id: '/component-showcase',
    path: '/component-showcase',
    getParentRoute: () => ConsoleOrgIdComponentShowcaseRouteRoute,
  });
const ConsoleOrgIdComponentShowcaseDatePickerTestRoute =
  ConsoleOrgIdComponentShowcaseDatePickerTestRouteImport.update({
    id: '/date-picker-test',
    path: '/date-picker-test',
    getParentRoute: () => ConsoleOrgIdComponentShowcaseRouteRoute,
  });
const ConsoleOrgIdComponentShowcaseFitOnPageRoute =
  ConsoleOrgIdComponentShowcaseFitOnPageRouteImport.update({
    id: '/fit-on-page',
    path: '/fit-on-page',
    getParentRoute: () => ConsoleOrgIdComponentShowcaseRouteRoute,
  });
const ConsoleOrgIdComponentShowcaseMarkdownShowcaseRoute =
  ConsoleOrgIdComponentShowcaseMarkdownShowcaseRouteImport.update({
    id: '/markdown-showcase',
    path: '/markdown-showcase',
    getParentRoute: () => ConsoleOrgIdComponentShowcaseRouteRoute,
  });
const ConsoleOrgIdComponentShowcaseTableShowcaseRoute =
  ConsoleOrgIdComponentShowcaseTableShowcaseRouteImport.update({
    id: '/table-showcase',
    path: '/table-showcase',
    getParentRoute: () => ConsoleOrgIdComponentShowcaseRouteRoute,
  });
const ConsoleOrgIdComponentShowcaseTagVariantsRoute =
  ConsoleOrgIdComponentShowcaseTagVariantsRouteImport.update({
    id: '/tag-variants',
    path: '/tag-variants',
    getParentRoute: () => ConsoleOrgIdComponentShowcaseRouteRoute,
  });
const ConsoleOrgIdComponentShowcaseTiptapTestRoute =
  ConsoleOrgIdComponentShowcaseTiptapTestRouteImport.update({
    id: '/tiptap-test',
    path: '/tiptap-test',
    getParentRoute: () => ConsoleOrgIdComponentShowcaseRouteRoute,
  });
const ConsoleOrgIdConfigurationIndexRoute =
  ConsoleOrgIdConfigurationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdConfigurationRouteRoute,
  });
const ConsoleOrgIdConfigurationApiIntegrationsRouteRoute =
  ConsoleOrgIdConfigurationApiIntegrationsRouteRouteImport.update({
    id: '/api-integrations',
    path: '/api-integrations',
    getParentRoute: () => ConsoleOrgIdConfigurationRouteRoute,
  });
const ConsoleOrgIdConfigurationClaimsProductsRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsRouteRouteImport.update({
    id: '/claims-products',
    path: '/claims-products',
    getParentRoute: () => ConsoleOrgIdConfigurationRouteRoute,
  });
const ConsoleOrgIdConfigurationClientDatabaseRoute =
  ConsoleOrgIdConfigurationClientDatabaseRouteImport.update({
    id: '/client-database',
    path: '/client-database',
    getParentRoute: () => ConsoleOrgIdConfigurationRouteRoute,
  });
const ConsoleOrgIdConfigurationComplianceRouteRoute =
  ConsoleOrgIdConfigurationComplianceRouteRouteImport.update({
    id: '/compliance',
    path: '/compliance',
    getParentRoute: () => ConsoleOrgIdConfigurationRouteRoute,
  });
const ConsoleOrgIdConfigurationFinancialsRouteRoute =
  ConsoleOrgIdConfigurationFinancialsRouteRouteImport.update({
    id: '/financials',
    path: '/financials',
    getParentRoute: () => ConsoleOrgIdConfigurationRouteRoute,
  });
const ConsoleOrgIdConfigurationFleetRouteRoute =
  ConsoleOrgIdConfigurationFleetRouteRouteImport.update({
    id: '/fleet',
    path: '/fleet',
    getParentRoute: () => ConsoleOrgIdConfigurationRouteRoute,
  });
const ConsoleOrgIdConfigurationMonitoringRouteRoute =
  ConsoleOrgIdConfigurationMonitoringRouteRouteImport.update({
    id: '/monitoring',
    path: '/monitoring',
    getParentRoute: () => ConsoleOrgIdConfigurationRouteRoute,
  });
const ConsoleOrgIdConfigurationOrgSettingsRouteRoute =
  ConsoleOrgIdConfigurationOrgSettingsRouteRouteImport.update({
    id: '/org-settings',
    path: '/org-settings',
    getParentRoute: () => ConsoleOrgIdConfigurationRouteRoute,
  });
const ConsoleOrgIdConfigurationRiskRouteRoute =
  ConsoleOrgIdConfigurationRiskRouteRouteImport.update({
    id: '/risk',
    path: '/risk',
    getParentRoute: () => ConsoleOrgIdConfigurationRouteRoute,
  });
const ConsoleOrgIdConfigurationVendorManagementRouteRoute =
  ConsoleOrgIdConfigurationVendorManagementRouteRouteImport.update({
    id: '/vendor-management',
    path: '/vendor-management',
    getParentRoute: () => ConsoleOrgIdConfigurationRouteRoute,
  });
const ConsoleOrgIdControlsIndexRoute =
  ConsoleOrgIdControlsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdControlsRouteRoute,
  });
const ConsoleOrgIdControlsActivitiesRouteRoute =
  ConsoleOrgIdControlsActivitiesRouteRouteImport.update({
    id: '/activities',
    path: '/activities',
    getParentRoute: () => ConsoleOrgIdControlsRouteRoute,
  });
const ConsoleOrgIdControlsRegisterRouteRoute =
  ConsoleOrgIdControlsRegisterRouteRouteImport.update({
    id: '/register',
    path: '/register',
    getParentRoute: () => ConsoleOrgIdControlsRouteRoute,
  });
const ConsoleOrgIdControlsTestsRouteRoute =
  ConsoleOrgIdControlsTestsRouteRouteImport.update({
    id: '/tests',
    path: '/tests',
    getParentRoute: () => ConsoleOrgIdControlsRouteRoute,
  });
const ConsoleOrgIdDashboardIndexRoute =
  ConsoleOrgIdDashboardIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdDashboardRouteRoute,
  });
const ConsoleOrgIdDashboardClaimsRoute =
  ConsoleOrgIdDashboardClaimsRouteImport.update({
    id: '/claims',
    path: '/claims',
    getParentRoute: () => ConsoleOrgIdDashboardRouteRoute,
  });
const ConsoleOrgIdDashboardComplaintsRoute =
  ConsoleOrgIdDashboardComplaintsRouteImport.update({
    id: '/complaints',
    path: '/complaints',
    getParentRoute: () => ConsoleOrgIdDashboardRouteRoute,
  });
const ConsoleOrgIdDashboardIncidentsRoute =
  ConsoleOrgIdDashboardIncidentsRouteImport.update({
    id: '/incidents',
    path: '/incidents',
    getParentRoute: () => ConsoleOrgIdDashboardRouteRoute,
  });
const ConsoleOrgIdDashboardManagementRoute =
  ConsoleOrgIdDashboardManagementRouteImport.update({
    id: '/management',
    path: '/management',
    getParentRoute: () => ConsoleOrgIdDashboardRouteRoute,
  });
const ConsoleOrgIdDashboardPeopleAndCultureRoute =
  ConsoleOrgIdDashboardPeopleAndCultureRouteImport.update({
    id: '/people-and-culture',
    path: '/people-and-culture',
    getParentRoute: () => ConsoleOrgIdDashboardRouteRoute,
  });
const ConsoleOrgIdDashboardRisksRoute =
  ConsoleOrgIdDashboardRisksRouteImport.update({
    id: '/risks',
    path: '/risks',
    getParentRoute: () => ConsoleOrgIdDashboardRouteRoute,
  });
const ConsoleOrgIdDebugIndexRoute = ConsoleOrgIdDebugIndexRouteImport.update({
  id: '/debug/',
  path: '/debug/',
  getParentRoute: () => ConsoleOrgIdRouteRoute,
});
const ConsoleOrgIdFleetPortalIndexRoute =
  ConsoleOrgIdFleetPortalIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdFleetPortalRouteRoute,
  });
const ConsoleOrgIdFleetPortalAuthorisationsRoute =
  ConsoleOrgIdFleetPortalAuthorisationsRouteImport.update({
    id: '/authorisations',
    path: '/authorisations',
    getParentRoute: () => ConsoleOrgIdFleetPortalRouteRoute,
  });
const ConsoleOrgIdFleetPortalClaimsRouteRoute =
  ConsoleOrgIdFleetPortalClaimsRouteRouteImport.update({
    id: '/claims',
    path: '/claims',
    getParentRoute: () => ConsoleOrgIdFleetPortalRouteRoute,
  });
const ConsoleOrgIdFleetPortalDashboardRoute =
  ConsoleOrgIdFleetPortalDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => ConsoleOrgIdFleetPortalRouteRoute,
  });
const ConsoleOrgIdFleetPortalFleetRoute =
  ConsoleOrgIdFleetPortalFleetRouteImport.update({
    id: '/fleet',
    path: '/fleet',
    getParentRoute: () => ConsoleOrgIdFleetPortalRouteRoute,
  });
const ConsoleOrgIdFleetPortalReportingRoute =
  ConsoleOrgIdFleetPortalReportingRouteImport.update({
    id: '/reporting',
    path: '/reporting',
    getParentRoute: () => ConsoleOrgIdFleetPortalRouteRoute,
  });
const ConsoleOrgIdFleetPortalSlaRoute =
  ConsoleOrgIdFleetPortalSlaRouteImport.update({
    id: '/sla',
    path: '/sla',
    getParentRoute: () => ConsoleOrgIdFleetPortalRouteRoute,
  });
const ConsoleOrgIdMsprMspExceptionsRouteRoute =
  ConsoleOrgIdMsprMspExceptionsRouteRouteImport.update({
    id: '/msp-exceptions',
    path: '/msp-exceptions',
    getParentRoute: () => ConsoleOrgIdMsprRouteRoute,
  });
const ConsoleOrgIdMsprServiceProvidersRouteRoute =
  ConsoleOrgIdMsprServiceProvidersRouteRouteImport.update({
    id: '/service-providers',
    path: '/service-providers',
    getParentRoute: () => ConsoleOrgIdMsprRouteRoute,
  });
const ConsoleOrgIdReportingAddRoute =
  ConsoleOrgIdReportingAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => ConsoleOrgIdReportingRouteRoute,
  });
const ConsoleOrgIdRiskIndexRoute = ConsoleOrgIdRiskIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ConsoleOrgIdRiskRouteRoute,
});
const ConsoleOrgIdRiskRasRouteRoute =
  ConsoleOrgIdRiskRasRouteRouteImport.update({
    id: '/ras',
    path: '/ras',
    getParentRoute: () => ConsoleOrgIdRiskRouteRoute,
  });
const ConsoleOrgIdRiskRegisterRouteRoute =
  ConsoleOrgIdRiskRegisterRouteRouteImport.update({
    id: '/register',
    path: '/register',
    getParentRoute: () => ConsoleOrgIdRiskRouteRoute,
  });
const ConsoleOrgIdToolsIndexRoute = ConsoleOrgIdToolsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ConsoleOrgIdToolsRouteRoute,
});
const ConsoleOrgIdToolsAutoDetectRouteRoute =
  ConsoleOrgIdToolsAutoDetectRouteRouteImport.update({
    id: '/auto-detect',
    path: '/auto-detect',
    getParentRoute: () => ConsoleOrgIdToolsRouteRoute,
  });
const ConsoleOrgIdToolsComplianceAuditRouteRoute =
  ConsoleOrgIdToolsComplianceAuditRouteRouteImport.update({
    id: '/compliance-audit',
    path: '/compliance-audit',
    getParentRoute: () => ConsoleOrgIdToolsRouteRoute,
  });
const ConsoleOrgIdToolsDocumentAnalyzerRouteRoute =
  ConsoleOrgIdToolsDocumentAnalyzerRouteRouteImport.update({
    id: '/document-analyzer',
    path: '/document-analyzer',
    getParentRoute: () => ConsoleOrgIdToolsRouteRoute,
  });
const ConsoleOrgIdToolsPdsCompareRouteRoute =
  ConsoleOrgIdToolsPdsCompareRouteRouteImport.update({
    id: '/pds-compare',
    path: '/pds-compare',
    getParentRoute: () => ConsoleOrgIdToolsRouteRoute,
  });
const ConsoleOrgIdToolsWebsiteCheckerRouteRoute =
  ConsoleOrgIdToolsWebsiteCheckerRouteRouteImport.update({
    id: '/website-checker',
    path: '/website-checker',
    getParentRoute: () => ConsoleOrgIdToolsRouteRoute,
  });
const ConsoleOrgIdUserSettingsIndexRoute =
  ConsoleOrgIdUserSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdUserSettingsRouteRoute,
  });
const ConsoleOrgIdUserSettingsNotificationsRoute =
  ConsoleOrgIdUserSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => ConsoleOrgIdUserSettingsRouteRoute,
  });
const ConsoleOrgIdUserSettingsProfileRoute =
  ConsoleOrgIdUserSettingsProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => ConsoleOrgIdUserSettingsRouteRoute,
  });
const ConsoleOrgIdWorkloadManagerIndexRoute =
  ConsoleOrgIdWorkloadManagerIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdWorkloadManagerRouteRoute,
  });
const ConsoleOrgIdWorkloadManagerComplaintsRoute =
  ConsoleOrgIdWorkloadManagerComplaintsRouteImport.update({
    id: '/complaints',
    path: '/complaints',
    getParentRoute: () => ConsoleOrgIdWorkloadManagerRouteRoute,
  });
const ConsoleOrgIdWorkloadManagerEmailsRouteRoute =
  ConsoleOrgIdWorkloadManagerEmailsRouteRouteImport.update({
    id: '/emails',
    path: '/emails',
    getParentRoute: () => ConsoleOrgIdWorkloadManagerRouteRoute,
  });
const ConsoleOrgIdWorkloadManagerTasksRouteRoute =
  ConsoleOrgIdWorkloadManagerTasksRouteRouteImport.update({
    id: '/tasks',
    path: '/tasks',
    getParentRoute: () => ConsoleOrgIdWorkloadManagerRouteRoute,
  });
const PublicOrgIdComplaintNewRouteRoute =
  PublicOrgIdComplaintNewRouteRouteImport.update({
    id: '/complaint/new',
    path: '/complaint/new',
    getParentRoute: () => PublicOrgIdRouteRoute,
  });
const ConsoleOrgIdAttestationsRoundsRoundIdRouteRoute =
  ConsoleOrgIdAttestationsRoundsRoundIdRouteRouteImport.update({
    id: '/rounds/$roundId',
    path: '/rounds/$roundId',
    getParentRoute: () => ConsoleOrgIdAttestationsRouteRoute,
  });
const ConsoleOrgIdAttestationsScheduledAttestationsScheduleIdRouteRoute =
  ConsoleOrgIdAttestationsScheduledAttestationsScheduleIdRouteRouteImport.update(
    {
      id: '/$scheduleId',
      path: '/$scheduleId',
      getParentRoute: () =>
        ConsoleOrgIdAttestationsScheduledAttestationsRouteRoute,
    },
  );
const ConsoleOrgIdAttestationsScheduledAttestationsNewRoute =
  ConsoleOrgIdAttestationsScheduledAttestationsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () =>
      ConsoleOrgIdAttestationsScheduledAttestationsRouteRoute,
  });
const ConsoleOrgIdAttestationsUserAttestationsAttestationIdRouteRoute =
  ConsoleOrgIdAttestationsUserAttestationsAttestationIdRouteRouteImport.update({
    id: '/$attestationId',
    path: '/$attestationId',
    getParentRoute: () => ConsoleOrgIdAttestationsUserAttestationsRouteRoute,
  });
const ConsoleOrgIdAttestationsUserAttestationsSendRoute =
  ConsoleOrgIdAttestationsUserAttestationsSendRouteImport.update({
    id: '/send',
    path: '/send',
    getParentRoute: () => ConsoleOrgIdAttestationsUserAttestationsRouteRoute,
  });
const ConsoleOrgIdClaimsDetailsIdRouteRoute =
  ConsoleOrgIdClaimsDetailsIdRouteRouteImport.update({
    id: '/details/$id',
    path: '/details/$id',
    getParentRoute: () => ConsoleOrgIdClaimsRouteRoute,
  });
const ConsoleOrgIdClaimsLodgeLinkIdRoute =
  ConsoleOrgIdClaimsLodgeLinkIdRouteImport.update({
    id: '/lodge/$linkId',
    path: '/lodge/$linkId',
    getParentRoute: () => ConsoleOrgIdClaimsRouteRoute,
  });
const ConsoleOrgIdComplianceCoiIndexRoute =
  ConsoleOrgIdComplianceCoiIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdComplianceCoiRouteRoute,
  });
const ConsoleOrgIdComplianceCoiAddRouteRoute =
  ConsoleOrgIdComplianceCoiAddRouteRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => ConsoleOrgIdComplianceCoiRouteRoute,
  });
const ConsoleOrgIdComplianceComplaintsIndexRoute =
  ConsoleOrgIdComplianceComplaintsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdComplianceComplaintsRouteRoute,
  });
const ConsoleOrgIdComplianceComplaintsAddRouteRoute =
  ConsoleOrgIdComplianceComplaintsAddRouteRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => ConsoleOrgIdComplianceComplaintsRouteRoute,
  });
const ConsoleOrgIdComplianceIncidentsIndexRoute =
  ConsoleOrgIdComplianceIncidentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdComplianceIncidentsRouteRoute,
  });
const ConsoleOrgIdComplianceIncidentsAddRoute =
  ConsoleOrgIdComplianceIncidentsAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => ConsoleOrgIdComplianceIncidentsRouteRoute,
  });
const ConsoleOrgIdComplianceObligationsIndexRoute =
  ConsoleOrgIdComplianceObligationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdComplianceObligationsRouteRoute,
  });
const ConsoleOrgIdComplianceObligationsAddRouteRoute =
  ConsoleOrgIdComplianceObligationsAddRouteRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => ConsoleOrgIdComplianceObligationsRouteRoute,
  });
const ConsoleOrgIdComplianceRegistersRegisterIdRouteRoute =
  ConsoleOrgIdComplianceRegistersRegisterIdRouteRouteImport.update({
    id: '/$registerId',
    path: '/$registerId',
    getParentRoute: () => ConsoleOrgIdComplianceRegistersRouteRoute,
  });
const ConsoleOrgIdComplianceRegistersListRouteRoute =
  ConsoleOrgIdComplianceRegistersListRouteRouteImport.update({
    id: '/_list',
    getParentRoute: () => ConsoleOrgIdComplianceRegistersRouteRoute,
  });
const ConsoleOrgIdComplianceTrainingIndexRoute =
  ConsoleOrgIdComplianceTrainingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdComplianceTrainingRouteRoute,
  });
const ConsoleOrgIdComplianceTrainingSearchRouteRoute =
  ConsoleOrgIdComplianceTrainingSearchRouteRouteImport.update({
    id: '/search',
    path: '/search',
    getParentRoute: () => ConsoleOrgIdComplianceTrainingRouteRoute,
  });
const ConsoleOrgIdConfigurationApiIntegrationsApiTokensRouteRoute =
  ConsoleOrgIdConfigurationApiIntegrationsApiTokensRouteRouteImport.update({
    id: '/api-tokens',
    path: '/api-tokens',
    getParentRoute: () => ConsoleOrgIdConfigurationApiIntegrationsRouteRoute,
  });
const ConsoleOrgIdConfigurationApiIntegrationsDocumentSourcesRouteRoute =
  ConsoleOrgIdConfigurationApiIntegrationsDocumentSourcesRouteRouteImport.update(
    {
      id: '/document-sources',
      path: '/document-sources',
      getParentRoute: () => ConsoleOrgIdConfigurationApiIntegrationsRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationApiIntegrationsMcpAccessRouteRoute =
  ConsoleOrgIdConfigurationApiIntegrationsMcpAccessRouteRouteImport.update({
    id: '/mcp-access',
    path: '/mcp-access',
    getParentRoute: () => ConsoleOrgIdConfigurationApiIntegrationsRouteRoute,
  });
const ConsoleOrgIdConfigurationClaimsProductsClaimIntakeLinksRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimIntakeLinksRouteRouteImport.update(
    {
      id: '/claim-intake-links',
      path: '/claim-intake-links',
      getParentRoute: () => ConsoleOrgIdConfigurationClaimsProductsRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRouteImport.update({
    id: '/claims',
    path: '/claims',
    getParentRoute: () => ConsoleOrgIdConfigurationClaimsProductsRouteRoute,
  });
const ConsoleOrgIdConfigurationClaimsProductsContactRolesRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsContactRolesRouteRouteImport.update({
    id: '/contact-roles',
    path: '/contact-roles',
    getParentRoute: () => ConsoleOrgIdConfigurationClaimsProductsRouteRoute,
  });
const ConsoleOrgIdConfigurationClaimsProductsFormsRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsFormsRouteRouteImport.update({
    id: '/forms',
    path: '/forms',
    getParentRoute: () => ConsoleOrgIdConfigurationClaimsProductsRouteRoute,
  });
const ConsoleOrgIdConfigurationClaimsProductsInsurersRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsInsurersRouteRouteImport.update({
    id: '/insurers',
    path: '/insurers',
    getParentRoute: () => ConsoleOrgIdConfigurationClaimsProductsRouteRoute,
  });
const ConsoleOrgIdConfigurationClaimsProductsProductTypesRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesRouteRouteImport.update({
    id: '/product-types',
    path: '/product-types',
    getParentRoute: () => ConsoleOrgIdConfigurationClaimsProductsRouteRoute,
  });
const ConsoleOrgIdConfigurationClaimsProductsProductsV2RouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductsV2RouteRouteImport.update({
    id: '/products-v2',
    path: '/products-v2',
    getParentRoute: () => ConsoleOrgIdConfigurationClaimsProductsRouteRoute,
  });
const ConsoleOrgIdConfigurationClaimsProductsQuestionnaireRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsQuestionnaireRouteRouteImport.update({
    id: '/questionnaire',
    path: '/questionnaire',
    getParentRoute: () => ConsoleOrgIdConfigurationClaimsProductsRouteRoute,
  });
const ConsoleOrgIdConfigurationClientDatabaseSplatRoute =
  ConsoleOrgIdConfigurationClientDatabaseSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => ConsoleOrgIdConfigurationClientDatabaseRoute,
  });
const ConsoleOrgIdConfigurationComplianceIndexRoute =
  ConsoleOrgIdConfigurationComplianceIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdConfigurationComplianceRouteRoute,
  });
const ConsoleOrgIdConfigurationComplianceAttestationsRouteRoute =
  ConsoleOrgIdConfigurationComplianceAttestationsRouteRouteImport.update({
    id: '/attestations',
    path: '/attestations',
    getParentRoute: () => ConsoleOrgIdConfigurationComplianceRouteRoute,
  });
const ConsoleOrgIdConfigurationComplianceAutoDetectRouteRoute =
  ConsoleOrgIdConfigurationComplianceAutoDetectRouteRouteImport.update({
    id: '/auto-detect',
    path: '/auto-detect',
    getParentRoute: () => ConsoleOrgIdConfigurationComplianceRouteRoute,
  });
const ConsoleOrgIdConfigurationComplianceComplaintsRouteRoute =
  ConsoleOrgIdConfigurationComplianceComplaintsRouteRouteImport.update({
    id: '/complaints',
    path: '/complaints',
    getParentRoute: () => ConsoleOrgIdConfigurationComplianceRouteRoute,
  });
const ConsoleOrgIdConfigurationComplianceComplianceAuditRouteRoute =
  ConsoleOrgIdConfigurationComplianceComplianceAuditRouteRouteImport.update({
    id: '/compliance-audit',
    path: '/compliance-audit',
    getParentRoute: () => ConsoleOrgIdConfigurationComplianceRouteRoute,
  });
const ConsoleOrgIdConfigurationComplianceGeneralRouteRoute =
  ConsoleOrgIdConfigurationComplianceGeneralRouteRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => ConsoleOrgIdConfigurationComplianceRouteRoute,
  });
const ConsoleOrgIdConfigurationComplianceIncidentsRouteRoute =
  ConsoleOrgIdConfigurationComplianceIncidentsRouteRouteImport.update({
    id: '/incidents',
    path: '/incidents',
    getParentRoute: () => ConsoleOrgIdConfigurationComplianceRouteRoute,
  });
const ConsoleOrgIdConfigurationComplianceMsprRouteRoute =
  ConsoleOrgIdConfigurationComplianceMsprRouteRouteImport.update({
    id: '/mspr',
    path: '/mspr',
    getParentRoute: () => ConsoleOrgIdConfigurationComplianceRouteRoute,
  });
const ConsoleOrgIdConfigurationComplianceObligationsRoute =
  ConsoleOrgIdConfigurationComplianceObligationsRouteImport.update({
    id: '/obligations',
    path: '/obligations',
    getParentRoute: () => ConsoleOrgIdConfigurationComplianceRouteRoute,
  });
const ConsoleOrgIdConfigurationComplianceTrainingRouteRoute =
  ConsoleOrgIdConfigurationComplianceTrainingRouteRouteImport.update({
    id: '/training',
    path: '/training',
    getParentRoute: () => ConsoleOrgIdConfigurationComplianceRouteRoute,
  });
const ConsoleOrgIdConfigurationFinancialsBankAccountRouteRoute =
  ConsoleOrgIdConfigurationFinancialsBankAccountRouteRouteImport.update({
    id: '/bank-account',
    path: '/bank-account',
    getParentRoute: () => ConsoleOrgIdConfigurationFinancialsRouteRoute,
  });
const ConsoleOrgIdConfigurationFinancialsBillingRouteRoute =
  ConsoleOrgIdConfigurationFinancialsBillingRouteRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => ConsoleOrgIdConfigurationFinancialsRouteRoute,
  });
const ConsoleOrgIdConfigurationFinancialsExpensesBillingRouteRoute =
  ConsoleOrgIdConfigurationFinancialsExpensesBillingRouteRouteImport.update({
    id: '/expenses-billing',
    path: '/expenses-billing',
    getParentRoute: () => ConsoleOrgIdConfigurationFinancialsRouteRoute,
  });
const ConsoleOrgIdConfigurationFleetIndexRoute =
  ConsoleOrgIdConfigurationFleetIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdConfigurationFleetRouteRoute,
  });
const ConsoleOrgIdConfigurationFleetClientDatabaseRouteRoute =
  ConsoleOrgIdConfigurationFleetClientDatabaseRouteRouteImport.update({
    id: '/client-database',
    path: '/client-database',
    getParentRoute: () => ConsoleOrgIdConfigurationFleetRouteRoute,
  });
const ConsoleOrgIdConfigurationFleetDelegatedAuthorityRouteRoute =
  ConsoleOrgIdConfigurationFleetDelegatedAuthorityRouteRouteImport.update({
    id: '/delegated-authority',
    path: '/delegated-authority',
    getParentRoute: () => ConsoleOrgIdConfigurationFleetRouteRoute,
  });
const ConsoleOrgIdConfigurationFleetEscalationsRouteRoute =
  ConsoleOrgIdConfigurationFleetEscalationsRouteRouteImport.update({
    id: '/escalations',
    path: '/escalations',
    getParentRoute: () => ConsoleOrgIdConfigurationFleetRouteRoute,
  });
const ConsoleOrgIdConfigurationFleetPortalClaimPageRouteRoute =
  ConsoleOrgIdConfigurationFleetPortalClaimPageRouteRouteImport.update({
    id: '/portal-claim-page',
    path: '/portal-claim-page',
    getParentRoute: () => ConsoleOrgIdConfigurationFleetRouteRoute,
  });
const ConsoleOrgIdConfigurationMonitoringAuditTrailRouteRoute =
  ConsoleOrgIdConfigurationMonitoringAuditTrailRouteRouteImport.update({
    id: '/audit-trail',
    path: '/audit-trail',
    getParentRoute: () => ConsoleOrgIdConfigurationMonitoringRouteRoute,
  });
const ConsoleOrgIdConfigurationMonitoringEmailActivityRouteRoute =
  ConsoleOrgIdConfigurationMonitoringEmailActivityRouteRouteImport.update({
    id: '/email-activity',
    path: '/email-activity',
    getParentRoute: () => ConsoleOrgIdConfigurationMonitoringRouteRoute,
  });
const ConsoleOrgIdConfigurationMonitoringStatisticsRouteRoute =
  ConsoleOrgIdConfigurationMonitoringStatisticsRouteRouteImport.update({
    id: '/statistics',
    path: '/statistics',
    getParentRoute: () => ConsoleOrgIdConfigurationMonitoringRouteRoute,
  });
const ConsoleOrgIdConfigurationOrgSettingsCommunicationRouteRoute =
  ConsoleOrgIdConfigurationOrgSettingsCommunicationRouteRouteImport.update({
    id: '/communication',
    path: '/communication',
    getParentRoute: () => ConsoleOrgIdConfigurationOrgSettingsRouteRoute,
  });
const ConsoleOrgIdConfigurationOrgSettingsFleetEscalationsRoute =
  ConsoleOrgIdConfigurationOrgSettingsFleetEscalationsRouteImport.update({
    id: '/fleet-escalations',
    path: '/fleet-escalations',
    getParentRoute: () => ConsoleOrgIdConfigurationOrgSettingsRouteRoute,
  });
const ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesRouteRoute =
  ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesRouteRouteImport.update({
    id: '/handling-parties',
    path: '/handling-parties',
    getParentRoute: () => ConsoleOrgIdConfigurationOrgSettingsRouteRoute,
  });
const ConsoleOrgIdConfigurationOrgSettingsSupportSessionsRouteRoute =
  ConsoleOrgIdConfigurationOrgSettingsSupportSessionsRouteRouteImport.update({
    id: '/support-sessions',
    path: '/support-sessions',
    getParentRoute: () => ConsoleOrgIdConfigurationOrgSettingsRouteRoute,
  });
const ConsoleOrgIdConfigurationOrgSettingsSystemRouteRoute =
  ConsoleOrgIdConfigurationOrgSettingsSystemRouteRouteImport.update({
    id: '/system',
    path: '/system',
    getParentRoute: () => ConsoleOrgIdConfigurationOrgSettingsRouteRoute,
  });
const ConsoleOrgIdConfigurationOrgSettingsTrashRouteRoute =
  ConsoleOrgIdConfigurationOrgSettingsTrashRouteRouteImport.update({
    id: '/trash',
    path: '/trash',
    getParentRoute: () => ConsoleOrgIdConfigurationOrgSettingsRouteRoute,
  });
const ConsoleOrgIdConfigurationOrgSettingsUsersRouteRoute =
  ConsoleOrgIdConfigurationOrgSettingsUsersRouteRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => ConsoleOrgIdConfigurationOrgSettingsRouteRoute,
  });
const ConsoleOrgIdConfigurationRiskIndexRoute =
  ConsoleOrgIdConfigurationRiskIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdConfigurationRiskRouteRoute,
  });
const ConsoleOrgIdConfigurationRiskAppetiteRoute =
  ConsoleOrgIdConfigurationRiskAppetiteRouteImport.update({
    id: '/appetite',
    path: '/appetite',
    getParentRoute: () => ConsoleOrgIdConfigurationRiskRouteRoute,
  });
const ConsoleOrgIdConfigurationRiskCategoriesRoute =
  ConsoleOrgIdConfigurationRiskCategoriesRouteImport.update({
    id: '/categories',
    path: '/categories',
    getParentRoute: () => ConsoleOrgIdConfigurationRiskRouteRoute,
  });
const ConsoleOrgIdConfigurationRiskMatrixRoute =
  ConsoleOrgIdConfigurationRiskMatrixRouteImport.update({
    id: '/matrix',
    path: '/matrix',
    getParentRoute: () => ConsoleOrgIdConfigurationRiskRouteRoute,
  });
const ConsoleOrgIdConfigurationVendorManagementRepairNetworksRouteRoute =
  ConsoleOrgIdConfigurationVendorManagementRepairNetworksRouteRouteImport.update(
    {
      id: '/repair-networks',
      path: '/repair-networks',
      getParentRoute: () => ConsoleOrgIdConfigurationVendorManagementRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRoute =
  ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRouteImport.update({
    id: '/suppliers',
    path: '/suppliers',
    getParentRoute: () => ConsoleOrgIdConfigurationVendorManagementRouteRoute,
  });
const ConsoleOrgIdControlsRegisterIndexRoute =
  ConsoleOrgIdControlsRegisterIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdControlsRegisterRouteRoute,
  });
const ConsoleOrgIdControlsRegisterAddRouteRoute =
  ConsoleOrgIdControlsRegisterAddRouteRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => ConsoleOrgIdControlsRegisterRouteRoute,
  });
const ConsoleOrgIdDocumentsDetailsFileIdRouteRoute =
  ConsoleOrgIdDocumentsDetailsFileIdRouteRouteImport.update({
    id: '/details/$fileId',
    path: '/details/$fileId',
    getParentRoute: () => ConsoleOrgIdDocumentsRouteRoute,
  });
const ConsoleOrgIdFleetPortalClaimsIndexRoute =
  ConsoleOrgIdFleetPortalClaimsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdFleetPortalClaimsRouteRoute,
  });
const ConsoleOrgIdMsprServiceProvidersIndexRoute =
  ConsoleOrgIdMsprServiceProvidersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdMsprServiceProvidersRouteRoute,
  });
const ConsoleOrgIdMsprServiceProvidersSearchRouteRoute =
  ConsoleOrgIdMsprServiceProvidersSearchRouteRouteImport.update({
    id: '/search',
    path: '/search',
    getParentRoute: () => ConsoleOrgIdMsprServiceProvidersRouteRoute,
  });
const ConsoleOrgIdRiskRasIndexRoute =
  ConsoleOrgIdRiskRasIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdRiskRasRouteRoute,
  });
const ConsoleOrgIdRiskRegisterIndexRoute =
  ConsoleOrgIdRiskRegisterIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdRiskRegisterRouteRoute,
  });
const ConsoleOrgIdToolsAutoDetectDashboardRoute =
  ConsoleOrgIdToolsAutoDetectDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => ConsoleOrgIdToolsAutoDetectRouteRoute,
  });
const ConsoleOrgIdToolsAutoDetectInboxRouteRoute =
  ConsoleOrgIdToolsAutoDetectInboxRouteRouteImport.update({
    id: '/inbox',
    path: '/inbox',
    getParentRoute: () => ConsoleOrgIdToolsAutoDetectRouteRoute,
  });
const ConsoleOrgIdToolsComplianceAuditIndexRoute =
  ConsoleOrgIdToolsComplianceAuditIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdToolsComplianceAuditRouteRoute,
  });
const ConsoleOrgIdToolsComplianceAuditOverviewRouteRoute =
  ConsoleOrgIdToolsComplianceAuditOverviewRouteRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => ConsoleOrgIdToolsComplianceAuditRouteRoute,
  });
const ConsoleOrgIdToolsDocumentAnalyzerIndexRoute =
  ConsoleOrgIdToolsDocumentAnalyzerIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdToolsDocumentAnalyzerRouteRoute,
  });
const ConsoleOrgIdToolsDocumentAnalyzerHistoryRouteRoute =
  ConsoleOrgIdToolsDocumentAnalyzerHistoryRouteRouteImport.update({
    id: '/history',
    path: '/history',
    getParentRoute: () => ConsoleOrgIdToolsDocumentAnalyzerRouteRoute,
  });
const ConsoleOrgIdToolsDocumentAnalyzerUploadRoute =
  ConsoleOrgIdToolsDocumentAnalyzerUploadRouteImport.update({
    id: '/upload',
    path: '/upload',
    getParentRoute: () => ConsoleOrgIdToolsDocumentAnalyzerRouteRoute,
  });
const ConsoleOrgIdToolsPdsCompareIndexRoute =
  ConsoleOrgIdToolsPdsCompareIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdToolsPdsCompareRouteRoute,
  });
const ConsoleOrgIdToolsPdsComparePdsDocumentsRouteRoute =
  ConsoleOrgIdToolsPdsComparePdsDocumentsRouteRouteImport.update({
    id: '/pds-documents',
    path: '/pds-documents',
    getParentRoute: () => ConsoleOrgIdToolsPdsCompareRouteRoute,
  });
const ConsoleOrgIdToolsWebsiteCheckerIndexRoute =
  ConsoleOrgIdToolsWebsiteCheckerIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdToolsWebsiteCheckerRouteRoute,
  });
const ConsoleOrgIdUserSettingsAuthorisedAppsIndexRoute =
  ConsoleOrgIdUserSettingsAuthorisedAppsIndexRouteImport.update({
    id: '/authorised-apps/',
    path: '/authorised-apps/',
    getParentRoute: () => ConsoleOrgIdUserSettingsRouteRoute,
  });
const ConsoleOrgIdWorkloadManagerTasksIndexRoute =
  ConsoleOrgIdWorkloadManagerTasksIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdWorkloadManagerTasksRouteRoute,
  });
const ConsoleOrgIdWorkloadManagerTasksCalendarRouteRoute =
  ConsoleOrgIdWorkloadManagerTasksCalendarRouteRouteImport.update({
    id: '/calendar',
    path: '/calendar',
    getParentRoute: () => ConsoleOrgIdWorkloadManagerTasksRouteRoute,
  });
const ConsoleOrgIdWorkloadManagerTasksListRouteRoute =
  ConsoleOrgIdWorkloadManagerTasksListRouteRouteImport.update({
    id: '/list',
    path: '/list',
    getParentRoute: () => ConsoleOrgIdWorkloadManagerTasksRouteRoute,
  });
const PublicOrgIdInvoiceViewAccessKeyRouteRoute =
  PublicOrgIdInvoiceViewAccessKeyRouteRouteImport.update({
    id: '/invoice/view/$accessKey',
    path: '/invoice/view/$accessKey',
    getParentRoute: () => PublicOrgIdRouteRoute,
  });
const ConsoleOrgIdAttestationsOverviewPeopleUserIdRoute =
  ConsoleOrgIdAttestationsOverviewPeopleUserIdRouteImport.update({
    id: '/people/$userId',
    path: '/people/$userId',
    getParentRoute: () => ConsoleOrgIdAttestationsOverviewRouteRoute,
  });
const ConsoleOrgIdAttestationsRoundsRoundIdCoverageRoute =
  ConsoleOrgIdAttestationsRoundsRoundIdCoverageRouteImport.update({
    id: '/coverage',
    path: '/coverage',
    getParentRoute: () => ConsoleOrgIdAttestationsRoundsRoundIdRouteRoute,
  });
const ConsoleOrgIdClaimsDetailsIdActivityRouteRoute =
  ConsoleOrgIdClaimsDetailsIdActivityRouteRouteImport.update({
    id: '/activity',
    path: '/activity',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdRouteRoute,
  });
const ConsoleOrgIdClaimsDetailsIdAiAssessmentRouteRoute =
  ConsoleOrgIdClaimsDetailsIdAiAssessmentRouteRouteImport.update({
    id: '/ai-assessment',
    path: '/ai-assessment',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdRouteRoute,
  });
const ConsoleOrgIdClaimsDetailsIdCommsRouteRoute =
  ConsoleOrgIdClaimsDetailsIdCommsRouteRouteImport.update({
    id: '/comms',
    path: '/comms',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdRouteRoute,
  });
const ConsoleOrgIdClaimsDetailsIdContactsRouteRoute =
  ConsoleOrgIdClaimsDetailsIdContactsRouteRouteImport.update({
    id: '/contacts',
    path: '/contacts',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdRouteRoute,
  });
const ConsoleOrgIdClaimsDetailsIdExpensesRouteRoute =
  ConsoleOrgIdClaimsDetailsIdExpensesRouteRouteImport.update({
    id: '/expenses',
    path: '/expenses',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdRouteRoute,
  });
const ConsoleOrgIdClaimsDetailsIdFinancialsRouteRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsRouteRouteImport.update({
    id: '/financials',
    path: '/financials',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdRouteRoute,
  });
const ConsoleOrgIdClaimsDetailsIdHistoryRouteRoute =
  ConsoleOrgIdClaimsDetailsIdHistoryRouteRouteImport.update({
    id: '/history',
    path: '/history',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdRouteRoute,
  });
const ConsoleOrgIdClaimsDetailsIdLibraryRouteRoute =
  ConsoleOrgIdClaimsDetailsIdLibraryRouteRouteImport.update({
    id: '/library',
    path: '/library',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdRouteRoute,
  });
const ConsoleOrgIdClaimsDetailsIdManageRouteRoute =
  ConsoleOrgIdClaimsDetailsIdManageRouteRouteImport.update({
    id: '/manage',
    path: '/manage',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdRouteRoute,
  });
const ConsoleOrgIdClaimsDetailsIdPolicyInfoRouteRoute =
  ConsoleOrgIdClaimsDetailsIdPolicyInfoRouteRouteImport.update({
    id: '/policy-info',
    path: '/policy-info',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdRouteRoute,
  });
const ConsoleOrgIdClaimsDetailsIdProductFieldsRouteRoute =
  ConsoleOrgIdClaimsDetailsIdProductFieldsRouteRouteImport.update({
    id: '/product-fields',
    path: '/product-fields',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdRouteRoute,
  });
const ConsoleOrgIdClaimsDetailsIdProductTypeDataRouteRoute =
  ConsoleOrgIdClaimsDetailsIdProductTypeDataRouteRouteImport.update({
    id: '/product-type-data',
    path: '/product-type-data',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdRouteRoute,
  });
const ConsoleOrgIdClaimsDetailsIdVehicleRouteRoute =
  ConsoleOrgIdClaimsDetailsIdVehicleRouteRouteImport.update({
    id: '/vehicle',
    path: '/vehicle',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdRouteRoute,
  });
const ConsoleOrgIdComplianceCoiDetailsIdRouteRoute =
  ConsoleOrgIdComplianceCoiDetailsIdRouteRouteImport.update({
    id: '/details/$id',
    path: '/details/$id',
    getParentRoute: () => ConsoleOrgIdComplianceCoiRouteRoute,
  });
const ConsoleOrgIdComplianceComplaintsDetailsIdRouteRoute =
  ConsoleOrgIdComplianceComplaintsDetailsIdRouteRouteImport.update({
    id: '/details/$id',
    path: '/details/$id',
    getParentRoute: () => ConsoleOrgIdComplianceComplaintsRouteRoute,
  });
const ConsoleOrgIdComplianceIncidentsDetailsIdRouteRoute =
  ConsoleOrgIdComplianceIncidentsDetailsIdRouteRouteImport.update({
    id: '/details/$id',
    path: '/details/$id',
    getParentRoute: () => ConsoleOrgIdComplianceIncidentsRouteRoute,
  });
const ConsoleOrgIdComplianceObligationsDetailsIdRouteRoute =
  ConsoleOrgIdComplianceObligationsDetailsIdRouteRouteImport.update({
    id: '/details/$id',
    path: '/details/$id',
    getParentRoute: () => ConsoleOrgIdComplianceObligationsRouteRoute,
  });
const ConsoleOrgIdComplianceRegistersRegisterIdIndexRoute =
  ConsoleOrgIdComplianceRegistersRegisterIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdComplianceRegistersRegisterIdRouteRoute,
  });
const ConsoleOrgIdComplianceRegistersListIndexRoute =
  ConsoleOrgIdComplianceRegistersListIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdComplianceRegistersListRouteRoute,
  });
const ConsoleOrgIdComplianceRegistersListAddRoute =
  ConsoleOrgIdComplianceRegistersListAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => ConsoleOrgIdComplianceRegistersListRouteRoute,
  });
const ConsoleOrgIdComplianceRegistersListNewRoute =
  ConsoleOrgIdComplianceRegistersListNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => ConsoleOrgIdComplianceRegistersListRouteRoute,
  });
const ConsoleOrgIdComplianceTrainingSearchAddRoute =
  ConsoleOrgIdComplianceTrainingSearchAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => ConsoleOrgIdComplianceTrainingSearchRouteRoute,
  });
const ConsoleOrgIdComplianceTrainingUserUserIdRouteRoute =
  ConsoleOrgIdComplianceTrainingUserUserIdRouteRouteImport.update({
    id: '/user/$userId',
    path: '/user/$userId',
    getParentRoute: () => ConsoleOrgIdComplianceTrainingRouteRoute,
  });
const ConsoleOrgIdConfigurationApiIntegrationsApiTokensCreateRoute =
  ConsoleOrgIdConfigurationApiIntegrationsApiTokensCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationApiIntegrationsApiTokensRouteRoute,
  });
const ConsoleOrgIdConfigurationApiIntegrationsDocumentSourcesConnectionIdRoute =
  ConsoleOrgIdConfigurationApiIntegrationsDocumentSourcesConnectionIdRouteImport.update(
    {
      id: '/$connectionId',
      path: '/$connectionId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationApiIntegrationsDocumentSourcesRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationApiIntegrationsDocumentSourcesAddRoute =
  ConsoleOrgIdConfigurationApiIntegrationsDocumentSourcesAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationApiIntegrationsDocumentSourcesRouteRoute,
  });
const ConsoleOrgIdConfigurationApiIntegrationsFormDesignerIndexRoute =
  ConsoleOrgIdConfigurationApiIntegrationsFormDesignerIndexRouteImport.update({
    id: '/form-designer/',
    path: '/form-designer/',
    getParentRoute: () => ConsoleOrgIdConfigurationApiIntegrationsRouteRoute,
  });
const ConsoleOrgIdConfigurationApiIntegrationsFormDesignerFormDefinitionIdRoute =
  ConsoleOrgIdConfigurationApiIntegrationsFormDesignerFormDefinitionIdRouteImport.update(
    {
      id: '/form-designer/$formDefinitionId',
      path: '/form-designer/$formDefinitionId',
      getParentRoute: () => ConsoleOrgIdConfigurationApiIntegrationsRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsClaimsIndexRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRoute,
  });
const ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsRouteRouteImport.update(
    {
      id: '/catastrophe-events',
      path: '/catastrophe-events',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsRouteRouteImport.update(
    {
      id: '/claim-flags',
      path: '/claim-flags',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsClaimsClaimsAuthorityRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsClaimsAuthorityRouteRouteImport.update(
    {
      id: '/claims-authority',
      path: '/claims-authority',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsClaimsDocumentsRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRoute,
  });
const ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralRouteRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRoute,
  });
const ConsoleOrgIdConfigurationClaimsProductsClaimsHandlingStandardsRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsHandlingStandardsRouteImport.update(
    {
      id: '/handling-standards',
      path: '/handling-standards',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsClaimsIdRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsIdRouteImport.update({
    id: '/id',
    path: '/id',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRoute,
  });
const ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsRouteRouteImport.update(
    {
      id: '/task-lists',
      path: '/task-lists',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsContactRolesAddRoute =
  ConsoleOrgIdConfigurationClaimsProductsContactRolesAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationClaimsProductsContactRolesRouteRoute,
  });
const ConsoleOrgIdConfigurationClaimsProductsFormsIndexRoute =
  ConsoleOrgIdConfigurationClaimsProductsFormsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationClaimsProductsFormsRouteRoute,
  });
const ConsoleOrgIdConfigurationClaimsProductsFormsFormDefinitionIdRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsFormsFormDefinitionIdRouteRouteImport.update(
    {
      id: '/$formDefinitionId',
      path: '/$formDefinitionId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsFormsRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdRouteRouteImport.update(
    {
      id: '/$productTypeId',
      path: '/$productTypeId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesAddRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationClaimsProductsProductTypesRouteRoute,
  });
const ConsoleOrgIdConfigurationClaimsProductsProductsV2AddRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductsV2AddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationClaimsProductsProductsV2RouteRoute,
  });
const ConsoleOrgIdConfigurationClaimsProductsQuestionnaireAddRoute =
  ConsoleOrgIdConfigurationClaimsProductsQuestionnaireAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationClaimsProductsQuestionnaireRouteRoute,
  });
const ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsRouteRoute =
  ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsRouteRouteImport.update(
    {
      id: '/user-attestations',
      path: '/user-attestations',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationComplianceAttestationsRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationComplianceComplaintsIndexRoute =
  ConsoleOrgIdConfigurationComplianceComplaintsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationComplianceComplaintsRouteRoute,
  });
const ConsoleOrgIdConfigurationComplianceComplaintsBrandsRoute =
  ConsoleOrgIdConfigurationComplianceComplaintsBrandsRouteImport.update({
    id: '/brands',
    path: '/brands',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationComplianceComplaintsRouteRoute,
  });
const ConsoleOrgIdConfigurationComplianceComplaintsCustomFieldsRoute =
  ConsoleOrgIdConfigurationComplianceComplaintsCustomFieldsRouteImport.update({
    id: '/custom-fields',
    path: '/custom-fields',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationComplianceComplaintsRouteRoute,
  });
const ConsoleOrgIdConfigurationComplianceComplaintsFlagsRouteRoute =
  ConsoleOrgIdConfigurationComplianceComplaintsFlagsRouteRouteImport.update({
    id: '/flags',
    path: '/flags',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationComplianceComplaintsRouteRoute,
  });
const ConsoleOrgIdConfigurationComplianceComplaintsGeneralRouteRoute =
  ConsoleOrgIdConfigurationComplianceComplaintsGeneralRouteRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationComplianceComplaintsRouteRoute,
  });
const ConsoleOrgIdConfigurationComplianceComplaintsRulesRoute =
  ConsoleOrgIdConfigurationComplianceComplaintsRulesRouteImport.update({
    id: '/rules',
    path: '/rules',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationComplianceComplaintsRouteRoute,
  });
const ConsoleOrgIdConfigurationComplianceGeneralIndexRoute =
  ConsoleOrgIdConfigurationComplianceGeneralIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdConfigurationComplianceGeneralRouteRoute,
  });
const ConsoleOrgIdConfigurationComplianceGeneralAsicProductsRoute =
  ConsoleOrgIdConfigurationComplianceGeneralAsicProductsRouteImport.update({
    id: '/asic-products',
    path: '/asic-products',
    getParentRoute: () => ConsoleOrgIdConfigurationComplianceGeneralRouteRoute,
  });
const ConsoleOrgIdConfigurationComplianceGeneralDocumentsRoute =
  ConsoleOrgIdConfigurationComplianceGeneralDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => ConsoleOrgIdConfigurationComplianceGeneralRouteRoute,
  });
const ConsoleOrgIdConfigurationComplianceIncidentsIndexRoute =
  ConsoleOrgIdConfigurationComplianceIncidentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationComplianceIncidentsRouteRoute,
  });
const ConsoleOrgIdConfigurationComplianceIncidentsCustomFieldsRoute =
  ConsoleOrgIdConfigurationComplianceIncidentsCustomFieldsRouteImport.update({
    id: '/custom-fields',
    path: '/custom-fields',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationComplianceIncidentsRouteRoute,
  });
const ConsoleOrgIdConfigurationComplianceIncidentsFlagsRouteRoute =
  ConsoleOrgIdConfigurationComplianceIncidentsFlagsRouteRouteImport.update({
    id: '/flags',
    path: '/flags',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationComplianceIncidentsRouteRoute,
  });
const ConsoleOrgIdConfigurationComplianceIncidentsGeneralRouteRoute =
  ConsoleOrgIdConfigurationComplianceIncidentsGeneralRouteRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationComplianceIncidentsRouteRoute,
  });
const ConsoleOrgIdConfigurationComplianceIncidentsRulesRoute =
  ConsoleOrgIdConfigurationComplianceIncidentsRulesRouteImport.update({
    id: '/rules',
    path: '/rules',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationComplianceIncidentsRouteRoute,
  });
const ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsRouteRoute =
  ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsRouteRouteImport.update(
    {
      id: '/critical-operations',
      path: '/critical-operations',
      getParentRoute: () => ConsoleOrgIdConfigurationComplianceMsprRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationComplianceMsprDefinitionsRouteRoute =
  ConsoleOrgIdConfigurationComplianceMsprDefinitionsRouteRouteImport.update({
    id: '/definitions',
    path: '/definitions',
    getParentRoute: () => ConsoleOrgIdConfigurationComplianceMsprRouteRoute,
  });
const ConsoleOrgIdConfigurationComplianceMsprDocumentsRoute =
  ConsoleOrgIdConfigurationComplianceMsprDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => ConsoleOrgIdConfigurationComplianceMsprRouteRoute,
  });
const ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigRouteRoute =
  ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigRouteRouteImport.update(
    {
      id: '/governance-config',
      path: '/governance-config',
      getParentRoute: () => ConsoleOrgIdConfigurationComplianceMsprRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationComplianceTrainingIndexRoute =
  ConsoleOrgIdConfigurationComplianceTrainingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdConfigurationComplianceTrainingRouteRoute,
  });
const ConsoleOrgIdConfigurationComplianceTrainingCustomFieldsRoute =
  ConsoleOrgIdConfigurationComplianceTrainingCustomFieldsRouteImport.update({
    id: '/custom-fields',
    path: '/custom-fields',
    getParentRoute: () => ConsoleOrgIdConfigurationComplianceTrainingRouteRoute,
  });
const ConsoleOrgIdConfigurationComplianceTrainingTrainingPeriodsRoute =
  ConsoleOrgIdConfigurationComplianceTrainingTrainingPeriodsRouteImport.update({
    id: '/training-periods',
    path: '/training-periods',
    getParentRoute: () => ConsoleOrgIdConfigurationComplianceTrainingRouteRoute,
  });
const ConsoleOrgIdConfigurationFinancialsBankAccountAddRoute =
  ConsoleOrgIdConfigurationFinancialsBankAccountAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationFinancialsBankAccountRouteRoute,
  });
const ConsoleOrgIdConfigurationFinancialsBillingBalanceRoute =
  ConsoleOrgIdConfigurationFinancialsBillingBalanceRouteImport.update({
    id: '/balance',
    path: '/balance',
    getParentRoute: () => ConsoleOrgIdConfigurationFinancialsBillingRouteRoute,
  });
const ConsoleOrgIdConfigurationFinancialsBillingBillingInfoRoute =
  ConsoleOrgIdConfigurationFinancialsBillingBillingInfoRouteImport.update({
    id: '/billing-info',
    path: '/billing-info',
    getParentRoute: () => ConsoleOrgIdConfigurationFinancialsBillingRouteRoute,
  });
const ConsoleOrgIdConfigurationFinancialsBillingInvoicesRoute =
  ConsoleOrgIdConfigurationFinancialsBillingInvoicesRouteImport.update({
    id: '/invoices',
    path: '/invoices',
    getParentRoute: () => ConsoleOrgIdConfigurationFinancialsBillingRouteRoute,
  });
const ConsoleOrgIdConfigurationFinancialsBillingTransactionsRoute =
  ConsoleOrgIdConfigurationFinancialsBillingTransactionsRouteImport.update({
    id: '/transactions',
    path: '/transactions',
    getParentRoute: () => ConsoleOrgIdConfigurationFinancialsBillingRouteRoute,
  });
const ConsoleOrgIdConfigurationFinancialsBillingUsageRoute =
  ConsoleOrgIdConfigurationFinancialsBillingUsageRouteImport.update({
    id: '/usage',
    path: '/usage',
    getParentRoute: () => ConsoleOrgIdConfigurationFinancialsBillingRouteRoute,
  });
const ConsoleOrgIdConfigurationFleetClientDatabaseAddRoute =
  ConsoleOrgIdConfigurationFleetClientDatabaseAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationFleetClientDatabaseRouteRoute,
  });
const ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesRouteRoute =
  ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesRouteRouteImport.update(
    {
      id: '/comm-signatures',
      path: '/comm-signatures',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationOrgSettingsCommunicationRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesRouteRoute =
  ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesRouteRouteImport.update(
    {
      id: '/comm-templates',
      path: '/comm-templates',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationOrgSettingsCommunicationRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesAddRoute =
  ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesRouteRoute,
  });
const ConsoleOrgIdConfigurationOrgSettingsTrashIndexRoute =
  ConsoleOrgIdConfigurationOrgSettingsTrashIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdConfigurationOrgSettingsTrashRouteRoute,
  });
const ConsoleOrgIdConfigurationOrgSettingsTrashFilesRoute =
  ConsoleOrgIdConfigurationOrgSettingsTrashFilesRouteImport.update({
    id: '/files',
    path: '/files',
    getParentRoute: () => ConsoleOrgIdConfigurationOrgSettingsTrashRouteRoute,
  });
const ConsoleOrgIdConfigurationOrgSettingsTrashRegistersRoute =
  ConsoleOrgIdConfigurationOrgSettingsTrashRegistersRouteImport.update({
    id: '/registers',
    path: '/registers',
    getParentRoute: () => ConsoleOrgIdConfigurationOrgSettingsTrashRouteRoute,
  });
const ConsoleOrgIdConfigurationOrgSettingsUsersIndexRoute =
  ConsoleOrgIdConfigurationOrgSettingsUsersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdConfigurationOrgSettingsUsersRouteRoute,
  });
const ConsoleOrgIdConfigurationVendorManagementSuppliersIndexRoute =
  ConsoleOrgIdConfigurationVendorManagementSuppliersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRoute,
  });
const ConsoleOrgIdConfigurationVendorManagementSuppliersAddRoute =
  ConsoleOrgIdConfigurationVendorManagementSuppliersAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRoute,
  });
const ConsoleOrgIdConfigurationVendorManagementSuppliersDefinitionsRoute =
  ConsoleOrgIdConfigurationVendorManagementSuppliersDefinitionsRouteImport.update(
    {
      id: '/definitions',
      path: '/definitions',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRoute,
    },
  );
const ConsoleOrgIdControlsRegisterDetailsIdRouteRoute =
  ConsoleOrgIdControlsRegisterDetailsIdRouteRouteImport.update({
    id: '/details/$id',
    path: '/details/$id',
    getParentRoute: () => ConsoleOrgIdControlsRegisterRouteRoute,
  });
const ConsoleOrgIdFleetPortalClaimsDetailsClaimIdRoute =
  ConsoleOrgIdFleetPortalClaimsDetailsClaimIdRouteImport.update({
    id: '/details/$claimId',
    path: '/details/$claimId',
    getParentRoute: () => ConsoleOrgIdFleetPortalClaimsRouteRoute,
  });
const ConsoleOrgIdMsprMspExceptionsEditIdRoute =
  ConsoleOrgIdMsprMspExceptionsEditIdRouteImport.update({
    id: '/edit/$id',
    path: '/edit/$id',
    getParentRoute: () => ConsoleOrgIdMsprMspExceptionsRouteRoute,
  });
const ConsoleOrgIdMsprServiceProvidersDetailsIdRouteRoute =
  ConsoleOrgIdMsprServiceProvidersDetailsIdRouteRouteImport.update({
    id: '/details/$id',
    path: '/details/$id',
    getParentRoute: () => ConsoleOrgIdMsprServiceProvidersRouteRoute,
  });
const ConsoleOrgIdMsprServiceProvidersSearchAddRoute =
  ConsoleOrgIdMsprServiceProvidersSearchAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => ConsoleOrgIdMsprServiceProvidersSearchRouteRoute,
  });
const ConsoleOrgIdRiskRasDetailsIdRouteRoute =
  ConsoleOrgIdRiskRasDetailsIdRouteRouteImport.update({
    id: '/details/$id',
    path: '/details/$id',
    getParentRoute: () => ConsoleOrgIdRiskRasRouteRoute,
  });
const ConsoleOrgIdRiskRegisterDetailsIdRouteRoute =
  ConsoleOrgIdRiskRegisterDetailsIdRouteRouteImport.update({
    id: '/details/$id',
    path: '/details/$id',
    getParentRoute: () => ConsoleOrgIdRiskRegisterRouteRoute,
  });
const ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdRoute =
  ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdRouteImport.update({
    id: '/details/$complianceAuditId',
    path: '/details/$complianceAuditId',
    getParentRoute: () => ConsoleOrgIdToolsComplianceAuditRouteRoute,
  });
const ConsoleOrgIdToolsComplianceAuditOverviewIndexRoute =
  ConsoleOrgIdToolsComplianceAuditOverviewIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdToolsComplianceAuditOverviewRouteRoute,
  });
const ConsoleOrgIdToolsComplianceAuditOverviewInsightsRoute =
  ConsoleOrgIdToolsComplianceAuditOverviewInsightsRouteImport.update({
    id: '/insights',
    path: '/insights',
    getParentRoute: () => ConsoleOrgIdToolsComplianceAuditOverviewRouteRoute,
  });
const ConsoleOrgIdToolsComplianceAuditOverviewSearchRouteRoute =
  ConsoleOrgIdToolsComplianceAuditOverviewSearchRouteRouteImport.update({
    id: '/search',
    path: '/search',
    getParentRoute: () => ConsoleOrgIdToolsComplianceAuditOverviewRouteRoute,
  });
const ConsoleOrgIdToolsWebsiteCheckerReportIdRouteRoute =
  ConsoleOrgIdToolsWebsiteCheckerReportIdRouteRouteImport.update({
    id: '/report/$id',
    path: '/report/$id',
    getParentRoute: () => ConsoleOrgIdToolsWebsiteCheckerRouteRoute,
  });
const ConsoleOrgIdWorkloadManagerTasksCalendarAddRoute =
  ConsoleOrgIdWorkloadManagerTasksCalendarAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => ConsoleOrgIdWorkloadManagerTasksCalendarRouteRoute,
  });
const ConsoleOrgIdWorkloadManagerTasksListAddRoute =
  ConsoleOrgIdWorkloadManagerTasksListAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => ConsoleOrgIdWorkloadManagerTasksListRouteRoute,
  });
const PublicClaimLodgementOrgIdPdsVersionIdQuestionnaireIdProductTypeIdRouteRoute =
  PublicClaimLodgementOrgIdPdsVersionIdQuestionnaireIdProductTypeIdRouteRouteImport.update(
    {
      id: '/claim-lodgement/$orgId/$pdsVersionId/$questionnaireId/$productTypeId',
      path: '/claim-lodgement/$orgId/$pdsVersionId/$questionnaireId/$productTypeId',
      getParentRoute: () => PublicRouteRoute,
    },
  );
const ConsoleOrgIdAttestationsRoundsRoundIdPeopleUserIdRoute =
  ConsoleOrgIdAttestationsRoundsRoundIdPeopleUserIdRouteImport.update({
    id: '/people/$userId',
    path: '/people/$userId',
    getParentRoute: () => ConsoleOrgIdAttestationsRoundsRoundIdRouteRoute,
  });
const ConsoleOrgIdClaimsDetailsIdContactsAddRoute =
  ConsoleOrgIdClaimsDetailsIdContactsAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdContactsRouteRoute,
  });
const ConsoleOrgIdClaimsDetailsIdExpensesAddRoute =
  ConsoleOrgIdClaimsDetailsIdExpensesAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdExpensesRouteRoute,
  });
const ConsoleOrgIdComplianceCoiDetailsIdIndexRoute =
  ConsoleOrgIdComplianceCoiDetailsIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdComplianceCoiDetailsIdRouteRoute,
  });
const ConsoleOrgIdComplianceCoiDetailsIdLibraryRoute =
  ConsoleOrgIdComplianceCoiDetailsIdLibraryRouteImport.update({
    id: '/library',
    path: '/library',
    getParentRoute: () => ConsoleOrgIdComplianceCoiDetailsIdRouteRoute,
  });
const ConsoleOrgIdComplianceCoiDetailsIdManageRoute =
  ConsoleOrgIdComplianceCoiDetailsIdManageRouteImport.update({
    id: '/manage',
    path: '/manage',
    getParentRoute: () => ConsoleOrgIdComplianceCoiDetailsIdRouteRoute,
  });
const ConsoleOrgIdComplianceComplaintsDetailsIdIndexRoute =
  ConsoleOrgIdComplianceComplaintsDetailsIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdComplianceComplaintsDetailsIdRouteRoute,
  });
const ConsoleOrgIdComplianceComplaintsDetailsIdCommsRouteRoute =
  ConsoleOrgIdComplianceComplaintsDetailsIdCommsRouteRouteImport.update({
    id: '/comms',
    path: '/comms',
    getParentRoute: () => ConsoleOrgIdComplianceComplaintsDetailsIdRouteRoute,
  });
const ConsoleOrgIdComplianceComplaintsDetailsIdHistoryRouteRoute =
  ConsoleOrgIdComplianceComplaintsDetailsIdHistoryRouteRouteImport.update({
    id: '/history',
    path: '/history',
    getParentRoute: () => ConsoleOrgIdComplianceComplaintsDetailsIdRouteRoute,
  });
const ConsoleOrgIdComplianceComplaintsDetailsIdLibraryRouteRoute =
  ConsoleOrgIdComplianceComplaintsDetailsIdLibraryRouteRouteImport.update({
    id: '/library',
    path: '/library',
    getParentRoute: () => ConsoleOrgIdComplianceComplaintsDetailsIdRouteRoute,
  });
const ConsoleOrgIdComplianceComplaintsDetailsIdManageRouteRoute =
  ConsoleOrgIdComplianceComplaintsDetailsIdManageRouteRouteImport.update({
    id: '/manage',
    path: '/manage',
    getParentRoute: () => ConsoleOrgIdComplianceComplaintsDetailsIdRouteRoute,
  });
const ConsoleOrgIdComplianceIncidentsDetailsIdIndexRoute =
  ConsoleOrgIdComplianceIncidentsDetailsIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdComplianceIncidentsDetailsIdRouteRoute,
  });
const ConsoleOrgIdComplianceIncidentsDetailsIdHistoryRouteRoute =
  ConsoleOrgIdComplianceIncidentsDetailsIdHistoryRouteRouteImport.update({
    id: '/history',
    path: '/history',
    getParentRoute: () => ConsoleOrgIdComplianceIncidentsDetailsIdRouteRoute,
  });
const ConsoleOrgIdComplianceIncidentsDetailsIdLibraryRouteRoute =
  ConsoleOrgIdComplianceIncidentsDetailsIdLibraryRouteRouteImport.update({
    id: '/library',
    path: '/library',
    getParentRoute: () => ConsoleOrgIdComplianceIncidentsDetailsIdRouteRoute,
  });
const ConsoleOrgIdComplianceIncidentsDetailsIdManageRouteRoute =
  ConsoleOrgIdComplianceIncidentsDetailsIdManageRouteRouteImport.update({
    id: '/manage',
    path: '/manage',
    getParentRoute: () => ConsoleOrgIdComplianceIncidentsDetailsIdRouteRoute,
  });
const ConsoleOrgIdComplianceObligationsDetailsIdDebugRoute =
  ConsoleOrgIdComplianceObligationsDetailsIdDebugRouteImport.update({
    id: '/debug',
    path: '/debug',
    getParentRoute: () => ConsoleOrgIdComplianceObligationsDetailsIdRouteRoute,
  });
const ConsoleOrgIdComplianceObligationsDetailsIdManageRoute =
  ConsoleOrgIdComplianceObligationsDetailsIdManageRouteImport.update({
    id: '/manage',
    path: '/manage',
    getParentRoute: () => ConsoleOrgIdComplianceObligationsDetailsIdRouteRoute,
  });
const ConsoleOrgIdComplianceRegistersRegisterIdRecordsRecordIdRoute =
  ConsoleOrgIdComplianceRegistersRegisterIdRecordsRecordIdRouteImport.update({
    id: '/records/$recordId',
    path: '/records/$recordId',
    getParentRoute: () => ConsoleOrgIdComplianceRegistersRegisterIdRouteRoute,
  });
const ConsoleOrgIdComplianceTrainingUserUserIdAddRoute =
  ConsoleOrgIdComplianceTrainingUserUserIdAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => ConsoleOrgIdComplianceTrainingUserUserIdRouteRoute,
  });
const ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsAddRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsAddRouteImport.update(
    {
      id: '/add',
      path: '/add',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsAddRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsRouteRoute,
  });
const ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsIndexRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchRouteRouteImport.update(
    {
      id: '/search',
      path: '/search',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsContactRolesEditContactRoleIdRoute =
  ConsoleOrgIdConfigurationClaimsProductsContactRolesEditContactRoleIdRouteImport.update(
    {
      id: '/edit/$contactRoleId',
      path: '/edit/$contactRoleId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsContactRolesRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsFormsFormDefinitionIdIndexRoute =
  ConsoleOrgIdConfigurationClaimsProductsFormsFormDefinitionIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsFormsFormDefinitionIdRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdAddRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdAddRouteImport.update(
    {
      id: '/add',
      path: '/add',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRouteImport.update(
    {
      id: '/decision-engine',
      path: '/decision-engine',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdRouteRouteImport.update(
    {
      id: '/edit/$productTypeId',
      path: '/edit/$productTypeId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdRouteRouteImport.update(
    {
      id: '/financials/$id',
      path: '/financials/$id',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesStatesIdRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesStatesIdRouteRouteImport.update(
    {
      id: '/states/$id',
      path: '/states/$id',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdRouteRouteImport.update(
    {
      id: '/details/$productId',
      path: '/details/$productId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductsV2RouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsProductsV2EditProductIdRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductsV2EditProductIdRouteImport.update(
    {
      id: '/edit/$productId',
      path: '/edit/$productId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductsV2RouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsQuestionnaireEditQuestionnaireIdRoute =
  ConsoleOrgIdConfigurationClaimsProductsQuestionnaireEditQuestionnaireIdRouteImport.update(
    {
      id: '/edit/$questionnaireId',
      path: '/edit/$questionnaireId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsQuestionnaireRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsAddRoute =
  ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsAddRouteImport.update(
    {
      id: '/add',
      path: '/add',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationComplianceComplaintsFlagsAddRoute =
  ConsoleOrgIdConfigurationComplianceComplaintsFlagsAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationComplianceComplaintsFlagsRouteRoute,
  });
const ConsoleOrgIdConfigurationComplianceComplaintsGeneralIndexRoute =
  ConsoleOrgIdConfigurationComplianceComplaintsGeneralIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationComplianceComplaintsGeneralRouteRoute,
  });
const ConsoleOrgIdConfigurationComplianceComplaintsGeneralLodgementRoute =
  ConsoleOrgIdConfigurationComplianceComplaintsGeneralLodgementRouteImport.update(
    {
      id: '/lodgement',
      path: '/lodgement',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationComplianceComplaintsGeneralRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationComplianceComplaintsGeneralTimelineRouteRoute =
  ConsoleOrgIdConfigurationComplianceComplaintsGeneralTimelineRouteRouteImport.update(
    {
      id: '/timeline',
      path: '/timeline',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationComplianceComplaintsGeneralRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationComplianceIncidentsFlagsAddRoute =
  ConsoleOrgIdConfigurationComplianceIncidentsFlagsAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationComplianceIncidentsFlagsRouteRoute,
  });
const ConsoleOrgIdConfigurationComplianceIncidentsGeneralIndexRoute =
  ConsoleOrgIdConfigurationComplianceIncidentsGeneralIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationComplianceIncidentsGeneralRouteRoute,
  });
const ConsoleOrgIdConfigurationComplianceIncidentsGeneralIncidentDetailsRoute =
  ConsoleOrgIdConfigurationComplianceIncidentsGeneralIncidentDetailsRouteImport.update(
    {
      id: '/incident-details',
      path: '/incident-details',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationComplianceIncidentsGeneralRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationComplianceIncidentsGeneralLodgementRoute =
  ConsoleOrgIdConfigurationComplianceIncidentsGeneralLodgementRouteImport.update(
    {
      id: '/lodgement',
      path: '/lodgement',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationComplianceIncidentsGeneralRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationComplianceIncidentsGeneralRectificationRoute =
  ConsoleOrgIdConfigurationComplianceIncidentsGeneralRectificationRouteImport.update(
    {
      id: '/rectification',
      path: '/rectification',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationComplianceIncidentsGeneralRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationComplianceIncidentsGeneralTimelineRouteRoute =
  ConsoleOrgIdConfigurationComplianceIncidentsGeneralTimelineRouteRouteImport.update(
    {
      id: '/timeline',
      path: '/timeline',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationComplianceIncidentsGeneralRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigAddRoute =
  ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigRouteRoute,
  });
const ConsoleOrgIdConfigurationFinancialsBillingPaymentSuccessRoute =
  ConsoleOrgIdConfigurationFinancialsBillingPaymentSuccessRouteImport.update({
    id: '/payment/success',
    path: '/payment/success',
    getParentRoute: () => ConsoleOrgIdConfigurationFinancialsBillingRouteRoute,
  });
const ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRouteRoute =
  ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRouteRouteImport.update({
    id: '/details/$id',
    path: '/details/$id',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationFleetClientDatabaseRouteRoute,
  });
const ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesAddRoute =
  ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesAddRouteImport.update(
    {
      id: '/add',
      path: '/add',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesAddRoute =
  ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesAddRouteImport.update(
    {
      id: '/add',
      path: '/add',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesDetailsIdRouteRoute =
  ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesDetailsIdRouteRouteImport.update(
    {
      id: '/details/$id',
      path: '/details/$id',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationOrgSettingsUsersDetailsUserIdRouteRoute =
  ConsoleOrgIdConfigurationOrgSettingsUsersDetailsUserIdRouteRouteImport.update(
    {
      id: '/details/$userId',
      path: '/details/$userId',
      getParentRoute: () => ConsoleOrgIdConfigurationOrgSettingsUsersRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationVendorManagementRepairNetworksDetailsIdRouteRoute =
  ConsoleOrgIdConfigurationVendorManagementRepairNetworksDetailsIdRouteRouteImport.update(
    {
      id: '/details/$id',
      path: '/details/$id',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationVendorManagementRepairNetworksRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationVendorManagementSuppliersListIndexRoute =
  ConsoleOrgIdConfigurationVendorManagementSuppliersListIndexRouteImport.update(
    {
      id: '/list/',
      path: '/list/',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationVendorManagementSuppliersSearchIndexRoute =
  ConsoleOrgIdConfigurationVendorManagementSuppliersSearchIndexRouteImport.update(
    {
      id: '/search/',
      path: '/search/',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationVendorManagementSuppliersSearchDefinitionsRoute =
  ConsoleOrgIdConfigurationVendorManagementSuppliersSearchDefinitionsRouteImport.update(
    {
      id: '/search/definitions',
      path: '/search/definitions',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationVendorManagementSuppliersSearchListRoute =
  ConsoleOrgIdConfigurationVendorManagementSuppliersSearchListRouteImport.update(
    {
      id: '/search/list',
      path: '/search/list',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRoute,
    },
  );
const ConsoleOrgIdMsprServiceProvidersDetailsIdHistoryRouteRoute =
  ConsoleOrgIdMsprServiceProvidersDetailsIdHistoryRouteRouteImport.update({
    id: '/history',
    path: '/history',
    getParentRoute: () => ConsoleOrgIdMsprServiceProvidersDetailsIdRouteRoute,
  });
const ConsoleOrgIdMsprServiceProvidersDetailsIdLibraryRouteRoute =
  ConsoleOrgIdMsprServiceProvidersDetailsIdLibraryRouteRouteImport.update({
    id: '/library',
    path: '/library',
    getParentRoute: () => ConsoleOrgIdMsprServiceProvidersDetailsIdRouteRoute,
  });
const ConsoleOrgIdMsprServiceProvidersDetailsIdManageRouteRoute =
  ConsoleOrgIdMsprServiceProvidersDetailsIdManageRouteRouteImport.update({
    id: '/manage',
    path: '/manage',
    getParentRoute: () => ConsoleOrgIdMsprServiceProvidersDetailsIdRouteRoute,
  });
const ConsoleOrgIdRiskRegisterDetailsIdActionPlanRouteRoute =
  ConsoleOrgIdRiskRegisterDetailsIdActionPlanRouteRouteImport.update({
    id: '/action-plan',
    path: '/action-plan',
    getParentRoute: () => ConsoleOrgIdRiskRegisterDetailsIdRouteRoute,
  });
const ConsoleOrgIdRiskRegisterDetailsIdAssessmentRouteRoute =
  ConsoleOrgIdRiskRegisterDetailsIdAssessmentRouteRouteImport.update({
    id: '/assessment',
    path: '/assessment',
    getParentRoute: () => ConsoleOrgIdRiskRegisterDetailsIdRouteRoute,
  });
const ConsoleOrgIdRiskRegisterDetailsIdHistoryRoute =
  ConsoleOrgIdRiskRegisterDetailsIdHistoryRouteImport.update({
    id: '/history',
    path: '/history',
    getParentRoute: () => ConsoleOrgIdRiskRegisterDetailsIdRouteRoute,
  });
const ConsoleOrgIdToolsAutoDetectInboxIdReviewEmailClassificationRoute =
  ConsoleOrgIdToolsAutoDetectInboxIdReviewEmailClassificationRouteImport.update(
    {
      id: '/$id/review-email-classification',
      path: '/$id/review-email-classification',
      getParentRoute: () => ConsoleOrgIdToolsAutoDetectInboxRouteRoute,
    },
  );
const ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdFindDocumentsRoute =
  ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdFindDocumentsRouteImport.update(
    {
      id: '/find-documents',
      path: '/find-documents',
      getParentRoute: () =>
        ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdRoute,
    },
  );
const ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdStatisticsRoute =
  ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdStatisticsRouteImport.update(
    {
      id: '/statistics',
      path: '/statistics',
      getParentRoute: () =>
        ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdRoute,
    },
  );
const ConsoleOrgIdToolsComplianceAuditOverviewSearchAddRoute =
  ConsoleOrgIdToolsComplianceAuditOverviewSearchAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () =>
      ConsoleOrgIdToolsComplianceAuditOverviewSearchRouteRoute,
  });
const ConsoleOrgIdToolsDocumentAnalyzerHistoryIdResultsRoute =
  ConsoleOrgIdToolsDocumentAnalyzerHistoryIdResultsRouteImport.update({
    id: '/$id/results',
    path: '/$id/results',
    getParentRoute: () => ConsoleOrgIdToolsDocumentAnalyzerHistoryRouteRoute,
  });
const ConsoleOrgIdToolsPdsComparePdsDocumentsEditIdRoute =
  ConsoleOrgIdToolsPdsComparePdsDocumentsEditIdRouteImport.update({
    id: '/edit/$id',
    path: '/edit/$id',
    getParentRoute: () => ConsoleOrgIdToolsPdsComparePdsDocumentsRouteRoute,
  });
const ConsoleOrgIdWorkloadManagerTasksCalendarDetailsIdRoute =
  ConsoleOrgIdWorkloadManagerTasksCalendarDetailsIdRouteImport.update({
    id: '/details/$id',
    path: '/details/$id',
    getParentRoute: () => ConsoleOrgIdWorkloadManagerTasksCalendarRouteRoute,
  });
const ConsoleOrgIdWorkloadManagerTasksListDetailsIdRoute =
  ConsoleOrgIdWorkloadManagerTasksListDetailsIdRouteImport.update({
    id: '/details/$id',
    path: '/details/$id',
    getParentRoute: () => ConsoleOrgIdWorkloadManagerTasksListRouteRoute,
  });
const PublicOrgIdClaimLodgementLookupPdsVersionIdQuestionnaireIdProductTypeIdRouteRoute =
  PublicOrgIdClaimLodgementLookupPdsVersionIdQuestionnaireIdProductTypeIdRouteRouteImport.update(
    {
      id: '/claim/lodgement-lookup/$pdsVersionId/$questionnaireId/$productTypeId',
      path: '/claim/lodgement-lookup/$pdsVersionId/$questionnaireId/$productTypeId',
      getParentRoute: () => PublicOrgIdRouteRoute,
    },
  );
const PublicOrgIdClaimLodgementPdsVersionIdQuestionnaireIdProductTypeIdRouteRoute =
  PublicOrgIdClaimLodgementPdsVersionIdQuestionnaireIdProductTypeIdRouteRouteImport.update(
    {
      id: '/claim/lodgement/$pdsVersionId/$questionnaireId/$productTypeId',
      path: '/claim/lodgement/$pdsVersionId/$questionnaireId/$productTypeId',
      getParentRoute: () => PublicOrgIdRouteRoute,
    },
  );
const ConsoleOrgIdClaimsDetailsIdActivityAddPhoneRoute =
  ConsoleOrgIdClaimsDetailsIdActivityAddPhoneRouteImport.update({
    id: '/add/phone',
    path: '/add/phone',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdActivityRouteRoute,
  });
const ConsoleOrgIdClaimsDetailsIdCommsMessageMessageIdRouteRoute =
  ConsoleOrgIdClaimsDetailsIdCommsMessageMessageIdRouteRouteImport.update({
    id: '/message/$messageId',
    path: '/message/$messageId',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdCommsRouteRoute,
  });
const ConsoleOrgIdClaimsDetailsIdCommsReplyMessageIdRouteRoute =
  ConsoleOrgIdClaimsDetailsIdCommsReplyMessageIdRouteRouteImport.update({
    id: '/reply/$messageId',
    path: '/reply/$messageId',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdCommsRouteRoute,
  });
const ConsoleOrgIdClaimsDetailsIdContactsEditContactIdRoute =
  ConsoleOrgIdClaimsDetailsIdContactsEditContactIdRouteImport.update({
    id: '/edit/$contactId',
    path: '/edit/$contactId',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdContactsRouteRoute,
  });
const ConsoleOrgIdClaimsDetailsIdExpensesEditExpenseItemIdRoute =
  ConsoleOrgIdClaimsDetailsIdExpensesEditExpenseItemIdRouteImport.update({
    id: '/edit/$expenseItemId',
    path: '/edit/$expenseItemId',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdExpensesRouteRoute,
  });
const ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddRouteRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddRouteRouteImport.update({
    id: '/compensations/add',
    path: '/compensations/add',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdFinancialsRouteRoute,
  });
const ConsoleOrgIdClaimsDetailsIdFinancialsExcessesAddRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsExcessesAddRouteImport.update({
    id: '/excesses/add',
    path: '/excesses/add',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdFinancialsRouteRoute,
  });
const ConsoleOrgIdClaimsDetailsIdFinancialsPaymentsCompensationIdRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsPaymentsCompensationIdRouteImport.update(
    {
      id: '/payments/$compensationId',
      path: '/payments/$compensationId',
      getParentRoute: () => ConsoleOrgIdClaimsDetailsIdFinancialsRouteRoute,
    },
  );
const ConsoleOrgIdClaimsDetailsIdFinancialsPaymentsAddRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsPaymentsAddRouteImport.update({
    id: '/payments/add',
    path: '/payments/add',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdFinancialsRouteRoute,
  });
const ConsoleOrgIdClaimsDetailsIdFinancialsReserveChangesRequestIdRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsReserveChangesRequestIdRouteImport.update(
    {
      id: '/reserve-changes/$requestId',
      path: '/reserve-changes/$requestId',
      getParentRoute: () => ConsoleOrgIdClaimsDetailsIdFinancialsRouteRoute,
    },
  );
const ConsoleOrgIdClaimsDetailsIdFinancialsReservesAddRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsReservesAddRouteImport.update({
    id: '/reserves/add',
    path: '/reserves/add',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdFinancialsRouteRoute,
  });
const ConsoleOrgIdClaimsDetailsIdLibraryPaymentsCompensationIdRoute =
  ConsoleOrgIdClaimsDetailsIdLibraryPaymentsCompensationIdRouteImport.update({
    id: '/payments/$compensationId',
    path: '/payments/$compensationId',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdLibraryRouteRoute,
  });
const ConsoleOrgIdClaimsDetailsIdManageStrategiesAddRouteRoute =
  ConsoleOrgIdClaimsDetailsIdManageStrategiesAddRouteRouteImport.update({
    id: '/strategies/add',
    path: '/strategies/add',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdManageRouteRoute,
  });
const ConsoleOrgIdClaimsDetailsIdManageSupplierJobsAddRoute =
  ConsoleOrgIdClaimsDetailsIdManageSupplierJobsAddRouteImport.update({
    id: '/supplier-jobs/add',
    path: '/supplier-jobs/add',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdManageRouteRoute,
  });
const ConsoleOrgIdClaimsDetailsIdManageSupplierJobsAddSupplierRoute =
  ConsoleOrgIdClaimsDetailsIdManageSupplierJobsAddSupplierRouteImport.update({
    id: '/supplier-jobs/add-supplier',
    path: '/supplier-jobs/add-supplier',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdManageRouteRoute,
  });
const ConsoleOrgIdClaimsDetailsIdVehicleReportInspectionIdRoute =
  ConsoleOrgIdClaimsDetailsIdVehicleReportInspectionIdRouteImport.update({
    id: '/report/$inspectionId',
    path: '/report/$inspectionId',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdVehicleRouteRoute,
  });
const ConsoleOrgIdComplianceComplaintsDetailsIdManageIncidentsRoute =
  ConsoleOrgIdComplianceComplaintsDetailsIdManageIncidentsRouteImport.update({
    id: '/incidents',
    path: '/incidents',
    getParentRoute: () =>
      ConsoleOrgIdComplianceComplaintsDetailsIdManageRouteRoute,
  });
const ConsoleOrgIdComplianceIncidentsDetailsIdManageComplaintsRoute =
  ConsoleOrgIdComplianceIncidentsDetailsIdManageComplaintsRouteImport.update({
    id: '/complaints',
    path: '/complaints',
    getParentRoute: () =>
      ConsoleOrgIdComplianceIncidentsDetailsIdManageRouteRoute,
  });
const ConsoleOrgIdComplianceTrainingUserUserIdEditRecordIdRoute =
  ConsoleOrgIdComplianceTrainingUserUserIdEditRecordIdRouteImport.update({
    id: '/edit/$recordId',
    path: '/edit/$recordId',
    getParentRoute: () => ConsoleOrgIdComplianceTrainingUserUserIdRouteRoute,
  });
const ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsEditCatastropheEventIdRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsEditCatastropheEventIdRouteImport.update(
    {
      id: '/edit/$catastropheEventId',
      path: '/edit/$catastropheEventId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsEditClaimFlagIdRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsEditClaimFlagIdRouteImport.update(
    {
      id: '/edit/$claimFlagId',
      path: '/edit/$claimFlagId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsClaimsClaimsAuthorityInsurerLimitsAddRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsClaimsAuthorityInsurerLimitsAddRouteImport.update(
    {
      id: '/insurer-limits/add',
      path: '/insurer-limits/add',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsClaimsClaimsAuthorityRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsClaimsClaimsAuthorityLevelsAddRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsClaimsAuthorityLevelsAddRouteImport.update(
    {
      id: '/levels/add',
      path: '/levels/add',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsClaimsClaimsAuthorityRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralClaimStatusesAddRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralClaimStatusesAddRouteImport.update(
    {
      id: '/claim-statuses/add',
      path: '/claim-statuses/add',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchAddRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchAddRouteImport.update(
    {
      id: '/add',
      path: '/add',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineConditionsRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineConditionsRouteImport.update(
    {
      id: '/conditions',
      path: '/conditions',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineExclusionsRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineExclusionsRouteImport.update(
    {
      id: '/exclusions',
      path: '/exclusions',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineGuideRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineGuideRouteImport.update(
    {
      id: '/guide',
      path: '/guide',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineLimitsExcessesRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineLimitsExcessesRouteImport.update(
    {
      id: '/limits-excesses',
      path: '/limits-excesses',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineLossCausesRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineLossCausesRouteImport.update(
    {
      id: '/loss-causes',
      path: '/loss-causes',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineOverviewRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineOverviewRouteImport.update(
    {
      id: '/overview',
      path: '/overview',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEnginePolicyTriggerMappingRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEnginePolicyTriggerMappingRouteImport.update(
    {
      id: '/policy-trigger-mapping',
      path: '/policy-trigger-mapping',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineProductInfoRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineProductInfoRouteImport.update(
    {
      id: '/product-info',
      path: '/product-info',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRedFlagsRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRedFlagsRouteImport.update(
    {
      id: '/red-flags',
      path: '/red-flags',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdEditPdsIdRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdEditPdsIdRouteImport.update(
    {
      id: '/edit/$pdsId',
      path: '/edit/$pdsId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdPdsTextPdsIdRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdPdsTextPdsIdRouteImport.update(
    {
      id: '/pds-text/$pdsId',
      path: '/pds-text/$pdsId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdPdsPdsIdRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdPdsPdsIdRouteRouteImport.update(
    {
      id: '/pds/$pdsId',
      path: '/pds/$pdsId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdDataFieldsRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdDataFieldsRouteImport.update(
    {
      id: '/data-fields',
      path: '/data-fields',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdPolicyFieldsRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdPolicyFieldsRouteImport.update(
    {
      id: '/policy-fields',
      path: '/policy-fields',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeRouteRouteImport.update(
    {
      id: '/third-party-contact-type',
      path: '/third-party-contact-type',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdCostCodesRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdCostCodesRouteImport.update(
    {
      id: '/cost-codes',
      path: '/cost-codes',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdSectionsRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdSectionsRouteImport.update(
    {
      id: '/sections',
      path: '/sections',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTaxRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTaxRouteImport.update(
    {
      id: '/tax',
      path: '/tax',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesRouteRouteImport.update(
    {
      id: '/transaction-types',
      path: '/transaction-types',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdLodgementLinksRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdLodgementLinksRouteRouteImport.update(
    {
      id: '/lodgement-links',
      path: '/lodgement-links',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsEditIdRouteRoute =
  ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsEditIdRouteRouteImport.update(
    {
      id: '/edit/$id',
      path: '/edit/$id',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationComplianceComplaintsFlagsEditComplaintFlagIdRoute =
  ConsoleOrgIdConfigurationComplianceComplaintsFlagsEditComplaintFlagIdRouteImport.update(
    {
      id: '/edit/$complaintFlagId',
      path: '/edit/$complaintFlagId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationComplianceComplaintsFlagsRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationComplianceIncidentsFlagsEditIncidentFlagIdRoute =
  ConsoleOrgIdConfigurationComplianceIncidentsFlagsEditIncidentFlagIdRouteImport.update(
    {
      id: '/edit/$incidentFlagId',
      path: '/edit/$incidentFlagId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationComplianceIncidentsFlagsRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsIdentifiedAddRoute =
  ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsIdentifiedAddRouteImport.update(
    {
      id: '/identified/add',
      path: '/identified/add',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationComplianceMsprDefinitionsCategoriesAddRoute =
  ConsoleOrgIdConfigurationComplianceMsprDefinitionsCategoriesAddRouteImport.update(
    {
      id: '/categories/add',
      path: '/categories/add',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationComplianceMsprDefinitionsRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigEditIdRoute =
  ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigEditIdRouteImport.update(
    {
      id: '/edit/$id',
      path: '/edit/$id',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdClientsRoute =
  ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdClientsRouteImport.update(
    {
      id: '/clients',
      path: '/clients',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdDriversRoute =
  ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdDriversRouteImport.update(
    {
      id: '/drivers',
      path: '/drivers',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdHistoryRoute =
  ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdHistoryRouteImport.update(
    {
      id: '/history',
      path: '/history',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdOverviewRoute =
  ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdOverviewRouteImport.update(
    {
      id: '/overview',
      path: '/overview',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdPortalAccessRoute =
  ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdPortalAccessRouteImport.update(
    {
      id: '/portal-access',
      path: '/portal-access',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRepairersRoute =
  ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRepairersRouteImport.update(
    {
      id: '/repairers',
      path: '/repairers',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdVehiclesRoute =
  ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdVehiclesRouteImport.update(
    {
      id: '/vehicles',
      path: '/vehicles',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesEditCommSignatureIdRoute =
  ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesEditCommSignatureIdRouteImport.update(
    {
      id: '/edit/$commSignatureId',
      path: '/edit/$commSignatureId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesEditCommunicationTemplateIdRoute =
  ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesEditCommunicationTemplateIdRouteImport.update(
    {
      id: '/edit/$communicationTemplateId',
      path: '/edit/$communicationTemplateId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesDetailsIdUsersRoute =
  ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesDetailsIdUsersRouteImport.update(
    {
      id: '/users',
      path: '/users',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesDetailsIdRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationVendorManagementRepairNetworksDetailsIdClientsRoute =
  ConsoleOrgIdConfigurationVendorManagementRepairNetworksDetailsIdClientsRouteImport.update(
    {
      id: '/clients',
      path: '/clients',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationVendorManagementRepairNetworksDetailsIdRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationVendorManagementRepairNetworksDetailsIdMembersRoute =
  ConsoleOrgIdConfigurationVendorManagementRepairNetworksDetailsIdMembersRouteImport.update(
    {
      id: '/members',
      path: '/members',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationVendorManagementRepairNetworksDetailsIdRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationVendorManagementRepairNetworksDetailsIdOverviewRoute =
  ConsoleOrgIdConfigurationVendorManagementRepairNetworksDetailsIdOverviewRouteImport.update(
    {
      id: '/overview',
      path: '/overview',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationVendorManagementRepairNetworksDetailsIdRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationVendorManagementSuppliersDetailsIdIndexRoute =
  ConsoleOrgIdConfigurationVendorManagementSuppliersDetailsIdIndexRouteImport.update(
    {
      id: '/details/$id/',
      path: '/details/$id/',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationVendorManagementSuppliersDetailsIdSplatRoute =
  ConsoleOrgIdConfigurationVendorManagementSuppliersDetailsIdSplatRouteImport.update(
    {
      id: '/details/$id/$',
      path: '/details/$id/$',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdRouteRoute =
  ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdRouteRouteImport.update(
    {
      id: '/list/details/$id',
      path: '/list/details/$id',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRoute,
    },
  );
const ConsoleOrgIdControlsRegisterDetailsIdActivityActivityIdRouteRoute =
  ConsoleOrgIdControlsRegisterDetailsIdActivityActivityIdRouteRouteImport.update(
    {
      id: '/activity/$activityId',
      path: '/activity/$activityId',
      getParentRoute: () => ConsoleOrgIdControlsRegisterDetailsIdRouteRoute,
    },
  );
const ConsoleOrgIdControlsRegisterDetailsIdActivityAddRouteRoute =
  ConsoleOrgIdControlsRegisterDetailsIdActivityAddRouteRouteImport.update({
    id: '/activity/add',
    path: '/activity/add',
    getParentRoute: () => ConsoleOrgIdControlsRegisterDetailsIdRouteRoute,
  });
const ConsoleOrgIdControlsRegisterDetailsIdTestTestIdRouteRoute =
  ConsoleOrgIdControlsRegisterDetailsIdTestTestIdRouteRouteImport.update({
    id: '/test/$testId',
    path: '/test/$testId',
    getParentRoute: () => ConsoleOrgIdControlsRegisterDetailsIdRouteRoute,
  });
const ConsoleOrgIdControlsRegisterDetailsIdTestAddRouteRoute =
  ConsoleOrgIdControlsRegisterDetailsIdTestAddRouteRouteImport.update({
    id: '/test/add',
    path: '/test/add',
    getParentRoute: () => ConsoleOrgIdControlsRegisterDetailsIdRouteRoute,
  });
const ConsoleOrgIdMsprServiceProvidersDetailsIdManageAddRoute =
  ConsoleOrgIdMsprServiceProvidersDetailsIdManageAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () =>
      ConsoleOrgIdMsprServiceProvidersDetailsIdManageRouteRoute,
  });
const ConsoleOrgIdRiskRegisterDetailsIdAssessmentIncidentsRoute =
  ConsoleOrgIdRiskRegisterDetailsIdAssessmentIncidentsRouteImport.update({
    id: '/incidents',
    path: '/incidents',
    getParentRoute: () => ConsoleOrgIdRiskRegisterDetailsIdAssessmentRouteRoute,
  });
const ConsoleOrgIdWorkloadManagerTasksCalendarDetailsControl_activityIdRoute =
  ConsoleOrgIdWorkloadManagerTasksCalendarDetailsControl_activityIdRouteImport.update(
    {
      id: '/details/control_activity/$id',
      path: '/details/control_activity/$id',
      getParentRoute: () => ConsoleOrgIdWorkloadManagerTasksCalendarRouteRoute,
    },
  );
const ConsoleOrgIdWorkloadManagerTasksCalendarDetailsControl_testIdRoute =
  ConsoleOrgIdWorkloadManagerTasksCalendarDetailsControl_testIdRouteImport.update(
    {
      id: '/details/control_test/$id',
      path: '/details/control_test/$id',
      getParentRoute: () => ConsoleOrgIdWorkloadManagerTasksCalendarRouteRoute,
    },
  );
const ConsoleOrgIdWorkloadManagerTasksCalendarDetailsMsp_governance_checkIdRoute =
  ConsoleOrgIdWorkloadManagerTasksCalendarDetailsMsp_governance_checkIdRouteImport.update(
    {
      id: '/details/msp_governance_check/$id',
      path: '/details/msp_governance_check/$id',
      getParentRoute: () => ConsoleOrgIdWorkloadManagerTasksCalendarRouteRoute,
    },
  );
const ConsoleOrgIdWorkloadManagerTasksCalendarDetailsRisk_actionIdRoute =
  ConsoleOrgIdWorkloadManagerTasksCalendarDetailsRisk_actionIdRouteImport.update(
    {
      id: '/details/risk_action/$id',
      path: '/details/risk_action/$id',
      getParentRoute: () => ConsoleOrgIdWorkloadManagerTasksCalendarRouteRoute,
    },
  );
const ConsoleOrgIdClaimsDetailsIdActivityEditPhoneCallLogIdRoute =
  ConsoleOrgIdClaimsDetailsIdActivityEditPhoneCallLogIdRouteImport.update({
    id: '/edit/phone/$callLogId',
    path: '/edit/phone/$callLogId',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdActivityRouteRoute,
  });
const ConsoleOrgIdClaimsDetailsIdContactsSuppliersDetailsSupplierIdRoute =
  ConsoleOrgIdClaimsDetailsIdContactsSuppliersDetailsSupplierIdRouteImport.update(
    {
      id: '/suppliers/details/$supplierId',
      path: '/suppliers/details/$supplierId',
      getParentRoute: () => ConsoleOrgIdClaimsDetailsIdContactsRouteRoute,
    },
  );
const ConsoleOrgIdClaimsDetailsIdContactsSuppliersReassignSupplierIdRouteRoute =
  ConsoleOrgIdClaimsDetailsIdContactsSuppliersReassignSupplierIdRouteRouteImport.update(
    {
      id: '/suppliers/reassign/$supplierId',
      path: '/suppliers/reassign/$supplierId',
      getParentRoute: () => ConsoleOrgIdClaimsDetailsIdContactsRouteRoute,
    },
  );
const ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdRouteRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdRouteRouteImport.update(
    {
      id: '/compensations/details/$compensationId',
      path: '/compensations/details/$compensationId',
      getParentRoute: () => ConsoleOrgIdClaimsDetailsIdFinancialsRouteRoute,
    },
  );
const ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdRouteRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdRouteRouteImport.update(
    {
      id: '/excesses/details/$excessId',
      path: '/excesses/details/$excessId',
      getParentRoute: () => ConsoleOrgIdClaimsDetailsIdFinancialsRouteRoute,
    },
  );
const ConsoleOrgIdClaimsDetailsIdFinancialsPaymentsCorrectCompensationIdRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsPaymentsCorrectCompensationIdRouteImport.update(
    {
      id: '/payments/correct/$compensationId',
      path: '/payments/correct/$compensationId',
      getParentRoute: () => ConsoleOrgIdClaimsDetailsIdFinancialsRouteRoute,
    },
  );
const ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdRouteRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdRouteRouteImport.update(
    {
      id: '/reserves/details/$reserveId',
      path: '/reserves/details/$reserveId',
      getParentRoute: () => ConsoleOrgIdClaimsDetailsIdFinancialsRouteRoute,
    },
  );
const ConsoleOrgIdClaimsDetailsIdManageSupplierJobsEditJobIdRoute =
  ConsoleOrgIdClaimsDetailsIdManageSupplierJobsEditJobIdRouteImport.update({
    id: '/supplier-jobs/edit/$jobId',
    path: '/supplier-jobs/edit/$jobId',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdManageRouteRoute,
  });
const ConsoleOrgIdComplianceComplaintsDetailsIdManageNoteAddRouteRoute =
  ConsoleOrgIdComplianceComplaintsDetailsIdManageNoteAddRouteRouteImport.update(
    {
      id: '/note/add',
      path: '/note/add',
      getParentRoute: () =>
        ConsoleOrgIdComplianceComplaintsDetailsIdManageRouteRoute,
    },
  );
const ConsoleOrgIdComplianceIncidentsDetailsIdManageNoteAddRouteRoute =
  ConsoleOrgIdComplianceIncidentsDetailsIdManageNoteAddRouteRouteImport.update({
    id: '/note/add',
    path: '/note/add',
    getParentRoute: () =>
      ConsoleOrgIdComplianceIncidentsDetailsIdManageRouteRoute,
  });
const ConsoleOrgIdConfigurationClaimsProductsClaimsClaimsAuthorityLevelsEditLevelIdRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsClaimsAuthorityLevelsEditLevelIdRouteImport.update(
    {
      id: '/levels/edit/$levelId',
      path: '/levels/edit/$levelId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsClaimsClaimsAuthorityRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsClaimsClaimsAuthorityPeopleEditUserIdRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsClaimsAuthorityPeopleEditUserIdRouteImport.update(
    {
      id: '/people/edit/$userId',
      path: '/people/edit/$userId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsClaimsClaimsAuthorityRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralClaimStatusesEditClaimStatusIdRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralClaimStatusesEditClaimStatusIdRouteImport.update(
    {
      id: '/claim-statuses/edit/$claimStatusId',
      path: '/claim-statuses/edit/$claimStatusId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksRouteRouteImport.update(
    {
      id: '/$taskListId/tasks',
      path: '/$taskListId/tasks',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchEditIdRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchEditIdRouteImport.update(
    {
      id: '/edit/$id',
      path: '/edit/$id',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeAddRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeAddRouteImport.update(
    {
      id: '/add',
      path: '/add',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesAddRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesAddRouteImport.update(
    {
      id: '/add',
      path: '/add',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationComplianceComplaintsGeneralTimelineMilestonesAddRoute =
  ConsoleOrgIdConfigurationComplianceComplaintsGeneralTimelineMilestonesAddRouteImport.update(
    {
      id: '/milestones/add',
      path: '/milestones/add',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationComplianceComplaintsGeneralTimelineRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationComplianceIncidentsGeneralTimelineMilestonesAddRoute =
  ConsoleOrgIdConfigurationComplianceIncidentsGeneralTimelineMilestonesAddRouteImport.update(
    {
      id: '/milestones/add',
      path: '/milestones/add',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationComplianceIncidentsGeneralTimelineRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsExcludedEditIdRoute =
  ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsExcludedEditIdRouteImport.update(
    {
      id: '/excluded/edit/$id',
      path: '/excluded/edit/$id',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsIdentifiedEditIdRoute =
  ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsIdentifiedEditIdRouteImport.update(
    {
      id: '/identified/edit/$id',
      path: '/identified/edit/$id',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationComplianceMsprDefinitionsCategoriesEditIdRoute =
  ConsoleOrgIdConfigurationComplianceMsprDefinitionsCategoriesEditIdRouteImport.update(
    {
      id: '/categories/edit/$id',
      path: '/categories/edit/$id',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationComplianceMsprDefinitionsRouteRoute,
    },
  );
const ConsoleOrgIdMsprServiceProvidersDetailsIdManageCheckCheckIdRouteRoute =
  ConsoleOrgIdMsprServiceProvidersDetailsIdManageCheckCheckIdRouteRouteImport.update(
    {
      id: '/check/$checkId',
      path: '/check/$checkId',
      getParentRoute: () =>
        ConsoleOrgIdMsprServiceProvidersDetailsIdManageRouteRoute,
    },
  );
const ConsoleOrgIdMsprServiceProvidersDetailsIdManageCheckAddRouteRoute =
  ConsoleOrgIdMsprServiceProvidersDetailsIdManageCheckAddRouteRouteImport.update(
    {
      id: '/check/add',
      path: '/check/add',
      getParentRoute: () =>
        ConsoleOrgIdMsprServiceProvidersDetailsIdManageRouteRoute,
    },
  );
const ConsoleOrgIdMsprServiceProvidersDetailsIdManageEditArrangementIdRoute =
  ConsoleOrgIdMsprServiceProvidersDetailsIdManageEditArrangementIdRouteImport.update(
    {
      id: '/edit/$arrangementId',
      path: '/edit/$arrangementId',
      getParentRoute: () =>
        ConsoleOrgIdMsprServiceProvidersDetailsIdManageRouteRoute,
    },
  );
const ConsoleOrgIdRiskRegisterDetailsIdActionPlanActionPlanActionPlanIdRouteRoute =
  ConsoleOrgIdRiskRegisterDetailsIdActionPlanActionPlanActionPlanIdRouteRouteImport.update(
    {
      id: '/action-plan/$actionPlanId',
      path: '/action-plan/$actionPlanId',
      getParentRoute: () =>
        ConsoleOrgIdRiskRegisterDetailsIdActionPlanRouteRoute,
    },
  );
const ConsoleOrgIdRiskRegisterDetailsIdActionPlanActionPlanAddRouteRoute =
  ConsoleOrgIdRiskRegisterDetailsIdActionPlanActionPlanAddRouteRouteImport.update(
    {
      id: '/action-plan/add',
      path: '/action-plan/add',
      getParentRoute: () =>
        ConsoleOrgIdRiskRegisterDetailsIdActionPlanRouteRoute,
    },
  );
const ConsoleOrgIdClaimsDetailsIdContactsSuppliersReassignSupplierIdAddRoute =
  ConsoleOrgIdClaimsDetailsIdContactsSuppliersReassignSupplierIdAddRouteImport.update(
    {
      id: '/add',
      path: '/add',
      getParentRoute: () =>
        ConsoleOrgIdClaimsDetailsIdContactsSuppliersReassignSupplierIdRouteRoute,
    },
  );
const ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddCompensationPaymentsAddRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddCompensationPaymentsAddRouteImport.update(
    {
      id: '/compensation-payments/add',
      path: '/compensation-payments/add',
      getParentRoute: () =>
        ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddRouteRoute,
    },
  );
const ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddExcessPaymentsAddRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddExcessPaymentsAddRouteImport.update(
    {
      id: '/excess-payments/add',
      path: '/excess-payments/add',
      getParentRoute: () =>
        ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddRouteRoute,
    },
  );
const ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddSuppliersAddRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddSuppliersAddRouteImport.update(
    {
      id: '/suppliers/add',
      path: '/suppliers/add',
      getParentRoute: () =>
        ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddRouteRoute,
    },
  );
const ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsRouteRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsRouteRouteImport.update(
    {
      id: '/financials',
      path: '/financials',
      getParentRoute: () =>
        ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdRouteRoute,
    },
  );
const ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdLibraryRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdLibraryRouteImport.update(
    {
      id: '/library',
      path: '/library',
      getParentRoute: () =>
        ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdRouteRoute,
    },
  );
const ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdPayeeRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdPayeeRouteImport.update(
    {
      id: '/payee',
      path: '/payee',
      getParentRoute: () =>
        ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdRouteRoute,
    },
  );
const ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdPaymentRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdPaymentRouteImport.update(
    {
      id: '/payment',
      path: '/payment',
      getParentRoute: () =>
        ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdRouteRoute,
    },
  );
const ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdLibraryRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdLibraryRouteImport.update(
    {
      id: '/library',
      path: '/library',
      getParentRoute: () =>
        ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdRouteRoute,
    },
  );
const ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdManageRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdManageRouteImport.update(
    {
      id: '/manage',
      path: '/manage',
      getParentRoute: () =>
        ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdRouteRoute,
    },
  );
const ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdPaymentsRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdPaymentsRouteImport.update(
    {
      id: '/payments',
      path: '/payments',
      getParentRoute: () =>
        ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdRouteRoute,
    },
  );
const ConsoleOrgIdClaimsDetailsIdFinancialsPaymentsAddContactsAddRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsPaymentsAddContactsAddRouteImport.update(
    {
      id: '/contacts/add',
      path: '/contacts/add',
      getParentRoute: () =>
        ConsoleOrgIdClaimsDetailsIdFinancialsPaymentsAddRoute,
    },
  );
const ConsoleOrgIdClaimsDetailsIdFinancialsPaymentsAddSuppliersAddRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsPaymentsAddSuppliersAddRouteImport.update(
    {
      id: '/suppliers/add',
      path: '/suppliers/add',
      getParentRoute: () =>
        ConsoleOrgIdClaimsDetailsIdFinancialsPaymentsAddRoute,
    },
  );
const ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdCompensationPaymentsRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdCompensationPaymentsRouteImport.update(
    {
      id: '/compensation-payments',
      path: '/compensation-payments',
      getParentRoute: () =>
        ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdRouteRoute,
    },
  );
const ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdLibraryRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdLibraryRouteImport.update(
    {
      id: '/library',
      path: '/library',
      getParentRoute: () =>
        ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdRouteRoute,
    },
  );
const ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdReserveAdjustmentsRouteRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdReserveAdjustmentsRouteRouteImport.update(
    {
      id: '/reserve-adjustments',
      path: '/reserve-adjustments',
      getParentRoute: () =>
        ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsClaimsClaimsAuthorityInsurerLimitsEditInsurerIdProductTypeIdRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsClaimsAuthorityInsurerLimitsEditInsurerIdProductTypeIdRouteImport.update(
    {
      id: '/insurer-limits/edit/$insurerId/$productTypeId',
      path: '/insurer-limits/edit/$insurerId/$productTypeId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsClaimsClaimsAuthorityRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksAddRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksAddRouteImport.update(
    {
      id: '/add',
      path: '/add',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeEditThirdPartyContactTypeIdRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeEditThirdPartyContactTypeIdRouteImport.update(
    {
      id: '/edit/$thirdPartyContactTypeId',
      path: '/edit/$thirdPartyContactTypeId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesEditTransactionTypeIdRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesEditTransactionTypeIdRouteImport.update(
    {
      id: '/edit/$transactionTypeId',
      path: '/edit/$transactionTypeId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdRouteRouteImport.update(
    {
      id: '/product-versions/details/$productVersionId',
      path: '/product-versions/details/$productVersionId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationComplianceComplaintsGeneralTimelineMilestonesEditInternalNameRoute =
  ConsoleOrgIdConfigurationComplianceComplaintsGeneralTimelineMilestonesEditInternalNameRouteImport.update(
    {
      id: '/milestones/edit/$internalName',
      path: '/milestones/edit/$internalName',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationComplianceComplaintsGeneralTimelineRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationComplianceIncidentsGeneralTimelineMilestonesEditInternalNameRoute =
  ConsoleOrgIdConfigurationComplianceIncidentsGeneralTimelineMilestonesEditInternalNameRouteImport.update(
    {
      id: '/milestones/edit/$internalName',
      path: '/milestones/edit/$internalName',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationComplianceIncidentsGeneralTimelineRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdContactsAddRoute =
  ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdContactsAddRouteImport.update(
    {
      id: '/contacts/add',
      path: '/contacts/add',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdRouteRoute,
    },
  );
const ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdReserveAdjustmentsAddRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdReserveAdjustmentsAddRouteImport.update(
    {
      id: '/add',
      path: '/add',
      getParentRoute: () =>
        ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdReserveAdjustmentsRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksEditIdRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksEditIdRouteImport.update(
    {
      id: '/edit/$id',
      path: '/edit/$id',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesRouteRouteImport.update(
    {
      id: '/contact-types',
      path: '/contact-types',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdDetailsRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdDetailsRouteImport.update(
    {
      id: '/details',
      path: '/details',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdDocumentsRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdDocumentsRouteImport.update(
    {
      id: '/documents',
      path: '/documents',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdFieldsRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdFieldsRouteImport.update(
    {
      id: '/fields',
      path: '/fields',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdContactsEditContactIdRoute =
  ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdContactsEditContactIdRouteImport.update(
    {
      id: '/contacts/edit/$contactId',
      path: '/contacts/edit/$contactId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesAddRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesAddRouteImport.update(
    {
      id: '/add',
      path: '/add',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesRouteRoute,
    },
  );
const ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsCompensationPaymentsDetailsCompensationPaymentIdRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsCompensationPaymentsDetailsCompensationPaymentIdRouteImport.update(
    {
      id: '/compensation-payments/details/$compensationPaymentId',
      path: '/compensation-payments/details/$compensationPaymentId',
      getParentRoute: () =>
        ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsRouteRoute,
    },
  );
const ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsExcessPaymentsDetailsExcessPaymentIdRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsExcessPaymentsDetailsExcessPaymentIdRouteImport.update(
    {
      id: '/excess-payments/details/$excessPaymentId',
      path: '/excess-payments/details/$excessPaymentId',
      getParentRoute: () =>
        ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsRouteRoute,
    },
  );
const ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesEditContactTypeIdRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesEditContactTypeIdRouteImport.update(
    {
      id: '/edit/$contactTypeId',
      path: '/edit/$contactTypeId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesRouteRoute,
    },
  );

const AttestationRouteRouteChildren = {
  AttestationTokenRoute: AttestationTokenRoute,
};

const AttestationRouteRouteWithChildren =
  AttestationRouteRoute._addFileChildren(AttestationRouteRouteChildren);

const LodgeRouteRouteChildren = {
  LodgeKeyRouteRoute: LodgeKeyRouteRoute,
  LodgeResumePublicIdRouteRoute: LodgeResumePublicIdRouteRoute,
  LodgeSummaryPublicIdRouteRoute: LodgeSummaryPublicIdRouteRoute,
};

const LodgeRouteRouteWithChildren = LodgeRouteRoute._addFileChildren(
  LodgeRouteRouteChildren,
);

const OauthRouteRouteChildren = {
  OauthAuthorizeRoute: OauthAuthorizeRoute,
};

const OauthRouteRouteWithChildren = OauthRouteRoute._addFileChildren(
  OauthRouteRouteChildren,
);

const PublicOrgIdRouteRouteChildren = {
  PublicOrgIdComplaintNewRouteRoute: PublicOrgIdComplaintNewRouteRoute,
  PublicOrgIdInvoiceViewAccessKeyRouteRoute:
    PublicOrgIdInvoiceViewAccessKeyRouteRoute,
  PublicOrgIdClaimLodgementLookupPdsVersionIdQuestionnaireIdProductTypeIdRouteRoute:
    PublicOrgIdClaimLodgementLookupPdsVersionIdQuestionnaireIdProductTypeIdRouteRoute,
  PublicOrgIdClaimLodgementPdsVersionIdQuestionnaireIdProductTypeIdRouteRoute:
    PublicOrgIdClaimLodgementPdsVersionIdQuestionnaireIdProductTypeIdRouteRoute,
};

const PublicOrgIdRouteRouteWithChildren =
  PublicOrgIdRouteRoute._addFileChildren(PublicOrgIdRouteRouteChildren);

const PublicRouteRouteChildren = {
  PublicOrgIdRouteRoute: PublicOrgIdRouteRouteWithChildren,
  PublicLodgementSummaryAccessKeyRouteRoute:
    PublicLodgementSummaryAccessKeyRouteRoute,
  PublicNewComplaintByKeyKeyRouteRoute: PublicNewComplaintByKeyKeyRouteRoute,
  PublicNewComplaintOrgIdRouteRoute: PublicNewComplaintOrgIdRouteRoute,
  PublicClaimLodgementOrgIdPdsVersionIdQuestionnaireIdProductTypeIdRouteRoute:
    PublicClaimLodgementOrgIdPdsVersionIdQuestionnaireIdProductTypeIdRouteRoute,
};

const PublicRouteRouteWithChildren = PublicRouteRoute._addFileChildren(
  PublicRouteRouteChildren,
);

const ConsoleOrgIdAttestationsOverviewRouteRouteChildren = {
  ConsoleOrgIdAttestationsOverviewPeopleUserIdRoute:
    ConsoleOrgIdAttestationsOverviewPeopleUserIdRoute,
};

const ConsoleOrgIdAttestationsOverviewRouteRouteWithChildren =
  ConsoleOrgIdAttestationsOverviewRouteRoute._addFileChildren(
    ConsoleOrgIdAttestationsOverviewRouteRouteChildren,
  );

const ConsoleOrgIdAttestationsScheduledAttestationsRouteRouteChildren = {
  ConsoleOrgIdAttestationsScheduledAttestationsScheduleIdRouteRoute:
    ConsoleOrgIdAttestationsScheduledAttestationsScheduleIdRouteRoute,
  ConsoleOrgIdAttestationsScheduledAttestationsNewRoute:
    ConsoleOrgIdAttestationsScheduledAttestationsNewRoute,
};

const ConsoleOrgIdAttestationsScheduledAttestationsRouteRouteWithChildren =
  ConsoleOrgIdAttestationsScheduledAttestationsRouteRoute._addFileChildren(
    ConsoleOrgIdAttestationsScheduledAttestationsRouteRouteChildren,
  );

const ConsoleOrgIdAttestationsUserAttestationsRouteRouteChildren = {
  ConsoleOrgIdAttestationsUserAttestationsAttestationIdRouteRoute:
    ConsoleOrgIdAttestationsUserAttestationsAttestationIdRouteRoute,
  ConsoleOrgIdAttestationsUserAttestationsSendRoute:
    ConsoleOrgIdAttestationsUserAttestationsSendRoute,
};

const ConsoleOrgIdAttestationsUserAttestationsRouteRouteWithChildren =
  ConsoleOrgIdAttestationsUserAttestationsRouteRoute._addFileChildren(
    ConsoleOrgIdAttestationsUserAttestationsRouteRouteChildren,
  );

const ConsoleOrgIdAttestationsRoundsRoundIdRouteRouteChildren = {
  ConsoleOrgIdAttestationsRoundsRoundIdCoverageRoute:
    ConsoleOrgIdAttestationsRoundsRoundIdCoverageRoute,
  ConsoleOrgIdAttestationsRoundsRoundIdPeopleUserIdRoute:
    ConsoleOrgIdAttestationsRoundsRoundIdPeopleUserIdRoute,
};

const ConsoleOrgIdAttestationsRoundsRoundIdRouteRouteWithChildren =
  ConsoleOrgIdAttestationsRoundsRoundIdRouteRoute._addFileChildren(
    ConsoleOrgIdAttestationsRoundsRoundIdRouteRouteChildren,
  );

const ConsoleOrgIdAttestationsRouteRouteChildren = {
  ConsoleOrgIdAttestationsIndexRoute: ConsoleOrgIdAttestationsIndexRoute,
  ConsoleOrgIdAttestationsOverviewRouteRoute:
    ConsoleOrgIdAttestationsOverviewRouteRouteWithChildren,
  ConsoleOrgIdAttestationsScheduledAttestationsRouteRoute:
    ConsoleOrgIdAttestationsScheduledAttestationsRouteRouteWithChildren,
  ConsoleOrgIdAttestationsUserAttestationsRouteRoute:
    ConsoleOrgIdAttestationsUserAttestationsRouteRouteWithChildren,
  ConsoleOrgIdAttestationsRoundsRoundIdRouteRoute:
    ConsoleOrgIdAttestationsRoundsRoundIdRouteRouteWithChildren,
};

const ConsoleOrgIdAttestationsRouteRouteWithChildren =
  ConsoleOrgIdAttestationsRouteRoute._addFileChildren(
    ConsoleOrgIdAttestationsRouteRouteChildren,
  );

const ConsoleOrgIdClaimsDetailsIdActivityRouteRouteChildren = {
  ConsoleOrgIdClaimsDetailsIdActivityAddPhoneRoute:
    ConsoleOrgIdClaimsDetailsIdActivityAddPhoneRoute,
  ConsoleOrgIdClaimsDetailsIdActivityEditPhoneCallLogIdRoute:
    ConsoleOrgIdClaimsDetailsIdActivityEditPhoneCallLogIdRoute,
};

const ConsoleOrgIdClaimsDetailsIdActivityRouteRouteWithChildren =
  ConsoleOrgIdClaimsDetailsIdActivityRouteRoute._addFileChildren(
    ConsoleOrgIdClaimsDetailsIdActivityRouteRouteChildren,
  );

const ConsoleOrgIdClaimsDetailsIdCommsRouteRouteChildren = {
  ConsoleOrgIdClaimsDetailsIdCommsMessageMessageIdRouteRoute:
    ConsoleOrgIdClaimsDetailsIdCommsMessageMessageIdRouteRoute,
  ConsoleOrgIdClaimsDetailsIdCommsReplyMessageIdRouteRoute:
    ConsoleOrgIdClaimsDetailsIdCommsReplyMessageIdRouteRoute,
};

const ConsoleOrgIdClaimsDetailsIdCommsRouteRouteWithChildren =
  ConsoleOrgIdClaimsDetailsIdCommsRouteRoute._addFileChildren(
    ConsoleOrgIdClaimsDetailsIdCommsRouteRouteChildren,
  );

const ConsoleOrgIdClaimsDetailsIdContactsSuppliersReassignSupplierIdRouteRouteChildren =
  {
    ConsoleOrgIdClaimsDetailsIdContactsSuppliersReassignSupplierIdAddRoute:
      ConsoleOrgIdClaimsDetailsIdContactsSuppliersReassignSupplierIdAddRoute,
  };

const ConsoleOrgIdClaimsDetailsIdContactsSuppliersReassignSupplierIdRouteRouteWithChildren =
  ConsoleOrgIdClaimsDetailsIdContactsSuppliersReassignSupplierIdRouteRoute._addFileChildren(
    ConsoleOrgIdClaimsDetailsIdContactsSuppliersReassignSupplierIdRouteRouteChildren,
  );

const ConsoleOrgIdClaimsDetailsIdContactsRouteRouteChildren = {
  ConsoleOrgIdClaimsDetailsIdContactsAddRoute:
    ConsoleOrgIdClaimsDetailsIdContactsAddRoute,
  ConsoleOrgIdClaimsDetailsIdContactsEditContactIdRoute:
    ConsoleOrgIdClaimsDetailsIdContactsEditContactIdRoute,
  ConsoleOrgIdClaimsDetailsIdContactsSuppliersDetailsSupplierIdRoute:
    ConsoleOrgIdClaimsDetailsIdContactsSuppliersDetailsSupplierIdRoute,
  ConsoleOrgIdClaimsDetailsIdContactsSuppliersReassignSupplierIdRouteRoute:
    ConsoleOrgIdClaimsDetailsIdContactsSuppliersReassignSupplierIdRouteRouteWithChildren,
};

const ConsoleOrgIdClaimsDetailsIdContactsRouteRouteWithChildren =
  ConsoleOrgIdClaimsDetailsIdContactsRouteRoute._addFileChildren(
    ConsoleOrgIdClaimsDetailsIdContactsRouteRouteChildren,
  );

const ConsoleOrgIdClaimsDetailsIdExpensesRouteRouteChildren = {
  ConsoleOrgIdClaimsDetailsIdExpensesAddRoute:
    ConsoleOrgIdClaimsDetailsIdExpensesAddRoute,
  ConsoleOrgIdClaimsDetailsIdExpensesEditExpenseItemIdRoute:
    ConsoleOrgIdClaimsDetailsIdExpensesEditExpenseItemIdRoute,
};

const ConsoleOrgIdClaimsDetailsIdExpensesRouteRouteWithChildren =
  ConsoleOrgIdClaimsDetailsIdExpensesRouteRoute._addFileChildren(
    ConsoleOrgIdClaimsDetailsIdExpensesRouteRouteChildren,
  );

const ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddRouteRouteChildren =
  {
    ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddCompensationPaymentsAddRoute:
      ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddCompensationPaymentsAddRoute,
    ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddExcessPaymentsAddRoute:
      ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddExcessPaymentsAddRoute,
    ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddSuppliersAddRoute:
      ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddSuppliersAddRoute,
  };

const ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddRouteRouteWithChildren =
  ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddRouteRoute._addFileChildren(
    ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddRouteRouteChildren,
  );

const ConsoleOrgIdClaimsDetailsIdFinancialsPaymentsAddRouteChildren = {
  ConsoleOrgIdClaimsDetailsIdFinancialsPaymentsAddContactsAddRoute:
    ConsoleOrgIdClaimsDetailsIdFinancialsPaymentsAddContactsAddRoute,
  ConsoleOrgIdClaimsDetailsIdFinancialsPaymentsAddSuppliersAddRoute:
    ConsoleOrgIdClaimsDetailsIdFinancialsPaymentsAddSuppliersAddRoute,
};

const ConsoleOrgIdClaimsDetailsIdFinancialsPaymentsAddRouteWithChildren =
  ConsoleOrgIdClaimsDetailsIdFinancialsPaymentsAddRoute._addFileChildren(
    ConsoleOrgIdClaimsDetailsIdFinancialsPaymentsAddRouteChildren,
  );

const ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsRouteRouteChildren =
  {
    ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsCompensationPaymentsDetailsCompensationPaymentIdRoute:
      ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsCompensationPaymentsDetailsCompensationPaymentIdRoute,
    ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsExcessPaymentsDetailsExcessPaymentIdRoute:
      ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsExcessPaymentsDetailsExcessPaymentIdRoute,
  };

const ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsRouteRouteWithChildren =
  ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsRouteRoute._addFileChildren(
    ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsRouteRouteChildren,
  );

const ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdRouteRouteChildren =
  {
    ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsRouteRoute:
      ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsRouteRouteWithChildren,
    ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdLibraryRoute:
      ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdLibraryRoute,
    ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdPayeeRoute:
      ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdPayeeRoute,
    ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdPaymentRoute:
      ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdPaymentRoute,
  };

const ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdRouteRouteWithChildren =
  ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdRouteRoute._addFileChildren(
    ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdRouteRouteChildren,
  );

const ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdRouteRouteChildren =
  {
    ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdLibraryRoute:
      ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdLibraryRoute,
    ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdManageRoute:
      ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdManageRoute,
    ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdPaymentsRoute:
      ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdPaymentsRoute,
  };

const ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdRouteRouteWithChildren =
  ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdRouteRoute._addFileChildren(
    ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdRouteRouteChildren,
  );

const ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdReserveAdjustmentsRouteRouteChildren =
  {
    ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdReserveAdjustmentsAddRoute:
      ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdReserveAdjustmentsAddRoute,
  };

const ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdReserveAdjustmentsRouteRouteWithChildren =
  ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdReserveAdjustmentsRouteRoute._addFileChildren(
    ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdReserveAdjustmentsRouteRouteChildren,
  );

const ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdRouteRouteChildren =
  {
    ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdCompensationPaymentsRoute:
      ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdCompensationPaymentsRoute,
    ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdLibraryRoute:
      ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdLibraryRoute,
    ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdReserveAdjustmentsRouteRoute:
      ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdReserveAdjustmentsRouteRouteWithChildren,
  };

const ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdRouteRouteWithChildren =
  ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdRouteRoute._addFileChildren(
    ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdRouteRouteChildren,
  );

const ConsoleOrgIdClaimsDetailsIdFinancialsRouteRouteChildren = {
  ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddRouteRoute:
    ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddRouteRouteWithChildren,
  ConsoleOrgIdClaimsDetailsIdFinancialsExcessesAddRoute:
    ConsoleOrgIdClaimsDetailsIdFinancialsExcessesAddRoute,
  ConsoleOrgIdClaimsDetailsIdFinancialsPaymentsCompensationIdRoute:
    ConsoleOrgIdClaimsDetailsIdFinancialsPaymentsCompensationIdRoute,
  ConsoleOrgIdClaimsDetailsIdFinancialsPaymentsAddRoute:
    ConsoleOrgIdClaimsDetailsIdFinancialsPaymentsAddRouteWithChildren,
  ConsoleOrgIdClaimsDetailsIdFinancialsReserveChangesRequestIdRoute:
    ConsoleOrgIdClaimsDetailsIdFinancialsReserveChangesRequestIdRoute,
  ConsoleOrgIdClaimsDetailsIdFinancialsReservesAddRoute:
    ConsoleOrgIdClaimsDetailsIdFinancialsReservesAddRoute,
  ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdRouteRoute:
    ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdRouteRouteWithChildren,
  ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdRouteRoute:
    ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdRouteRouteWithChildren,
  ConsoleOrgIdClaimsDetailsIdFinancialsPaymentsCorrectCompensationIdRoute:
    ConsoleOrgIdClaimsDetailsIdFinancialsPaymentsCorrectCompensationIdRoute,
  ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdRouteRoute:
    ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdRouteRouteWithChildren,
};

const ConsoleOrgIdClaimsDetailsIdFinancialsRouteRouteWithChildren =
  ConsoleOrgIdClaimsDetailsIdFinancialsRouteRoute._addFileChildren(
    ConsoleOrgIdClaimsDetailsIdFinancialsRouteRouteChildren,
  );

const ConsoleOrgIdClaimsDetailsIdLibraryRouteRouteChildren = {
  ConsoleOrgIdClaimsDetailsIdLibraryPaymentsCompensationIdRoute:
    ConsoleOrgIdClaimsDetailsIdLibraryPaymentsCompensationIdRoute,
};

const ConsoleOrgIdClaimsDetailsIdLibraryRouteRouteWithChildren =
  ConsoleOrgIdClaimsDetailsIdLibraryRouteRoute._addFileChildren(
    ConsoleOrgIdClaimsDetailsIdLibraryRouteRouteChildren,
  );

const ConsoleOrgIdClaimsDetailsIdManageRouteRouteChildren = {
  ConsoleOrgIdClaimsDetailsIdManageStrategiesAddRouteRoute:
    ConsoleOrgIdClaimsDetailsIdManageStrategiesAddRouteRoute,
  ConsoleOrgIdClaimsDetailsIdManageSupplierJobsAddRoute:
    ConsoleOrgIdClaimsDetailsIdManageSupplierJobsAddRoute,
  ConsoleOrgIdClaimsDetailsIdManageSupplierJobsAddSupplierRoute:
    ConsoleOrgIdClaimsDetailsIdManageSupplierJobsAddSupplierRoute,
  ConsoleOrgIdClaimsDetailsIdManageSupplierJobsEditJobIdRoute:
    ConsoleOrgIdClaimsDetailsIdManageSupplierJobsEditJobIdRoute,
};

const ConsoleOrgIdClaimsDetailsIdManageRouteRouteWithChildren =
  ConsoleOrgIdClaimsDetailsIdManageRouteRoute._addFileChildren(
    ConsoleOrgIdClaimsDetailsIdManageRouteRouteChildren,
  );

const ConsoleOrgIdClaimsDetailsIdVehicleRouteRouteChildren = {
  ConsoleOrgIdClaimsDetailsIdVehicleReportInspectionIdRoute:
    ConsoleOrgIdClaimsDetailsIdVehicleReportInspectionIdRoute,
};

const ConsoleOrgIdClaimsDetailsIdVehicleRouteRouteWithChildren =
  ConsoleOrgIdClaimsDetailsIdVehicleRouteRoute._addFileChildren(
    ConsoleOrgIdClaimsDetailsIdVehicleRouteRouteChildren,
  );

const ConsoleOrgIdClaimsDetailsIdRouteRouteChildren = {
  ConsoleOrgIdClaimsDetailsIdActivityRouteRoute:
    ConsoleOrgIdClaimsDetailsIdActivityRouteRouteWithChildren,
  ConsoleOrgIdClaimsDetailsIdAiAssessmentRouteRoute:
    ConsoleOrgIdClaimsDetailsIdAiAssessmentRouteRoute,
  ConsoleOrgIdClaimsDetailsIdCommsRouteRoute:
    ConsoleOrgIdClaimsDetailsIdCommsRouteRouteWithChildren,
  ConsoleOrgIdClaimsDetailsIdContactsRouteRoute:
    ConsoleOrgIdClaimsDetailsIdContactsRouteRouteWithChildren,
  ConsoleOrgIdClaimsDetailsIdExpensesRouteRoute:
    ConsoleOrgIdClaimsDetailsIdExpensesRouteRouteWithChildren,
  ConsoleOrgIdClaimsDetailsIdFinancialsRouteRoute:
    ConsoleOrgIdClaimsDetailsIdFinancialsRouteRouteWithChildren,
  ConsoleOrgIdClaimsDetailsIdHistoryRouteRoute:
    ConsoleOrgIdClaimsDetailsIdHistoryRouteRoute,
  ConsoleOrgIdClaimsDetailsIdLibraryRouteRoute:
    ConsoleOrgIdClaimsDetailsIdLibraryRouteRouteWithChildren,
  ConsoleOrgIdClaimsDetailsIdManageRouteRoute:
    ConsoleOrgIdClaimsDetailsIdManageRouteRouteWithChildren,
  ConsoleOrgIdClaimsDetailsIdPolicyInfoRouteRoute:
    ConsoleOrgIdClaimsDetailsIdPolicyInfoRouteRoute,
  ConsoleOrgIdClaimsDetailsIdProductFieldsRouteRoute:
    ConsoleOrgIdClaimsDetailsIdProductFieldsRouteRoute,
  ConsoleOrgIdClaimsDetailsIdProductTypeDataRouteRoute:
    ConsoleOrgIdClaimsDetailsIdProductTypeDataRouteRoute,
  ConsoleOrgIdClaimsDetailsIdVehicleRouteRoute:
    ConsoleOrgIdClaimsDetailsIdVehicleRouteRouteWithChildren,
};

const ConsoleOrgIdClaimsDetailsIdRouteRouteWithChildren =
  ConsoleOrgIdClaimsDetailsIdRouteRoute._addFileChildren(
    ConsoleOrgIdClaimsDetailsIdRouteRouteChildren,
  );

const ConsoleOrgIdClaimsRouteRouteChildren = {
  ConsoleOrgIdClaimsIndexRoute: ConsoleOrgIdClaimsIndexRoute,
  ConsoleOrgIdClaimsLodgeFromDocumentsRoute:
    ConsoleOrgIdClaimsLodgeFromDocumentsRoute,
  ConsoleOrgIdClaimsLodgementsRouteRoute:
    ConsoleOrgIdClaimsLodgementsRouteRoute,
  ConsoleOrgIdClaimsDetailsIdRouteRoute:
    ConsoleOrgIdClaimsDetailsIdRouteRouteWithChildren,
  ConsoleOrgIdClaimsLodgeLinkIdRoute: ConsoleOrgIdClaimsLodgeLinkIdRoute,
};

const ConsoleOrgIdClaimsRouteRouteWithChildren =
  ConsoleOrgIdClaimsRouteRoute._addFileChildren(
    ConsoleOrgIdClaimsRouteRouteChildren,
  );

const ConsoleOrgIdComplianceCoiDetailsIdRouteRouteChildren = {
  ConsoleOrgIdComplianceCoiDetailsIdIndexRoute:
    ConsoleOrgIdComplianceCoiDetailsIdIndexRoute,
  ConsoleOrgIdComplianceCoiDetailsIdLibraryRoute:
    ConsoleOrgIdComplianceCoiDetailsIdLibraryRoute,
  ConsoleOrgIdComplianceCoiDetailsIdManageRoute:
    ConsoleOrgIdComplianceCoiDetailsIdManageRoute,
};

const ConsoleOrgIdComplianceCoiDetailsIdRouteRouteWithChildren =
  ConsoleOrgIdComplianceCoiDetailsIdRouteRoute._addFileChildren(
    ConsoleOrgIdComplianceCoiDetailsIdRouteRouteChildren,
  );

const ConsoleOrgIdComplianceCoiRouteRouteChildren = {
  ConsoleOrgIdComplianceCoiIndexRoute: ConsoleOrgIdComplianceCoiIndexRoute,
  ConsoleOrgIdComplianceCoiAddRouteRoute:
    ConsoleOrgIdComplianceCoiAddRouteRoute,
  ConsoleOrgIdComplianceCoiDetailsIdRouteRoute:
    ConsoleOrgIdComplianceCoiDetailsIdRouteRouteWithChildren,
};

const ConsoleOrgIdComplianceCoiRouteRouteWithChildren =
  ConsoleOrgIdComplianceCoiRouteRoute._addFileChildren(
    ConsoleOrgIdComplianceCoiRouteRouteChildren,
  );

const ConsoleOrgIdComplianceComplaintsDetailsIdManageRouteRouteChildren = {
  ConsoleOrgIdComplianceComplaintsDetailsIdManageIncidentsRoute:
    ConsoleOrgIdComplianceComplaintsDetailsIdManageIncidentsRoute,
  ConsoleOrgIdComplianceComplaintsDetailsIdManageNoteAddRouteRoute:
    ConsoleOrgIdComplianceComplaintsDetailsIdManageNoteAddRouteRoute,
};

const ConsoleOrgIdComplianceComplaintsDetailsIdManageRouteRouteWithChildren =
  ConsoleOrgIdComplianceComplaintsDetailsIdManageRouteRoute._addFileChildren(
    ConsoleOrgIdComplianceComplaintsDetailsIdManageRouteRouteChildren,
  );

const ConsoleOrgIdComplianceComplaintsDetailsIdRouteRouteChildren = {
  ConsoleOrgIdComplianceComplaintsDetailsIdIndexRoute:
    ConsoleOrgIdComplianceComplaintsDetailsIdIndexRoute,
  ConsoleOrgIdComplianceComplaintsDetailsIdCommsRouteRoute:
    ConsoleOrgIdComplianceComplaintsDetailsIdCommsRouteRoute,
  ConsoleOrgIdComplianceComplaintsDetailsIdHistoryRouteRoute:
    ConsoleOrgIdComplianceComplaintsDetailsIdHistoryRouteRoute,
  ConsoleOrgIdComplianceComplaintsDetailsIdLibraryRouteRoute:
    ConsoleOrgIdComplianceComplaintsDetailsIdLibraryRouteRoute,
  ConsoleOrgIdComplianceComplaintsDetailsIdManageRouteRoute:
    ConsoleOrgIdComplianceComplaintsDetailsIdManageRouteRouteWithChildren,
};

const ConsoleOrgIdComplianceComplaintsDetailsIdRouteRouteWithChildren =
  ConsoleOrgIdComplianceComplaintsDetailsIdRouteRoute._addFileChildren(
    ConsoleOrgIdComplianceComplaintsDetailsIdRouteRouteChildren,
  );

const ConsoleOrgIdComplianceComplaintsRouteRouteChildren = {
  ConsoleOrgIdComplianceComplaintsIndexRoute:
    ConsoleOrgIdComplianceComplaintsIndexRoute,
  ConsoleOrgIdComplianceComplaintsAddRouteRoute:
    ConsoleOrgIdComplianceComplaintsAddRouteRoute,
  ConsoleOrgIdComplianceComplaintsDetailsIdRouteRoute:
    ConsoleOrgIdComplianceComplaintsDetailsIdRouteRouteWithChildren,
};

const ConsoleOrgIdComplianceComplaintsRouteRouteWithChildren =
  ConsoleOrgIdComplianceComplaintsRouteRoute._addFileChildren(
    ConsoleOrgIdComplianceComplaintsRouteRouteChildren,
  );

const ConsoleOrgIdComplianceIncidentsDetailsIdManageRouteRouteChildren = {
  ConsoleOrgIdComplianceIncidentsDetailsIdManageComplaintsRoute:
    ConsoleOrgIdComplianceIncidentsDetailsIdManageComplaintsRoute,
  ConsoleOrgIdComplianceIncidentsDetailsIdManageNoteAddRouteRoute:
    ConsoleOrgIdComplianceIncidentsDetailsIdManageNoteAddRouteRoute,
};

const ConsoleOrgIdComplianceIncidentsDetailsIdManageRouteRouteWithChildren =
  ConsoleOrgIdComplianceIncidentsDetailsIdManageRouteRoute._addFileChildren(
    ConsoleOrgIdComplianceIncidentsDetailsIdManageRouteRouteChildren,
  );

const ConsoleOrgIdComplianceIncidentsDetailsIdRouteRouteChildren = {
  ConsoleOrgIdComplianceIncidentsDetailsIdIndexRoute:
    ConsoleOrgIdComplianceIncidentsDetailsIdIndexRoute,
  ConsoleOrgIdComplianceIncidentsDetailsIdHistoryRouteRoute:
    ConsoleOrgIdComplianceIncidentsDetailsIdHistoryRouteRoute,
  ConsoleOrgIdComplianceIncidentsDetailsIdLibraryRouteRoute:
    ConsoleOrgIdComplianceIncidentsDetailsIdLibraryRouteRoute,
  ConsoleOrgIdComplianceIncidentsDetailsIdManageRouteRoute:
    ConsoleOrgIdComplianceIncidentsDetailsIdManageRouteRouteWithChildren,
};

const ConsoleOrgIdComplianceIncidentsDetailsIdRouteRouteWithChildren =
  ConsoleOrgIdComplianceIncidentsDetailsIdRouteRoute._addFileChildren(
    ConsoleOrgIdComplianceIncidentsDetailsIdRouteRouteChildren,
  );

const ConsoleOrgIdComplianceIncidentsRouteRouteChildren = {
  ConsoleOrgIdComplianceIncidentsIndexRoute:
    ConsoleOrgIdComplianceIncidentsIndexRoute,
  ConsoleOrgIdComplianceIncidentsAddRoute:
    ConsoleOrgIdComplianceIncidentsAddRoute,
  ConsoleOrgIdComplianceIncidentsDetailsIdRouteRoute:
    ConsoleOrgIdComplianceIncidentsDetailsIdRouteRouteWithChildren,
};

const ConsoleOrgIdComplianceIncidentsRouteRouteWithChildren =
  ConsoleOrgIdComplianceIncidentsRouteRoute._addFileChildren(
    ConsoleOrgIdComplianceIncidentsRouteRouteChildren,
  );

const ConsoleOrgIdComplianceObligationsDetailsIdRouteRouteChildren = {
  ConsoleOrgIdComplianceObligationsDetailsIdDebugRoute:
    ConsoleOrgIdComplianceObligationsDetailsIdDebugRoute,
  ConsoleOrgIdComplianceObligationsDetailsIdManageRoute:
    ConsoleOrgIdComplianceObligationsDetailsIdManageRoute,
};

const ConsoleOrgIdComplianceObligationsDetailsIdRouteRouteWithChildren =
  ConsoleOrgIdComplianceObligationsDetailsIdRouteRoute._addFileChildren(
    ConsoleOrgIdComplianceObligationsDetailsIdRouteRouteChildren,
  );

const ConsoleOrgIdComplianceObligationsRouteRouteChildren = {
  ConsoleOrgIdComplianceObligationsIndexRoute:
    ConsoleOrgIdComplianceObligationsIndexRoute,
  ConsoleOrgIdComplianceObligationsAddRouteRoute:
    ConsoleOrgIdComplianceObligationsAddRouteRoute,
  ConsoleOrgIdComplianceObligationsDetailsIdRouteRoute:
    ConsoleOrgIdComplianceObligationsDetailsIdRouteRouteWithChildren,
};

const ConsoleOrgIdComplianceObligationsRouteRouteWithChildren =
  ConsoleOrgIdComplianceObligationsRouteRoute._addFileChildren(
    ConsoleOrgIdComplianceObligationsRouteRouteChildren,
  );

const ConsoleOrgIdComplianceRegistersRegisterIdRouteRouteChildren = {
  ConsoleOrgIdComplianceRegistersRegisterIdIndexRoute:
    ConsoleOrgIdComplianceRegistersRegisterIdIndexRoute,
  ConsoleOrgIdComplianceRegistersRegisterIdRecordsRecordIdRoute:
    ConsoleOrgIdComplianceRegistersRegisterIdRecordsRecordIdRoute,
};

const ConsoleOrgIdComplianceRegistersRegisterIdRouteRouteWithChildren =
  ConsoleOrgIdComplianceRegistersRegisterIdRouteRoute._addFileChildren(
    ConsoleOrgIdComplianceRegistersRegisterIdRouteRouteChildren,
  );

const ConsoleOrgIdComplianceRegistersListRouteRouteChildren = {
  ConsoleOrgIdComplianceRegistersListIndexRoute:
    ConsoleOrgIdComplianceRegistersListIndexRoute,
  ConsoleOrgIdComplianceRegistersListAddRoute:
    ConsoleOrgIdComplianceRegistersListAddRoute,
  ConsoleOrgIdComplianceRegistersListNewRoute:
    ConsoleOrgIdComplianceRegistersListNewRoute,
};

const ConsoleOrgIdComplianceRegistersListRouteRouteWithChildren =
  ConsoleOrgIdComplianceRegistersListRouteRoute._addFileChildren(
    ConsoleOrgIdComplianceRegistersListRouteRouteChildren,
  );

const ConsoleOrgIdComplianceRegistersRouteRouteChildren = {
  ConsoleOrgIdComplianceRegistersRegisterIdRouteRoute:
    ConsoleOrgIdComplianceRegistersRegisterIdRouteRouteWithChildren,
  ConsoleOrgIdComplianceRegistersListRouteRoute:
    ConsoleOrgIdComplianceRegistersListRouteRouteWithChildren,
};

const ConsoleOrgIdComplianceRegistersRouteRouteWithChildren =
  ConsoleOrgIdComplianceRegistersRouteRoute._addFileChildren(
    ConsoleOrgIdComplianceRegistersRouteRouteChildren,
  );

const ConsoleOrgIdComplianceTrainingSearchRouteRouteChildren = {
  ConsoleOrgIdComplianceTrainingSearchAddRoute:
    ConsoleOrgIdComplianceTrainingSearchAddRoute,
};

const ConsoleOrgIdComplianceTrainingSearchRouteRouteWithChildren =
  ConsoleOrgIdComplianceTrainingSearchRouteRoute._addFileChildren(
    ConsoleOrgIdComplianceTrainingSearchRouteRouteChildren,
  );

const ConsoleOrgIdComplianceTrainingUserUserIdRouteRouteChildren = {
  ConsoleOrgIdComplianceTrainingUserUserIdAddRoute:
    ConsoleOrgIdComplianceTrainingUserUserIdAddRoute,
  ConsoleOrgIdComplianceTrainingUserUserIdEditRecordIdRoute:
    ConsoleOrgIdComplianceTrainingUserUserIdEditRecordIdRoute,
};

const ConsoleOrgIdComplianceTrainingUserUserIdRouteRouteWithChildren =
  ConsoleOrgIdComplianceTrainingUserUserIdRouteRoute._addFileChildren(
    ConsoleOrgIdComplianceTrainingUserUserIdRouteRouteChildren,
  );

const ConsoleOrgIdComplianceTrainingRouteRouteChildren = {
  ConsoleOrgIdComplianceTrainingIndexRoute:
    ConsoleOrgIdComplianceTrainingIndexRoute,
  ConsoleOrgIdComplianceTrainingSearchRouteRoute:
    ConsoleOrgIdComplianceTrainingSearchRouteRouteWithChildren,
  ConsoleOrgIdComplianceTrainingUserUserIdRouteRoute:
    ConsoleOrgIdComplianceTrainingUserUserIdRouteRouteWithChildren,
};

const ConsoleOrgIdComplianceTrainingRouteRouteWithChildren =
  ConsoleOrgIdComplianceTrainingRouteRoute._addFileChildren(
    ConsoleOrgIdComplianceTrainingRouteRouteChildren,
  );

const ConsoleOrgIdComplianceRouteRouteChildren = {
  ConsoleOrgIdComplianceIndexRoute: ConsoleOrgIdComplianceIndexRoute,
  ConsoleOrgIdComplianceCoiRouteRoute:
    ConsoleOrgIdComplianceCoiRouteRouteWithChildren,
  ConsoleOrgIdComplianceComplaintsRouteRoute:
    ConsoleOrgIdComplianceComplaintsRouteRouteWithChildren,
  ConsoleOrgIdComplianceIncidentsRouteRoute:
    ConsoleOrgIdComplianceIncidentsRouteRouteWithChildren,
  ConsoleOrgIdComplianceIntakeRouteRoute:
    ConsoleOrgIdComplianceIntakeRouteRoute,
  ConsoleOrgIdComplianceObligationsRouteRoute:
    ConsoleOrgIdComplianceObligationsRouteRouteWithChildren,
  ConsoleOrgIdComplianceRegistersRouteRoute:
    ConsoleOrgIdComplianceRegistersRouteRouteWithChildren,
  ConsoleOrgIdComplianceTrainingRouteRoute:
    ConsoleOrgIdComplianceTrainingRouteRouteWithChildren,
};

const ConsoleOrgIdComplianceRouteRouteWithChildren =
  ConsoleOrgIdComplianceRouteRoute._addFileChildren(
    ConsoleOrgIdComplianceRouteRouteChildren,
  );

const ConsoleOrgIdComponentShowcaseRouteRouteChildren = {
  ConsoleOrgIdComponentShowcaseIndexRoute:
    ConsoleOrgIdComponentShowcaseIndexRoute,
  ConsoleOrgIdComponentShowcaseAiChatTestRoute:
    ConsoleOrgIdComponentShowcaseAiChatTestRoute,
  ConsoleOrgIdComponentShowcaseButtonIconTestRoute:
    ConsoleOrgIdComponentShowcaseButtonIconTestRoute,
  ConsoleOrgIdComponentShowcaseButtonVariantsRoute:
    ConsoleOrgIdComponentShowcaseButtonVariantsRoute,
  ConsoleOrgIdComponentShowcaseComponentShowcaseRoute:
    ConsoleOrgIdComponentShowcaseComponentShowcaseRoute,
  ConsoleOrgIdComponentShowcaseDatePickerTestRoute:
    ConsoleOrgIdComponentShowcaseDatePickerTestRoute,
  ConsoleOrgIdComponentShowcaseFitOnPageRoute:
    ConsoleOrgIdComponentShowcaseFitOnPageRoute,
  ConsoleOrgIdComponentShowcaseMarkdownShowcaseRoute:
    ConsoleOrgIdComponentShowcaseMarkdownShowcaseRoute,
  ConsoleOrgIdComponentShowcaseTableShowcaseRoute:
    ConsoleOrgIdComponentShowcaseTableShowcaseRoute,
  ConsoleOrgIdComponentShowcaseTagVariantsRoute:
    ConsoleOrgIdComponentShowcaseTagVariantsRoute,
  ConsoleOrgIdComponentShowcaseTiptapTestRoute:
    ConsoleOrgIdComponentShowcaseTiptapTestRoute,
};

const ConsoleOrgIdComponentShowcaseRouteRouteWithChildren =
  ConsoleOrgIdComponentShowcaseRouteRoute._addFileChildren(
    ConsoleOrgIdComponentShowcaseRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationApiIntegrationsApiTokensRouteRouteChildren = {
  ConsoleOrgIdConfigurationApiIntegrationsApiTokensCreateRoute:
    ConsoleOrgIdConfigurationApiIntegrationsApiTokensCreateRoute,
};

const ConsoleOrgIdConfigurationApiIntegrationsApiTokensRouteRouteWithChildren =
  ConsoleOrgIdConfigurationApiIntegrationsApiTokensRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationApiIntegrationsApiTokensRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationApiIntegrationsDocumentSourcesRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationApiIntegrationsDocumentSourcesConnectionIdRoute:
      ConsoleOrgIdConfigurationApiIntegrationsDocumentSourcesConnectionIdRoute,
    ConsoleOrgIdConfigurationApiIntegrationsDocumentSourcesAddRoute:
      ConsoleOrgIdConfigurationApiIntegrationsDocumentSourcesAddRoute,
  };

const ConsoleOrgIdConfigurationApiIntegrationsDocumentSourcesRouteRouteWithChildren =
  ConsoleOrgIdConfigurationApiIntegrationsDocumentSourcesRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationApiIntegrationsDocumentSourcesRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationApiIntegrationsRouteRouteChildren = {
  ConsoleOrgIdConfigurationApiIntegrationsApiTokensRouteRoute:
    ConsoleOrgIdConfigurationApiIntegrationsApiTokensRouteRouteWithChildren,
  ConsoleOrgIdConfigurationApiIntegrationsDocumentSourcesRouteRoute:
    ConsoleOrgIdConfigurationApiIntegrationsDocumentSourcesRouteRouteWithChildren,
  ConsoleOrgIdConfigurationApiIntegrationsMcpAccessRouteRoute:
    ConsoleOrgIdConfigurationApiIntegrationsMcpAccessRouteRoute,
  ConsoleOrgIdConfigurationApiIntegrationsFormDesignerIndexRoute:
    ConsoleOrgIdConfigurationApiIntegrationsFormDesignerIndexRoute,
  ConsoleOrgIdConfigurationApiIntegrationsFormDesignerFormDefinitionIdRoute:
    ConsoleOrgIdConfigurationApiIntegrationsFormDesignerFormDefinitionIdRoute,
};

const ConsoleOrgIdConfigurationApiIntegrationsRouteRouteWithChildren =
  ConsoleOrgIdConfigurationApiIntegrationsRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationApiIntegrationsRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsAddRoute:
      ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsAddRoute,
    ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsEditCatastropheEventIdRoute:
      ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsEditCatastropheEventIdRoute,
  };

const ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsRouteRouteWithChildren =
  ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsAddRoute:
      ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsAddRoute,
    ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsEditClaimFlagIdRoute:
      ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsEditClaimFlagIdRoute,
  };

const ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsRouteRouteWithChildren =
  ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationClaimsProductsClaimsClaimsAuthorityRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationClaimsProductsClaimsClaimsAuthorityInsurerLimitsAddRoute:
      ConsoleOrgIdConfigurationClaimsProductsClaimsClaimsAuthorityInsurerLimitsAddRoute,
    ConsoleOrgIdConfigurationClaimsProductsClaimsClaimsAuthorityLevelsAddRoute:
      ConsoleOrgIdConfigurationClaimsProductsClaimsClaimsAuthorityLevelsAddRoute,
    ConsoleOrgIdConfigurationClaimsProductsClaimsClaimsAuthorityLevelsEditLevelIdRoute:
      ConsoleOrgIdConfigurationClaimsProductsClaimsClaimsAuthorityLevelsEditLevelIdRoute,
    ConsoleOrgIdConfigurationClaimsProductsClaimsClaimsAuthorityPeopleEditUserIdRoute:
      ConsoleOrgIdConfigurationClaimsProductsClaimsClaimsAuthorityPeopleEditUserIdRoute,
    ConsoleOrgIdConfigurationClaimsProductsClaimsClaimsAuthorityInsurerLimitsEditInsurerIdProductTypeIdRoute:
      ConsoleOrgIdConfigurationClaimsProductsClaimsClaimsAuthorityInsurerLimitsEditInsurerIdProductTypeIdRoute,
  };

const ConsoleOrgIdConfigurationClaimsProductsClaimsClaimsAuthorityRouteRouteWithChildren =
  ConsoleOrgIdConfigurationClaimsProductsClaimsClaimsAuthorityRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationClaimsProductsClaimsClaimsAuthorityRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralRouteRouteChildren = {
  ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralClaimStatusesAddRoute:
    ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralClaimStatusesAddRoute,
  ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralClaimStatusesEditClaimStatusIdRoute:
    ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralClaimStatusesEditClaimStatusIdRoute,
};

const ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralRouteRouteWithChildren =
  ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksAddRoute:
      ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksAddRoute,
    ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksEditIdRoute:
      ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksEditIdRoute,
  };

const ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksRouteRouteWithChildren =
  ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchAddRoute:
      ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchAddRoute,
    ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksRouteRoute:
      ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksRouteRouteWithChildren,
    ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchEditIdRoute:
      ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchEditIdRoute,
  };

const ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchRouteRouteWithChildren =
  ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsIndexRoute:
      ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsIndexRoute,
    ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchRouteRoute:
      ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchRouteRouteWithChildren,
  };

const ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsRouteRouteWithChildren =
  ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRouteChildren = {
  ConsoleOrgIdConfigurationClaimsProductsClaimsIndexRoute:
    ConsoleOrgIdConfigurationClaimsProductsClaimsIndexRoute,
  ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsRouteRoute:
    ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsRouteRouteWithChildren,
  ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsRouteRoute:
    ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsRouteRouteWithChildren,
  ConsoleOrgIdConfigurationClaimsProductsClaimsClaimsAuthorityRouteRoute:
    ConsoleOrgIdConfigurationClaimsProductsClaimsClaimsAuthorityRouteRouteWithChildren,
  ConsoleOrgIdConfigurationClaimsProductsClaimsDocumentsRoute:
    ConsoleOrgIdConfigurationClaimsProductsClaimsDocumentsRoute,
  ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralRouteRoute:
    ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralRouteRouteWithChildren,
  ConsoleOrgIdConfigurationClaimsProductsClaimsHandlingStandardsRoute:
    ConsoleOrgIdConfigurationClaimsProductsClaimsHandlingStandardsRoute,
  ConsoleOrgIdConfigurationClaimsProductsClaimsIdRoute:
    ConsoleOrgIdConfigurationClaimsProductsClaimsIdRoute,
  ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsRouteRoute:
    ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsRouteRouteWithChildren,
};

const ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRouteWithChildren =
  ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationClaimsProductsContactRolesRouteRouteChildren = {
  ConsoleOrgIdConfigurationClaimsProductsContactRolesAddRoute:
    ConsoleOrgIdConfigurationClaimsProductsContactRolesAddRoute,
  ConsoleOrgIdConfigurationClaimsProductsContactRolesEditContactRoleIdRoute:
    ConsoleOrgIdConfigurationClaimsProductsContactRolesEditContactRoleIdRoute,
};

const ConsoleOrgIdConfigurationClaimsProductsContactRolesRouteRouteWithChildren =
  ConsoleOrgIdConfigurationClaimsProductsContactRolesRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationClaimsProductsContactRolesRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationClaimsProductsFormsFormDefinitionIdRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationClaimsProductsFormsFormDefinitionIdIndexRoute:
      ConsoleOrgIdConfigurationClaimsProductsFormsFormDefinitionIdIndexRoute,
  };

const ConsoleOrgIdConfigurationClaimsProductsFormsFormDefinitionIdRouteRouteWithChildren =
  ConsoleOrgIdConfigurationClaimsProductsFormsFormDefinitionIdRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationClaimsProductsFormsFormDefinitionIdRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationClaimsProductsFormsRouteRouteChildren = {
  ConsoleOrgIdConfigurationClaimsProductsFormsIndexRoute:
    ConsoleOrgIdConfigurationClaimsProductsFormsIndexRoute,
  ConsoleOrgIdConfigurationClaimsProductsFormsFormDefinitionIdRouteRoute:
    ConsoleOrgIdConfigurationClaimsProductsFormsFormDefinitionIdRouteRouteWithChildren,
};

const ConsoleOrgIdConfigurationClaimsProductsFormsRouteRouteWithChildren =
  ConsoleOrgIdConfigurationClaimsProductsFormsRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationClaimsProductsFormsRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineConditionsRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineConditionsRoute,
    ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineExclusionsRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineExclusionsRoute,
    ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineGuideRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineGuideRoute,
    ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineLimitsExcessesRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineLimitsExcessesRoute,
    ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineLossCausesRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineLossCausesRoute,
    ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineOverviewRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineOverviewRoute,
    ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEnginePolicyTriggerMappingRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEnginePolicyTriggerMappingRoute,
    ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineProductInfoRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineProductInfoRoute,
    ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRedFlagsRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRedFlagsRoute,
  };

const ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRouteWithChildren =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdAddRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdAddRoute,
    ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRouteWithChildren,
    ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdEditPdsIdRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdEditPdsIdRoute,
    ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdPdsTextPdsIdRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdPdsTextPdsIdRoute,
    ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdPdsPdsIdRouteRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdPdsPdsIdRouteRoute,
  };

const ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdRouteRouteWithChildren =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeAddRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeAddRoute,
    ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeEditThirdPartyContactTypeIdRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeEditThirdPartyContactTypeIdRoute,
  };

const ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeRouteRouteWithChildren =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdDataFieldsRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdDataFieldsRoute,
    ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdPolicyFieldsRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdPolicyFieldsRoute,
    ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeRouteRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeRouteRouteWithChildren,
  };

const ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdRouteRouteWithChildren =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesAddRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesAddRoute,
    ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesEditTransactionTypeIdRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesEditTransactionTypeIdRoute,
  };

const ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesRouteRouteWithChildren =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdCostCodesRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdCostCodesRoute,
    ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdSectionsRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdSectionsRoute,
    ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTaxRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTaxRoute,
    ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesRouteRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesRouteRouteWithChildren,
  };

const ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdRouteRouteWithChildren =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationClaimsProductsProductTypesRouteRouteChildren = {
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdRouteRoute:
    ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdRouteRouteWithChildren,
  ConsoleOrgIdConfigurationClaimsProductsProductTypesAddRoute:
    ConsoleOrgIdConfigurationClaimsProductsProductTypesAddRoute,
  ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdRouteRoute:
    ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdRouteRouteWithChildren,
  ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdRouteRoute:
    ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdRouteRouteWithChildren,
  ConsoleOrgIdConfigurationClaimsProductsProductTypesStatesIdRouteRoute:
    ConsoleOrgIdConfigurationClaimsProductsProductTypesStatesIdRouteRoute,
};

const ConsoleOrgIdConfigurationClaimsProductsProductTypesRouteRouteWithChildren =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationClaimsProductsProductTypesRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesAddRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesAddRoute,
    ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesEditContactTypeIdRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesEditContactTypeIdRoute,
  };

const ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesRouteRouteWithChildren =
  ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesRouteRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesRouteRouteWithChildren,
    ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdDetailsRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdDetailsRoute,
    ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdDocumentsRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdDocumentsRoute,
    ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdFieldsRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdFieldsRoute,
  };

const ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdRouteRouteWithChildren =
  ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdLodgementLinksRouteRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdLodgementLinksRouteRoute,
    ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdRouteRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdRouteRouteWithChildren,
  };

const ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdRouteRouteWithChildren =
  ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationClaimsProductsProductsV2RouteRouteChildren = {
  ConsoleOrgIdConfigurationClaimsProductsProductsV2AddRoute:
    ConsoleOrgIdConfigurationClaimsProductsProductsV2AddRoute,
  ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdRouteRoute:
    ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdRouteRouteWithChildren,
  ConsoleOrgIdConfigurationClaimsProductsProductsV2EditProductIdRoute:
    ConsoleOrgIdConfigurationClaimsProductsProductsV2EditProductIdRoute,
};

const ConsoleOrgIdConfigurationClaimsProductsProductsV2RouteRouteWithChildren =
  ConsoleOrgIdConfigurationClaimsProductsProductsV2RouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationClaimsProductsProductsV2RouteRouteChildren,
  );

const ConsoleOrgIdConfigurationClaimsProductsQuestionnaireRouteRouteChildren = {
  ConsoleOrgIdConfigurationClaimsProductsQuestionnaireAddRoute:
    ConsoleOrgIdConfigurationClaimsProductsQuestionnaireAddRoute,
  ConsoleOrgIdConfigurationClaimsProductsQuestionnaireEditQuestionnaireIdRoute:
    ConsoleOrgIdConfigurationClaimsProductsQuestionnaireEditQuestionnaireIdRoute,
};

const ConsoleOrgIdConfigurationClaimsProductsQuestionnaireRouteRouteWithChildren =
  ConsoleOrgIdConfigurationClaimsProductsQuestionnaireRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationClaimsProductsQuestionnaireRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationClaimsProductsRouteRouteChildren = {
  ConsoleOrgIdConfigurationClaimsProductsClaimIntakeLinksRouteRoute:
    ConsoleOrgIdConfigurationClaimsProductsClaimIntakeLinksRouteRoute,
  ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRoute:
    ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRouteWithChildren,
  ConsoleOrgIdConfigurationClaimsProductsContactRolesRouteRoute:
    ConsoleOrgIdConfigurationClaimsProductsContactRolesRouteRouteWithChildren,
  ConsoleOrgIdConfigurationClaimsProductsFormsRouteRoute:
    ConsoleOrgIdConfigurationClaimsProductsFormsRouteRouteWithChildren,
  ConsoleOrgIdConfigurationClaimsProductsInsurersRouteRoute:
    ConsoleOrgIdConfigurationClaimsProductsInsurersRouteRoute,
  ConsoleOrgIdConfigurationClaimsProductsProductTypesRouteRoute:
    ConsoleOrgIdConfigurationClaimsProductsProductTypesRouteRouteWithChildren,
  ConsoleOrgIdConfigurationClaimsProductsProductsV2RouteRoute:
    ConsoleOrgIdConfigurationClaimsProductsProductsV2RouteRouteWithChildren,
  ConsoleOrgIdConfigurationClaimsProductsQuestionnaireRouteRoute:
    ConsoleOrgIdConfigurationClaimsProductsQuestionnaireRouteRouteWithChildren,
};

const ConsoleOrgIdConfigurationClaimsProductsRouteRouteWithChildren =
  ConsoleOrgIdConfigurationClaimsProductsRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationClaimsProductsRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationClientDatabaseRouteChildren = {
  ConsoleOrgIdConfigurationClientDatabaseSplatRoute:
    ConsoleOrgIdConfigurationClientDatabaseSplatRoute,
};

const ConsoleOrgIdConfigurationClientDatabaseRouteWithChildren =
  ConsoleOrgIdConfigurationClientDatabaseRoute._addFileChildren(
    ConsoleOrgIdConfigurationClientDatabaseRouteChildren,
  );

const ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsAddRoute:
      ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsAddRoute,
    ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsEditIdRouteRoute:
      ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsEditIdRouteRoute,
  };

const ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsRouteRouteWithChildren =
  ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationComplianceAttestationsRouteRouteChildren = {
  ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsRouteRoute:
    ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsRouteRouteWithChildren,
};

const ConsoleOrgIdConfigurationComplianceAttestationsRouteRouteWithChildren =
  ConsoleOrgIdConfigurationComplianceAttestationsRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationComplianceAttestationsRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationComplianceComplaintsFlagsRouteRouteChildren = {
  ConsoleOrgIdConfigurationComplianceComplaintsFlagsAddRoute:
    ConsoleOrgIdConfigurationComplianceComplaintsFlagsAddRoute,
  ConsoleOrgIdConfigurationComplianceComplaintsFlagsEditComplaintFlagIdRoute:
    ConsoleOrgIdConfigurationComplianceComplaintsFlagsEditComplaintFlagIdRoute,
};

const ConsoleOrgIdConfigurationComplianceComplaintsFlagsRouteRouteWithChildren =
  ConsoleOrgIdConfigurationComplianceComplaintsFlagsRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationComplianceComplaintsFlagsRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationComplianceComplaintsGeneralTimelineRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationComplianceComplaintsGeneralTimelineMilestonesAddRoute:
      ConsoleOrgIdConfigurationComplianceComplaintsGeneralTimelineMilestonesAddRoute,
    ConsoleOrgIdConfigurationComplianceComplaintsGeneralTimelineMilestonesEditInternalNameRoute:
      ConsoleOrgIdConfigurationComplianceComplaintsGeneralTimelineMilestonesEditInternalNameRoute,
  };

const ConsoleOrgIdConfigurationComplianceComplaintsGeneralTimelineRouteRouteWithChildren =
  ConsoleOrgIdConfigurationComplianceComplaintsGeneralTimelineRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationComplianceComplaintsGeneralTimelineRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationComplianceComplaintsGeneralRouteRouteChildren = {
  ConsoleOrgIdConfigurationComplianceComplaintsGeneralIndexRoute:
    ConsoleOrgIdConfigurationComplianceComplaintsGeneralIndexRoute,
  ConsoleOrgIdConfigurationComplianceComplaintsGeneralLodgementRoute:
    ConsoleOrgIdConfigurationComplianceComplaintsGeneralLodgementRoute,
  ConsoleOrgIdConfigurationComplianceComplaintsGeneralTimelineRouteRoute:
    ConsoleOrgIdConfigurationComplianceComplaintsGeneralTimelineRouteRouteWithChildren,
};

const ConsoleOrgIdConfigurationComplianceComplaintsGeneralRouteRouteWithChildren =
  ConsoleOrgIdConfigurationComplianceComplaintsGeneralRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationComplianceComplaintsGeneralRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationComplianceComplaintsRouteRouteChildren = {
  ConsoleOrgIdConfigurationComplianceComplaintsIndexRoute:
    ConsoleOrgIdConfigurationComplianceComplaintsIndexRoute,
  ConsoleOrgIdConfigurationComplianceComplaintsBrandsRoute:
    ConsoleOrgIdConfigurationComplianceComplaintsBrandsRoute,
  ConsoleOrgIdConfigurationComplianceComplaintsCustomFieldsRoute:
    ConsoleOrgIdConfigurationComplianceComplaintsCustomFieldsRoute,
  ConsoleOrgIdConfigurationComplianceComplaintsFlagsRouteRoute:
    ConsoleOrgIdConfigurationComplianceComplaintsFlagsRouteRouteWithChildren,
  ConsoleOrgIdConfigurationComplianceComplaintsGeneralRouteRoute:
    ConsoleOrgIdConfigurationComplianceComplaintsGeneralRouteRouteWithChildren,
  ConsoleOrgIdConfigurationComplianceComplaintsRulesRoute:
    ConsoleOrgIdConfigurationComplianceComplaintsRulesRoute,
};

const ConsoleOrgIdConfigurationComplianceComplaintsRouteRouteWithChildren =
  ConsoleOrgIdConfigurationComplianceComplaintsRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationComplianceComplaintsRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationComplianceGeneralRouteRouteChildren = {
  ConsoleOrgIdConfigurationComplianceGeneralIndexRoute:
    ConsoleOrgIdConfigurationComplianceGeneralIndexRoute,
  ConsoleOrgIdConfigurationComplianceGeneralAsicProductsRoute:
    ConsoleOrgIdConfigurationComplianceGeneralAsicProductsRoute,
  ConsoleOrgIdConfigurationComplianceGeneralDocumentsRoute:
    ConsoleOrgIdConfigurationComplianceGeneralDocumentsRoute,
};

const ConsoleOrgIdConfigurationComplianceGeneralRouteRouteWithChildren =
  ConsoleOrgIdConfigurationComplianceGeneralRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationComplianceGeneralRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationComplianceIncidentsFlagsRouteRouteChildren = {
  ConsoleOrgIdConfigurationComplianceIncidentsFlagsAddRoute:
    ConsoleOrgIdConfigurationComplianceIncidentsFlagsAddRoute,
  ConsoleOrgIdConfigurationComplianceIncidentsFlagsEditIncidentFlagIdRoute:
    ConsoleOrgIdConfigurationComplianceIncidentsFlagsEditIncidentFlagIdRoute,
};

const ConsoleOrgIdConfigurationComplianceIncidentsFlagsRouteRouteWithChildren =
  ConsoleOrgIdConfigurationComplianceIncidentsFlagsRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationComplianceIncidentsFlagsRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationComplianceIncidentsGeneralTimelineRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationComplianceIncidentsGeneralTimelineMilestonesAddRoute:
      ConsoleOrgIdConfigurationComplianceIncidentsGeneralTimelineMilestonesAddRoute,
    ConsoleOrgIdConfigurationComplianceIncidentsGeneralTimelineMilestonesEditInternalNameRoute:
      ConsoleOrgIdConfigurationComplianceIncidentsGeneralTimelineMilestonesEditInternalNameRoute,
  };

const ConsoleOrgIdConfigurationComplianceIncidentsGeneralTimelineRouteRouteWithChildren =
  ConsoleOrgIdConfigurationComplianceIncidentsGeneralTimelineRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationComplianceIncidentsGeneralTimelineRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationComplianceIncidentsGeneralRouteRouteChildren = {
  ConsoleOrgIdConfigurationComplianceIncidentsGeneralIndexRoute:
    ConsoleOrgIdConfigurationComplianceIncidentsGeneralIndexRoute,
  ConsoleOrgIdConfigurationComplianceIncidentsGeneralIncidentDetailsRoute:
    ConsoleOrgIdConfigurationComplianceIncidentsGeneralIncidentDetailsRoute,
  ConsoleOrgIdConfigurationComplianceIncidentsGeneralLodgementRoute:
    ConsoleOrgIdConfigurationComplianceIncidentsGeneralLodgementRoute,
  ConsoleOrgIdConfigurationComplianceIncidentsGeneralRectificationRoute:
    ConsoleOrgIdConfigurationComplianceIncidentsGeneralRectificationRoute,
  ConsoleOrgIdConfigurationComplianceIncidentsGeneralTimelineRouteRoute:
    ConsoleOrgIdConfigurationComplianceIncidentsGeneralTimelineRouteRouteWithChildren,
};

const ConsoleOrgIdConfigurationComplianceIncidentsGeneralRouteRouteWithChildren =
  ConsoleOrgIdConfigurationComplianceIncidentsGeneralRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationComplianceIncidentsGeneralRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationComplianceIncidentsRouteRouteChildren = {
  ConsoleOrgIdConfigurationComplianceIncidentsIndexRoute:
    ConsoleOrgIdConfigurationComplianceIncidentsIndexRoute,
  ConsoleOrgIdConfigurationComplianceIncidentsCustomFieldsRoute:
    ConsoleOrgIdConfigurationComplianceIncidentsCustomFieldsRoute,
  ConsoleOrgIdConfigurationComplianceIncidentsFlagsRouteRoute:
    ConsoleOrgIdConfigurationComplianceIncidentsFlagsRouteRouteWithChildren,
  ConsoleOrgIdConfigurationComplianceIncidentsGeneralRouteRoute:
    ConsoleOrgIdConfigurationComplianceIncidentsGeneralRouteRouteWithChildren,
  ConsoleOrgIdConfigurationComplianceIncidentsRulesRoute:
    ConsoleOrgIdConfigurationComplianceIncidentsRulesRoute,
};

const ConsoleOrgIdConfigurationComplianceIncidentsRouteRouteWithChildren =
  ConsoleOrgIdConfigurationComplianceIncidentsRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationComplianceIncidentsRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsIdentifiedAddRoute:
      ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsIdentifiedAddRoute,
    ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsExcludedEditIdRoute:
      ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsExcludedEditIdRoute,
    ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsIdentifiedEditIdRoute:
      ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsIdentifiedEditIdRoute,
  };

const ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsRouteRouteWithChildren =
  ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationComplianceMsprDefinitionsRouteRouteChildren = {
  ConsoleOrgIdConfigurationComplianceMsprDefinitionsCategoriesAddRoute:
    ConsoleOrgIdConfigurationComplianceMsprDefinitionsCategoriesAddRoute,
  ConsoleOrgIdConfigurationComplianceMsprDefinitionsCategoriesEditIdRoute:
    ConsoleOrgIdConfigurationComplianceMsprDefinitionsCategoriesEditIdRoute,
};

const ConsoleOrgIdConfigurationComplianceMsprDefinitionsRouteRouteWithChildren =
  ConsoleOrgIdConfigurationComplianceMsprDefinitionsRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationComplianceMsprDefinitionsRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigAddRoute:
      ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigAddRoute,
    ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigEditIdRoute:
      ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigEditIdRoute,
  };

const ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigRouteRouteWithChildren =
  ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationComplianceMsprRouteRouteChildren = {
  ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsRouteRoute:
    ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsRouteRouteWithChildren,
  ConsoleOrgIdConfigurationComplianceMsprDefinitionsRouteRoute:
    ConsoleOrgIdConfigurationComplianceMsprDefinitionsRouteRouteWithChildren,
  ConsoleOrgIdConfigurationComplianceMsprDocumentsRoute:
    ConsoleOrgIdConfigurationComplianceMsprDocumentsRoute,
  ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigRouteRoute:
    ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigRouteRouteWithChildren,
};

const ConsoleOrgIdConfigurationComplianceMsprRouteRouteWithChildren =
  ConsoleOrgIdConfigurationComplianceMsprRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationComplianceMsprRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationComplianceTrainingRouteRouteChildren = {
  ConsoleOrgIdConfigurationComplianceTrainingIndexRoute:
    ConsoleOrgIdConfigurationComplianceTrainingIndexRoute,
  ConsoleOrgIdConfigurationComplianceTrainingCustomFieldsRoute:
    ConsoleOrgIdConfigurationComplianceTrainingCustomFieldsRoute,
  ConsoleOrgIdConfigurationComplianceTrainingTrainingPeriodsRoute:
    ConsoleOrgIdConfigurationComplianceTrainingTrainingPeriodsRoute,
};

const ConsoleOrgIdConfigurationComplianceTrainingRouteRouteWithChildren =
  ConsoleOrgIdConfigurationComplianceTrainingRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationComplianceTrainingRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationComplianceRouteRouteChildren = {
  ConsoleOrgIdConfigurationComplianceIndexRoute:
    ConsoleOrgIdConfigurationComplianceIndexRoute,
  ConsoleOrgIdConfigurationComplianceAttestationsRouteRoute:
    ConsoleOrgIdConfigurationComplianceAttestationsRouteRouteWithChildren,
  ConsoleOrgIdConfigurationComplianceAutoDetectRouteRoute:
    ConsoleOrgIdConfigurationComplianceAutoDetectRouteRoute,
  ConsoleOrgIdConfigurationComplianceComplaintsRouteRoute:
    ConsoleOrgIdConfigurationComplianceComplaintsRouteRouteWithChildren,
  ConsoleOrgIdConfigurationComplianceComplianceAuditRouteRoute:
    ConsoleOrgIdConfigurationComplianceComplianceAuditRouteRoute,
  ConsoleOrgIdConfigurationComplianceGeneralRouteRoute:
    ConsoleOrgIdConfigurationComplianceGeneralRouteRouteWithChildren,
  ConsoleOrgIdConfigurationComplianceIncidentsRouteRoute:
    ConsoleOrgIdConfigurationComplianceIncidentsRouteRouteWithChildren,
  ConsoleOrgIdConfigurationComplianceMsprRouteRoute:
    ConsoleOrgIdConfigurationComplianceMsprRouteRouteWithChildren,
  ConsoleOrgIdConfigurationComplianceObligationsRoute:
    ConsoleOrgIdConfigurationComplianceObligationsRoute,
  ConsoleOrgIdConfigurationComplianceTrainingRouteRoute:
    ConsoleOrgIdConfigurationComplianceTrainingRouteRouteWithChildren,
};

const ConsoleOrgIdConfigurationComplianceRouteRouteWithChildren =
  ConsoleOrgIdConfigurationComplianceRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationComplianceRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationFinancialsBankAccountRouteRouteChildren = {
  ConsoleOrgIdConfigurationFinancialsBankAccountAddRoute:
    ConsoleOrgIdConfigurationFinancialsBankAccountAddRoute,
};

const ConsoleOrgIdConfigurationFinancialsBankAccountRouteRouteWithChildren =
  ConsoleOrgIdConfigurationFinancialsBankAccountRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationFinancialsBankAccountRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationFinancialsBillingRouteRouteChildren = {
  ConsoleOrgIdConfigurationFinancialsBillingBalanceRoute:
    ConsoleOrgIdConfigurationFinancialsBillingBalanceRoute,
  ConsoleOrgIdConfigurationFinancialsBillingBillingInfoRoute:
    ConsoleOrgIdConfigurationFinancialsBillingBillingInfoRoute,
  ConsoleOrgIdConfigurationFinancialsBillingInvoicesRoute:
    ConsoleOrgIdConfigurationFinancialsBillingInvoicesRoute,
  ConsoleOrgIdConfigurationFinancialsBillingTransactionsRoute:
    ConsoleOrgIdConfigurationFinancialsBillingTransactionsRoute,
  ConsoleOrgIdConfigurationFinancialsBillingUsageRoute:
    ConsoleOrgIdConfigurationFinancialsBillingUsageRoute,
  ConsoleOrgIdConfigurationFinancialsBillingPaymentSuccessRoute:
    ConsoleOrgIdConfigurationFinancialsBillingPaymentSuccessRoute,
};

const ConsoleOrgIdConfigurationFinancialsBillingRouteRouteWithChildren =
  ConsoleOrgIdConfigurationFinancialsBillingRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationFinancialsBillingRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationFinancialsRouteRouteChildren = {
  ConsoleOrgIdConfigurationFinancialsBankAccountRouteRoute:
    ConsoleOrgIdConfigurationFinancialsBankAccountRouteRouteWithChildren,
  ConsoleOrgIdConfigurationFinancialsBillingRouteRoute:
    ConsoleOrgIdConfigurationFinancialsBillingRouteRouteWithChildren,
  ConsoleOrgIdConfigurationFinancialsExpensesBillingRouteRoute:
    ConsoleOrgIdConfigurationFinancialsExpensesBillingRouteRoute,
};

const ConsoleOrgIdConfigurationFinancialsRouteRouteWithChildren =
  ConsoleOrgIdConfigurationFinancialsRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationFinancialsRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdClientsRoute:
      ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdClientsRoute,
    ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdDriversRoute:
      ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdDriversRoute,
    ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdHistoryRoute:
      ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdHistoryRoute,
    ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdOverviewRoute:
      ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdOverviewRoute,
    ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdPortalAccessRoute:
      ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdPortalAccessRoute,
    ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRepairersRoute:
      ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRepairersRoute,
    ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdVehiclesRoute:
      ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdVehiclesRoute,
  };

const ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRouteRouteWithChildren =
  ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationFleetClientDatabaseRouteRouteChildren = {
  ConsoleOrgIdConfigurationFleetClientDatabaseAddRoute:
    ConsoleOrgIdConfigurationFleetClientDatabaseAddRoute,
  ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRouteRoute:
    ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRouteRouteWithChildren,
};

const ConsoleOrgIdConfigurationFleetClientDatabaseRouteRouteWithChildren =
  ConsoleOrgIdConfigurationFleetClientDatabaseRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationFleetClientDatabaseRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationFleetRouteRouteChildren = {
  ConsoleOrgIdConfigurationFleetIndexRoute:
    ConsoleOrgIdConfigurationFleetIndexRoute,
  ConsoleOrgIdConfigurationFleetClientDatabaseRouteRoute:
    ConsoleOrgIdConfigurationFleetClientDatabaseRouteRouteWithChildren,
  ConsoleOrgIdConfigurationFleetDelegatedAuthorityRouteRoute:
    ConsoleOrgIdConfigurationFleetDelegatedAuthorityRouteRoute,
  ConsoleOrgIdConfigurationFleetEscalationsRouteRoute:
    ConsoleOrgIdConfigurationFleetEscalationsRouteRoute,
  ConsoleOrgIdConfigurationFleetPortalClaimPageRouteRoute:
    ConsoleOrgIdConfigurationFleetPortalClaimPageRouteRoute,
};

const ConsoleOrgIdConfigurationFleetRouteRouteWithChildren =
  ConsoleOrgIdConfigurationFleetRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationFleetRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationMonitoringRouteRouteChildren = {
  ConsoleOrgIdConfigurationMonitoringAuditTrailRouteRoute:
    ConsoleOrgIdConfigurationMonitoringAuditTrailRouteRoute,
  ConsoleOrgIdConfigurationMonitoringEmailActivityRouteRoute:
    ConsoleOrgIdConfigurationMonitoringEmailActivityRouteRoute,
  ConsoleOrgIdConfigurationMonitoringStatisticsRouteRoute:
    ConsoleOrgIdConfigurationMonitoringStatisticsRouteRoute,
};

const ConsoleOrgIdConfigurationMonitoringRouteRouteWithChildren =
  ConsoleOrgIdConfigurationMonitoringRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationMonitoringRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesAddRoute:
      ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesAddRoute,
    ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesEditCommSignatureIdRoute:
      ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesEditCommSignatureIdRoute,
  };

const ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesRouteRouteWithChildren =
  ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesAddRoute:
      ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesAddRoute,
    ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesEditCommunicationTemplateIdRoute:
      ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesEditCommunicationTemplateIdRoute,
  };

const ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesRouteRouteWithChildren =
  ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationOrgSettingsCommunicationRouteRouteChildren = {
  ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesRouteRoute:
    ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesRouteRouteWithChildren,
  ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesRouteRoute:
    ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesRouteRouteWithChildren,
};

const ConsoleOrgIdConfigurationOrgSettingsCommunicationRouteRouteWithChildren =
  ConsoleOrgIdConfigurationOrgSettingsCommunicationRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationOrgSettingsCommunicationRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesDetailsIdRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesDetailsIdUsersRoute:
      ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesDetailsIdUsersRoute,
  };

const ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesDetailsIdRouteRouteWithChildren =
  ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesDetailsIdRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesDetailsIdRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesRouteRouteChildren = {
  ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesAddRoute:
    ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesAddRoute,
  ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesDetailsIdRouteRoute:
    ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesDetailsIdRouteRouteWithChildren,
};

const ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesRouteRouteWithChildren =
  ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationOrgSettingsTrashRouteRouteChildren = {
  ConsoleOrgIdConfigurationOrgSettingsTrashIndexRoute:
    ConsoleOrgIdConfigurationOrgSettingsTrashIndexRoute,
  ConsoleOrgIdConfigurationOrgSettingsTrashFilesRoute:
    ConsoleOrgIdConfigurationOrgSettingsTrashFilesRoute,
  ConsoleOrgIdConfigurationOrgSettingsTrashRegistersRoute:
    ConsoleOrgIdConfigurationOrgSettingsTrashRegistersRoute,
};

const ConsoleOrgIdConfigurationOrgSettingsTrashRouteRouteWithChildren =
  ConsoleOrgIdConfigurationOrgSettingsTrashRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationOrgSettingsTrashRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationOrgSettingsUsersRouteRouteChildren = {
  ConsoleOrgIdConfigurationOrgSettingsUsersIndexRoute:
    ConsoleOrgIdConfigurationOrgSettingsUsersIndexRoute,
  ConsoleOrgIdConfigurationOrgSettingsUsersDetailsUserIdRouteRoute:
    ConsoleOrgIdConfigurationOrgSettingsUsersDetailsUserIdRouteRoute,
};

const ConsoleOrgIdConfigurationOrgSettingsUsersRouteRouteWithChildren =
  ConsoleOrgIdConfigurationOrgSettingsUsersRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationOrgSettingsUsersRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationOrgSettingsRouteRouteChildren = {
  ConsoleOrgIdConfigurationOrgSettingsCommunicationRouteRoute:
    ConsoleOrgIdConfigurationOrgSettingsCommunicationRouteRouteWithChildren,
  ConsoleOrgIdConfigurationOrgSettingsFleetEscalationsRoute:
    ConsoleOrgIdConfigurationOrgSettingsFleetEscalationsRoute,
  ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesRouteRoute:
    ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesRouteRouteWithChildren,
  ConsoleOrgIdConfigurationOrgSettingsSupportSessionsRouteRoute:
    ConsoleOrgIdConfigurationOrgSettingsSupportSessionsRouteRoute,
  ConsoleOrgIdConfigurationOrgSettingsSystemRouteRoute:
    ConsoleOrgIdConfigurationOrgSettingsSystemRouteRoute,
  ConsoleOrgIdConfigurationOrgSettingsTrashRouteRoute:
    ConsoleOrgIdConfigurationOrgSettingsTrashRouteRouteWithChildren,
  ConsoleOrgIdConfigurationOrgSettingsUsersRouteRoute:
    ConsoleOrgIdConfigurationOrgSettingsUsersRouteRouteWithChildren,
};

const ConsoleOrgIdConfigurationOrgSettingsRouteRouteWithChildren =
  ConsoleOrgIdConfigurationOrgSettingsRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationOrgSettingsRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationRiskRouteRouteChildren = {
  ConsoleOrgIdConfigurationRiskIndexRoute:
    ConsoleOrgIdConfigurationRiskIndexRoute,
  ConsoleOrgIdConfigurationRiskAppetiteRoute:
    ConsoleOrgIdConfigurationRiskAppetiteRoute,
  ConsoleOrgIdConfigurationRiskCategoriesRoute:
    ConsoleOrgIdConfigurationRiskCategoriesRoute,
  ConsoleOrgIdConfigurationRiskMatrixRoute:
    ConsoleOrgIdConfigurationRiskMatrixRoute,
};

const ConsoleOrgIdConfigurationRiskRouteRouteWithChildren =
  ConsoleOrgIdConfigurationRiskRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationRiskRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationVendorManagementRepairNetworksDetailsIdRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationVendorManagementRepairNetworksDetailsIdClientsRoute:
      ConsoleOrgIdConfigurationVendorManagementRepairNetworksDetailsIdClientsRoute,
    ConsoleOrgIdConfigurationVendorManagementRepairNetworksDetailsIdMembersRoute:
      ConsoleOrgIdConfigurationVendorManagementRepairNetworksDetailsIdMembersRoute,
    ConsoleOrgIdConfigurationVendorManagementRepairNetworksDetailsIdOverviewRoute:
      ConsoleOrgIdConfigurationVendorManagementRepairNetworksDetailsIdOverviewRoute,
  };

const ConsoleOrgIdConfigurationVendorManagementRepairNetworksDetailsIdRouteRouteWithChildren =
  ConsoleOrgIdConfigurationVendorManagementRepairNetworksDetailsIdRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationVendorManagementRepairNetworksDetailsIdRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationVendorManagementRepairNetworksRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationVendorManagementRepairNetworksDetailsIdRouteRoute:
      ConsoleOrgIdConfigurationVendorManagementRepairNetworksDetailsIdRouteRouteWithChildren,
  };

const ConsoleOrgIdConfigurationVendorManagementRepairNetworksRouteRouteWithChildren =
  ConsoleOrgIdConfigurationVendorManagementRepairNetworksRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationVendorManagementRepairNetworksRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdContactsAddRoute:
      ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdContactsAddRoute,
    ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdContactsEditContactIdRoute:
      ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdContactsEditContactIdRoute,
  };

const ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdRouteRouteWithChildren =
  ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRouteChildren = {
  ConsoleOrgIdConfigurationVendorManagementSuppliersIndexRoute:
    ConsoleOrgIdConfigurationVendorManagementSuppliersIndexRoute,
  ConsoleOrgIdConfigurationVendorManagementSuppliersAddRoute:
    ConsoleOrgIdConfigurationVendorManagementSuppliersAddRoute,
  ConsoleOrgIdConfigurationVendorManagementSuppliersDefinitionsRoute:
    ConsoleOrgIdConfigurationVendorManagementSuppliersDefinitionsRoute,
  ConsoleOrgIdConfigurationVendorManagementSuppliersListIndexRoute:
    ConsoleOrgIdConfigurationVendorManagementSuppliersListIndexRoute,
  ConsoleOrgIdConfigurationVendorManagementSuppliersSearchIndexRoute:
    ConsoleOrgIdConfigurationVendorManagementSuppliersSearchIndexRoute,
  ConsoleOrgIdConfigurationVendorManagementSuppliersSearchDefinitionsRoute:
    ConsoleOrgIdConfigurationVendorManagementSuppliersSearchDefinitionsRoute,
  ConsoleOrgIdConfigurationVendorManagementSuppliersSearchListRoute:
    ConsoleOrgIdConfigurationVendorManagementSuppliersSearchListRoute,
  ConsoleOrgIdConfigurationVendorManagementSuppliersDetailsIdIndexRoute:
    ConsoleOrgIdConfigurationVendorManagementSuppliersDetailsIdIndexRoute,
  ConsoleOrgIdConfigurationVendorManagementSuppliersDetailsIdSplatRoute:
    ConsoleOrgIdConfigurationVendorManagementSuppliersDetailsIdSplatRoute,
  ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdRouteRoute:
    ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdRouteRouteWithChildren,
};

const ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRouteWithChildren =
  ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationVendorManagementRouteRouteChildren = {
  ConsoleOrgIdConfigurationVendorManagementRepairNetworksRouteRoute:
    ConsoleOrgIdConfigurationVendorManagementRepairNetworksRouteRouteWithChildren,
  ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRoute:
    ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRouteWithChildren,
};

const ConsoleOrgIdConfigurationVendorManagementRouteRouteWithChildren =
  ConsoleOrgIdConfigurationVendorManagementRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationVendorManagementRouteRouteChildren,
  );

const ConsoleOrgIdConfigurationRouteRouteChildren = {
  ConsoleOrgIdConfigurationIndexRoute: ConsoleOrgIdConfigurationIndexRoute,
  ConsoleOrgIdConfigurationApiIntegrationsRouteRoute:
    ConsoleOrgIdConfigurationApiIntegrationsRouteRouteWithChildren,
  ConsoleOrgIdConfigurationClaimsProductsRouteRoute:
    ConsoleOrgIdConfigurationClaimsProductsRouteRouteWithChildren,
  ConsoleOrgIdConfigurationClientDatabaseRoute:
    ConsoleOrgIdConfigurationClientDatabaseRouteWithChildren,
  ConsoleOrgIdConfigurationComplianceRouteRoute:
    ConsoleOrgIdConfigurationComplianceRouteRouteWithChildren,
  ConsoleOrgIdConfigurationFinancialsRouteRoute:
    ConsoleOrgIdConfigurationFinancialsRouteRouteWithChildren,
  ConsoleOrgIdConfigurationFleetRouteRoute:
    ConsoleOrgIdConfigurationFleetRouteRouteWithChildren,
  ConsoleOrgIdConfigurationMonitoringRouteRoute:
    ConsoleOrgIdConfigurationMonitoringRouteRouteWithChildren,
  ConsoleOrgIdConfigurationOrgSettingsRouteRoute:
    ConsoleOrgIdConfigurationOrgSettingsRouteRouteWithChildren,
  ConsoleOrgIdConfigurationRiskRouteRoute:
    ConsoleOrgIdConfigurationRiskRouteRouteWithChildren,
  ConsoleOrgIdConfigurationVendorManagementRouteRoute:
    ConsoleOrgIdConfigurationVendorManagementRouteRouteWithChildren,
};

const ConsoleOrgIdConfigurationRouteRouteWithChildren =
  ConsoleOrgIdConfigurationRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationRouteRouteChildren,
  );

const ConsoleOrgIdControlsRegisterDetailsIdRouteRouteChildren = {
  ConsoleOrgIdControlsRegisterDetailsIdActivityActivityIdRouteRoute:
    ConsoleOrgIdControlsRegisterDetailsIdActivityActivityIdRouteRoute,
  ConsoleOrgIdControlsRegisterDetailsIdActivityAddRouteRoute:
    ConsoleOrgIdControlsRegisterDetailsIdActivityAddRouteRoute,
  ConsoleOrgIdControlsRegisterDetailsIdTestTestIdRouteRoute:
    ConsoleOrgIdControlsRegisterDetailsIdTestTestIdRouteRoute,
  ConsoleOrgIdControlsRegisterDetailsIdTestAddRouteRoute:
    ConsoleOrgIdControlsRegisterDetailsIdTestAddRouteRoute,
};

const ConsoleOrgIdControlsRegisterDetailsIdRouteRouteWithChildren =
  ConsoleOrgIdControlsRegisterDetailsIdRouteRoute._addFileChildren(
    ConsoleOrgIdControlsRegisterDetailsIdRouteRouteChildren,
  );

const ConsoleOrgIdControlsRegisterRouteRouteChildren = {
  ConsoleOrgIdControlsRegisterIndexRoute:
    ConsoleOrgIdControlsRegisterIndexRoute,
  ConsoleOrgIdControlsRegisterAddRouteRoute:
    ConsoleOrgIdControlsRegisterAddRouteRoute,
  ConsoleOrgIdControlsRegisterDetailsIdRouteRoute:
    ConsoleOrgIdControlsRegisterDetailsIdRouteRouteWithChildren,
};

const ConsoleOrgIdControlsRegisterRouteRouteWithChildren =
  ConsoleOrgIdControlsRegisterRouteRoute._addFileChildren(
    ConsoleOrgIdControlsRegisterRouteRouteChildren,
  );

const ConsoleOrgIdControlsRouteRouteChildren = {
  ConsoleOrgIdControlsIndexRoute: ConsoleOrgIdControlsIndexRoute,
  ConsoleOrgIdControlsActivitiesRouteRoute:
    ConsoleOrgIdControlsActivitiesRouteRoute,
  ConsoleOrgIdControlsRegisterRouteRoute:
    ConsoleOrgIdControlsRegisterRouteRouteWithChildren,
  ConsoleOrgIdControlsTestsRouteRoute: ConsoleOrgIdControlsTestsRouteRoute,
};

const ConsoleOrgIdControlsRouteRouteWithChildren =
  ConsoleOrgIdControlsRouteRoute._addFileChildren(
    ConsoleOrgIdControlsRouteRouteChildren,
  );

const ConsoleOrgIdDashboardRouteRouteChildren = {
  ConsoleOrgIdDashboardIndexRoute: ConsoleOrgIdDashboardIndexRoute,
  ConsoleOrgIdDashboardClaimsRoute: ConsoleOrgIdDashboardClaimsRoute,
  ConsoleOrgIdDashboardComplaintsRoute: ConsoleOrgIdDashboardComplaintsRoute,
  ConsoleOrgIdDashboardIncidentsRoute: ConsoleOrgIdDashboardIncidentsRoute,
  ConsoleOrgIdDashboardManagementRoute: ConsoleOrgIdDashboardManagementRoute,
  ConsoleOrgIdDashboardPeopleAndCultureRoute:
    ConsoleOrgIdDashboardPeopleAndCultureRoute,
  ConsoleOrgIdDashboardRisksRoute: ConsoleOrgIdDashboardRisksRoute,
};

const ConsoleOrgIdDashboardRouteRouteWithChildren =
  ConsoleOrgIdDashboardRouteRoute._addFileChildren(
    ConsoleOrgIdDashboardRouteRouteChildren,
  );

const ConsoleOrgIdDocumentsRouteRouteChildren = {
  ConsoleOrgIdDocumentsDetailsFileIdRouteRoute:
    ConsoleOrgIdDocumentsDetailsFileIdRouteRoute,
};

const ConsoleOrgIdDocumentsRouteRouteWithChildren =
  ConsoleOrgIdDocumentsRouteRoute._addFileChildren(
    ConsoleOrgIdDocumentsRouteRouteChildren,
  );

const ConsoleOrgIdFleetPortalClaimsRouteRouteChildren = {
  ConsoleOrgIdFleetPortalClaimsIndexRoute:
    ConsoleOrgIdFleetPortalClaimsIndexRoute,
  ConsoleOrgIdFleetPortalClaimsDetailsClaimIdRoute:
    ConsoleOrgIdFleetPortalClaimsDetailsClaimIdRoute,
};

const ConsoleOrgIdFleetPortalClaimsRouteRouteWithChildren =
  ConsoleOrgIdFleetPortalClaimsRouteRoute._addFileChildren(
    ConsoleOrgIdFleetPortalClaimsRouteRouteChildren,
  );

const ConsoleOrgIdFleetPortalRouteRouteChildren = {
  ConsoleOrgIdFleetPortalIndexRoute: ConsoleOrgIdFleetPortalIndexRoute,
  ConsoleOrgIdFleetPortalAuthorisationsRoute:
    ConsoleOrgIdFleetPortalAuthorisationsRoute,
  ConsoleOrgIdFleetPortalClaimsRouteRoute:
    ConsoleOrgIdFleetPortalClaimsRouteRouteWithChildren,
  ConsoleOrgIdFleetPortalDashboardRoute: ConsoleOrgIdFleetPortalDashboardRoute,
  ConsoleOrgIdFleetPortalFleetRoute: ConsoleOrgIdFleetPortalFleetRoute,
  ConsoleOrgIdFleetPortalReportingRoute: ConsoleOrgIdFleetPortalReportingRoute,
  ConsoleOrgIdFleetPortalSlaRoute: ConsoleOrgIdFleetPortalSlaRoute,
};

const ConsoleOrgIdFleetPortalRouteRouteWithChildren =
  ConsoleOrgIdFleetPortalRouteRoute._addFileChildren(
    ConsoleOrgIdFleetPortalRouteRouteChildren,
  );

const ConsoleOrgIdMsprMspExceptionsRouteRouteChildren = {
  ConsoleOrgIdMsprMspExceptionsEditIdRoute:
    ConsoleOrgIdMsprMspExceptionsEditIdRoute,
};

const ConsoleOrgIdMsprMspExceptionsRouteRouteWithChildren =
  ConsoleOrgIdMsprMspExceptionsRouteRoute._addFileChildren(
    ConsoleOrgIdMsprMspExceptionsRouteRouteChildren,
  );

const ConsoleOrgIdMsprServiceProvidersSearchRouteRouteChildren = {
  ConsoleOrgIdMsprServiceProvidersSearchAddRoute:
    ConsoleOrgIdMsprServiceProvidersSearchAddRoute,
};

const ConsoleOrgIdMsprServiceProvidersSearchRouteRouteWithChildren =
  ConsoleOrgIdMsprServiceProvidersSearchRouteRoute._addFileChildren(
    ConsoleOrgIdMsprServiceProvidersSearchRouteRouteChildren,
  );

const ConsoleOrgIdMsprServiceProvidersDetailsIdManageRouteRouteChildren = {
  ConsoleOrgIdMsprServiceProvidersDetailsIdManageAddRoute:
    ConsoleOrgIdMsprServiceProvidersDetailsIdManageAddRoute,
  ConsoleOrgIdMsprServiceProvidersDetailsIdManageCheckCheckIdRouteRoute:
    ConsoleOrgIdMsprServiceProvidersDetailsIdManageCheckCheckIdRouteRoute,
  ConsoleOrgIdMsprServiceProvidersDetailsIdManageCheckAddRouteRoute:
    ConsoleOrgIdMsprServiceProvidersDetailsIdManageCheckAddRouteRoute,
  ConsoleOrgIdMsprServiceProvidersDetailsIdManageEditArrangementIdRoute:
    ConsoleOrgIdMsprServiceProvidersDetailsIdManageEditArrangementIdRoute,
};

const ConsoleOrgIdMsprServiceProvidersDetailsIdManageRouteRouteWithChildren =
  ConsoleOrgIdMsprServiceProvidersDetailsIdManageRouteRoute._addFileChildren(
    ConsoleOrgIdMsprServiceProvidersDetailsIdManageRouteRouteChildren,
  );

const ConsoleOrgIdMsprServiceProvidersDetailsIdRouteRouteChildren = {
  ConsoleOrgIdMsprServiceProvidersDetailsIdHistoryRouteRoute:
    ConsoleOrgIdMsprServiceProvidersDetailsIdHistoryRouteRoute,
  ConsoleOrgIdMsprServiceProvidersDetailsIdLibraryRouteRoute:
    ConsoleOrgIdMsprServiceProvidersDetailsIdLibraryRouteRoute,
  ConsoleOrgIdMsprServiceProvidersDetailsIdManageRouteRoute:
    ConsoleOrgIdMsprServiceProvidersDetailsIdManageRouteRouteWithChildren,
};

const ConsoleOrgIdMsprServiceProvidersDetailsIdRouteRouteWithChildren =
  ConsoleOrgIdMsprServiceProvidersDetailsIdRouteRoute._addFileChildren(
    ConsoleOrgIdMsprServiceProvidersDetailsIdRouteRouteChildren,
  );

const ConsoleOrgIdMsprServiceProvidersRouteRouteChildren = {
  ConsoleOrgIdMsprServiceProvidersIndexRoute:
    ConsoleOrgIdMsprServiceProvidersIndexRoute,
  ConsoleOrgIdMsprServiceProvidersSearchRouteRoute:
    ConsoleOrgIdMsprServiceProvidersSearchRouteRouteWithChildren,
  ConsoleOrgIdMsprServiceProvidersDetailsIdRouteRoute:
    ConsoleOrgIdMsprServiceProvidersDetailsIdRouteRouteWithChildren,
};

const ConsoleOrgIdMsprServiceProvidersRouteRouteWithChildren =
  ConsoleOrgIdMsprServiceProvidersRouteRoute._addFileChildren(
    ConsoleOrgIdMsprServiceProvidersRouteRouteChildren,
  );

const ConsoleOrgIdMsprRouteRouteChildren = {
  ConsoleOrgIdMsprMspExceptionsRouteRoute:
    ConsoleOrgIdMsprMspExceptionsRouteRouteWithChildren,
  ConsoleOrgIdMsprServiceProvidersRouteRoute:
    ConsoleOrgIdMsprServiceProvidersRouteRouteWithChildren,
};

const ConsoleOrgIdMsprRouteRouteWithChildren =
  ConsoleOrgIdMsprRouteRoute._addFileChildren(
    ConsoleOrgIdMsprRouteRouteChildren,
  );

const ConsoleOrgIdReportingRouteRouteChildren = {
  ConsoleOrgIdReportingAddRoute: ConsoleOrgIdReportingAddRoute,
};

const ConsoleOrgIdReportingRouteRouteWithChildren =
  ConsoleOrgIdReportingRouteRoute._addFileChildren(
    ConsoleOrgIdReportingRouteRouteChildren,
  );

const ConsoleOrgIdRiskRasRouteRouteChildren = {
  ConsoleOrgIdRiskRasIndexRoute: ConsoleOrgIdRiskRasIndexRoute,
  ConsoleOrgIdRiskRasDetailsIdRouteRoute:
    ConsoleOrgIdRiskRasDetailsIdRouteRoute,
};

const ConsoleOrgIdRiskRasRouteRouteWithChildren =
  ConsoleOrgIdRiskRasRouteRoute._addFileChildren(
    ConsoleOrgIdRiskRasRouteRouteChildren,
  );

const ConsoleOrgIdRiskRegisterDetailsIdActionPlanRouteRouteChildren = {
  ConsoleOrgIdRiskRegisterDetailsIdActionPlanActionPlanActionPlanIdRouteRoute:
    ConsoleOrgIdRiskRegisterDetailsIdActionPlanActionPlanActionPlanIdRouteRoute,
  ConsoleOrgIdRiskRegisterDetailsIdActionPlanActionPlanAddRouteRoute:
    ConsoleOrgIdRiskRegisterDetailsIdActionPlanActionPlanAddRouteRoute,
};

const ConsoleOrgIdRiskRegisterDetailsIdActionPlanRouteRouteWithChildren =
  ConsoleOrgIdRiskRegisterDetailsIdActionPlanRouteRoute._addFileChildren(
    ConsoleOrgIdRiskRegisterDetailsIdActionPlanRouteRouteChildren,
  );

const ConsoleOrgIdRiskRegisterDetailsIdAssessmentRouteRouteChildren = {
  ConsoleOrgIdRiskRegisterDetailsIdAssessmentIncidentsRoute:
    ConsoleOrgIdRiskRegisterDetailsIdAssessmentIncidentsRoute,
};

const ConsoleOrgIdRiskRegisterDetailsIdAssessmentRouteRouteWithChildren =
  ConsoleOrgIdRiskRegisterDetailsIdAssessmentRouteRoute._addFileChildren(
    ConsoleOrgIdRiskRegisterDetailsIdAssessmentRouteRouteChildren,
  );

const ConsoleOrgIdRiskRegisterDetailsIdRouteRouteChildren = {
  ConsoleOrgIdRiskRegisterDetailsIdActionPlanRouteRoute:
    ConsoleOrgIdRiskRegisterDetailsIdActionPlanRouteRouteWithChildren,
  ConsoleOrgIdRiskRegisterDetailsIdAssessmentRouteRoute:
    ConsoleOrgIdRiskRegisterDetailsIdAssessmentRouteRouteWithChildren,
  ConsoleOrgIdRiskRegisterDetailsIdHistoryRoute:
    ConsoleOrgIdRiskRegisterDetailsIdHistoryRoute,
};

const ConsoleOrgIdRiskRegisterDetailsIdRouteRouteWithChildren =
  ConsoleOrgIdRiskRegisterDetailsIdRouteRoute._addFileChildren(
    ConsoleOrgIdRiskRegisterDetailsIdRouteRouteChildren,
  );

const ConsoleOrgIdRiskRegisterRouteRouteChildren = {
  ConsoleOrgIdRiskRegisterIndexRoute: ConsoleOrgIdRiskRegisterIndexRoute,
  ConsoleOrgIdRiskRegisterDetailsIdRouteRoute:
    ConsoleOrgIdRiskRegisterDetailsIdRouteRouteWithChildren,
};

const ConsoleOrgIdRiskRegisterRouteRouteWithChildren =
  ConsoleOrgIdRiskRegisterRouteRoute._addFileChildren(
    ConsoleOrgIdRiskRegisterRouteRouteChildren,
  );

const ConsoleOrgIdRiskRouteRouteChildren = {
  ConsoleOrgIdRiskIndexRoute: ConsoleOrgIdRiskIndexRoute,
  ConsoleOrgIdRiskRasRouteRoute: ConsoleOrgIdRiskRasRouteRouteWithChildren,
  ConsoleOrgIdRiskRegisterRouteRoute:
    ConsoleOrgIdRiskRegisterRouteRouteWithChildren,
};

const ConsoleOrgIdRiskRouteRouteWithChildren =
  ConsoleOrgIdRiskRouteRoute._addFileChildren(
    ConsoleOrgIdRiskRouteRouteChildren,
  );

const ConsoleOrgIdToolsAutoDetectInboxRouteRouteChildren = {
  ConsoleOrgIdToolsAutoDetectInboxIdReviewEmailClassificationRoute:
    ConsoleOrgIdToolsAutoDetectInboxIdReviewEmailClassificationRoute,
};

const ConsoleOrgIdToolsAutoDetectInboxRouteRouteWithChildren =
  ConsoleOrgIdToolsAutoDetectInboxRouteRoute._addFileChildren(
    ConsoleOrgIdToolsAutoDetectInboxRouteRouteChildren,
  );

const ConsoleOrgIdToolsAutoDetectRouteRouteChildren = {
  ConsoleOrgIdToolsAutoDetectDashboardRoute:
    ConsoleOrgIdToolsAutoDetectDashboardRoute,
  ConsoleOrgIdToolsAutoDetectInboxRouteRoute:
    ConsoleOrgIdToolsAutoDetectInboxRouteRouteWithChildren,
};

const ConsoleOrgIdToolsAutoDetectRouteRouteWithChildren =
  ConsoleOrgIdToolsAutoDetectRouteRoute._addFileChildren(
    ConsoleOrgIdToolsAutoDetectRouteRouteChildren,
  );

const ConsoleOrgIdToolsComplianceAuditOverviewSearchRouteRouteChildren = {
  ConsoleOrgIdToolsComplianceAuditOverviewSearchAddRoute:
    ConsoleOrgIdToolsComplianceAuditOverviewSearchAddRoute,
};

const ConsoleOrgIdToolsComplianceAuditOverviewSearchRouteRouteWithChildren =
  ConsoleOrgIdToolsComplianceAuditOverviewSearchRouteRoute._addFileChildren(
    ConsoleOrgIdToolsComplianceAuditOverviewSearchRouteRouteChildren,
  );

const ConsoleOrgIdToolsComplianceAuditOverviewRouteRouteChildren = {
  ConsoleOrgIdToolsComplianceAuditOverviewIndexRoute:
    ConsoleOrgIdToolsComplianceAuditOverviewIndexRoute,
  ConsoleOrgIdToolsComplianceAuditOverviewInsightsRoute:
    ConsoleOrgIdToolsComplianceAuditOverviewInsightsRoute,
  ConsoleOrgIdToolsComplianceAuditOverviewSearchRouteRoute:
    ConsoleOrgIdToolsComplianceAuditOverviewSearchRouteRouteWithChildren,
};

const ConsoleOrgIdToolsComplianceAuditOverviewRouteRouteWithChildren =
  ConsoleOrgIdToolsComplianceAuditOverviewRouteRoute._addFileChildren(
    ConsoleOrgIdToolsComplianceAuditOverviewRouteRouteChildren,
  );

const ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdRouteChildren = {
  ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdFindDocumentsRoute:
    ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdFindDocumentsRoute,
  ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdStatisticsRoute:
    ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdStatisticsRoute,
};

const ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdRouteWithChildren =
  ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdRoute._addFileChildren(
    ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdRouteChildren,
  );

const ConsoleOrgIdToolsComplianceAuditRouteRouteChildren = {
  ConsoleOrgIdToolsComplianceAuditIndexRoute:
    ConsoleOrgIdToolsComplianceAuditIndexRoute,
  ConsoleOrgIdToolsComplianceAuditOverviewRouteRoute:
    ConsoleOrgIdToolsComplianceAuditOverviewRouteRouteWithChildren,
  ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdRoute:
    ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdRouteWithChildren,
};

const ConsoleOrgIdToolsComplianceAuditRouteRouteWithChildren =
  ConsoleOrgIdToolsComplianceAuditRouteRoute._addFileChildren(
    ConsoleOrgIdToolsComplianceAuditRouteRouteChildren,
  );

const ConsoleOrgIdToolsDocumentAnalyzerHistoryRouteRouteChildren = {
  ConsoleOrgIdToolsDocumentAnalyzerHistoryIdResultsRoute:
    ConsoleOrgIdToolsDocumentAnalyzerHistoryIdResultsRoute,
};

const ConsoleOrgIdToolsDocumentAnalyzerHistoryRouteRouteWithChildren =
  ConsoleOrgIdToolsDocumentAnalyzerHistoryRouteRoute._addFileChildren(
    ConsoleOrgIdToolsDocumentAnalyzerHistoryRouteRouteChildren,
  );

const ConsoleOrgIdToolsDocumentAnalyzerRouteRouteChildren = {
  ConsoleOrgIdToolsDocumentAnalyzerIndexRoute:
    ConsoleOrgIdToolsDocumentAnalyzerIndexRoute,
  ConsoleOrgIdToolsDocumentAnalyzerHistoryRouteRoute:
    ConsoleOrgIdToolsDocumentAnalyzerHistoryRouteRouteWithChildren,
  ConsoleOrgIdToolsDocumentAnalyzerUploadRoute:
    ConsoleOrgIdToolsDocumentAnalyzerUploadRoute,
};

const ConsoleOrgIdToolsDocumentAnalyzerRouteRouteWithChildren =
  ConsoleOrgIdToolsDocumentAnalyzerRouteRoute._addFileChildren(
    ConsoleOrgIdToolsDocumentAnalyzerRouteRouteChildren,
  );

const ConsoleOrgIdToolsPdsComparePdsDocumentsRouteRouteChildren = {
  ConsoleOrgIdToolsPdsComparePdsDocumentsEditIdRoute:
    ConsoleOrgIdToolsPdsComparePdsDocumentsEditIdRoute,
};

const ConsoleOrgIdToolsPdsComparePdsDocumentsRouteRouteWithChildren =
  ConsoleOrgIdToolsPdsComparePdsDocumentsRouteRoute._addFileChildren(
    ConsoleOrgIdToolsPdsComparePdsDocumentsRouteRouteChildren,
  );

const ConsoleOrgIdToolsPdsCompareRouteRouteChildren = {
  ConsoleOrgIdToolsPdsCompareIndexRoute: ConsoleOrgIdToolsPdsCompareIndexRoute,
  ConsoleOrgIdToolsPdsComparePdsDocumentsRouteRoute:
    ConsoleOrgIdToolsPdsComparePdsDocumentsRouteRouteWithChildren,
};

const ConsoleOrgIdToolsPdsCompareRouteRouteWithChildren =
  ConsoleOrgIdToolsPdsCompareRouteRoute._addFileChildren(
    ConsoleOrgIdToolsPdsCompareRouteRouteChildren,
  );

const ConsoleOrgIdToolsWebsiteCheckerRouteRouteChildren = {
  ConsoleOrgIdToolsWebsiteCheckerIndexRoute:
    ConsoleOrgIdToolsWebsiteCheckerIndexRoute,
  ConsoleOrgIdToolsWebsiteCheckerReportIdRouteRoute:
    ConsoleOrgIdToolsWebsiteCheckerReportIdRouteRoute,
};

const ConsoleOrgIdToolsWebsiteCheckerRouteRouteWithChildren =
  ConsoleOrgIdToolsWebsiteCheckerRouteRoute._addFileChildren(
    ConsoleOrgIdToolsWebsiteCheckerRouteRouteChildren,
  );

const ConsoleOrgIdToolsRouteRouteChildren = {
  ConsoleOrgIdToolsIndexRoute: ConsoleOrgIdToolsIndexRoute,
  ConsoleOrgIdToolsAutoDetectRouteRoute:
    ConsoleOrgIdToolsAutoDetectRouteRouteWithChildren,
  ConsoleOrgIdToolsComplianceAuditRouteRoute:
    ConsoleOrgIdToolsComplianceAuditRouteRouteWithChildren,
  ConsoleOrgIdToolsDocumentAnalyzerRouteRoute:
    ConsoleOrgIdToolsDocumentAnalyzerRouteRouteWithChildren,
  ConsoleOrgIdToolsPdsCompareRouteRoute:
    ConsoleOrgIdToolsPdsCompareRouteRouteWithChildren,
  ConsoleOrgIdToolsWebsiteCheckerRouteRoute:
    ConsoleOrgIdToolsWebsiteCheckerRouteRouteWithChildren,
};

const ConsoleOrgIdToolsRouteRouteWithChildren =
  ConsoleOrgIdToolsRouteRoute._addFileChildren(
    ConsoleOrgIdToolsRouteRouteChildren,
  );

const ConsoleOrgIdUserSettingsRouteRouteChildren = {
  ConsoleOrgIdUserSettingsIndexRoute: ConsoleOrgIdUserSettingsIndexRoute,
  ConsoleOrgIdUserSettingsNotificationsRoute:
    ConsoleOrgIdUserSettingsNotificationsRoute,
  ConsoleOrgIdUserSettingsProfileRoute: ConsoleOrgIdUserSettingsProfileRoute,
  ConsoleOrgIdUserSettingsAuthorisedAppsIndexRoute:
    ConsoleOrgIdUserSettingsAuthorisedAppsIndexRoute,
};

const ConsoleOrgIdUserSettingsRouteRouteWithChildren =
  ConsoleOrgIdUserSettingsRouteRoute._addFileChildren(
    ConsoleOrgIdUserSettingsRouteRouteChildren,
  );

const ConsoleOrgIdWorkloadManagerTasksCalendarRouteRouteChildren = {
  ConsoleOrgIdWorkloadManagerTasksCalendarAddRoute:
    ConsoleOrgIdWorkloadManagerTasksCalendarAddRoute,
  ConsoleOrgIdWorkloadManagerTasksCalendarDetailsIdRoute:
    ConsoleOrgIdWorkloadManagerTasksCalendarDetailsIdRoute,
  ConsoleOrgIdWorkloadManagerTasksCalendarDetailsControl_activityIdRoute:
    ConsoleOrgIdWorkloadManagerTasksCalendarDetailsControl_activityIdRoute,
  ConsoleOrgIdWorkloadManagerTasksCalendarDetailsControl_testIdRoute:
    ConsoleOrgIdWorkloadManagerTasksCalendarDetailsControl_testIdRoute,
  ConsoleOrgIdWorkloadManagerTasksCalendarDetailsMsp_governance_checkIdRoute:
    ConsoleOrgIdWorkloadManagerTasksCalendarDetailsMsp_governance_checkIdRoute,
  ConsoleOrgIdWorkloadManagerTasksCalendarDetailsRisk_actionIdRoute:
    ConsoleOrgIdWorkloadManagerTasksCalendarDetailsRisk_actionIdRoute,
};

const ConsoleOrgIdWorkloadManagerTasksCalendarRouteRouteWithChildren =
  ConsoleOrgIdWorkloadManagerTasksCalendarRouteRoute._addFileChildren(
    ConsoleOrgIdWorkloadManagerTasksCalendarRouteRouteChildren,
  );

const ConsoleOrgIdWorkloadManagerTasksListRouteRouteChildren = {
  ConsoleOrgIdWorkloadManagerTasksListAddRoute:
    ConsoleOrgIdWorkloadManagerTasksListAddRoute,
  ConsoleOrgIdWorkloadManagerTasksListDetailsIdRoute:
    ConsoleOrgIdWorkloadManagerTasksListDetailsIdRoute,
};

const ConsoleOrgIdWorkloadManagerTasksListRouteRouteWithChildren =
  ConsoleOrgIdWorkloadManagerTasksListRouteRoute._addFileChildren(
    ConsoleOrgIdWorkloadManagerTasksListRouteRouteChildren,
  );

const ConsoleOrgIdWorkloadManagerTasksRouteRouteChildren = {
  ConsoleOrgIdWorkloadManagerTasksIndexRoute:
    ConsoleOrgIdWorkloadManagerTasksIndexRoute,
  ConsoleOrgIdWorkloadManagerTasksCalendarRouteRoute:
    ConsoleOrgIdWorkloadManagerTasksCalendarRouteRouteWithChildren,
  ConsoleOrgIdWorkloadManagerTasksListRouteRoute:
    ConsoleOrgIdWorkloadManagerTasksListRouteRouteWithChildren,
};

const ConsoleOrgIdWorkloadManagerTasksRouteRouteWithChildren =
  ConsoleOrgIdWorkloadManagerTasksRouteRoute._addFileChildren(
    ConsoleOrgIdWorkloadManagerTasksRouteRouteChildren,
  );

const ConsoleOrgIdWorkloadManagerRouteRouteChildren = {
  ConsoleOrgIdWorkloadManagerIndexRoute: ConsoleOrgIdWorkloadManagerIndexRoute,
  ConsoleOrgIdWorkloadManagerComplaintsRoute:
    ConsoleOrgIdWorkloadManagerComplaintsRoute,
  ConsoleOrgIdWorkloadManagerEmailsRouteRoute:
    ConsoleOrgIdWorkloadManagerEmailsRouteRoute,
  ConsoleOrgIdWorkloadManagerTasksRouteRoute:
    ConsoleOrgIdWorkloadManagerTasksRouteRouteWithChildren,
};

const ConsoleOrgIdWorkloadManagerRouteRouteWithChildren =
  ConsoleOrgIdWorkloadManagerRouteRoute._addFileChildren(
    ConsoleOrgIdWorkloadManagerRouteRouteChildren,
  );

const ConsoleOrgIdRouteRouteChildren = {
  ConsoleOrgIdIndexRoute: ConsoleOrgIdIndexRoute,
  ConsoleOrgIdAttestationsRouteRoute:
    ConsoleOrgIdAttestationsRouteRouteWithChildren,
  ConsoleOrgIdClaimsRouteRoute: ConsoleOrgIdClaimsRouteRouteWithChildren,
  ConsoleOrgIdComplianceRouteRoute:
    ConsoleOrgIdComplianceRouteRouteWithChildren,
  ConsoleOrgIdComponentShowcaseRouteRoute:
    ConsoleOrgIdComponentShowcaseRouteRouteWithChildren,
  ConsoleOrgIdConfigurationRouteRoute:
    ConsoleOrgIdConfigurationRouteRouteWithChildren,
  ConsoleOrgIdControlsRouteRoute: ConsoleOrgIdControlsRouteRouteWithChildren,
  ConsoleOrgIdDashboardRouteRoute: ConsoleOrgIdDashboardRouteRouteWithChildren,
  ConsoleOrgIdDocumentsRouteRoute: ConsoleOrgIdDocumentsRouteRouteWithChildren,
  ConsoleOrgIdFaqRouteRoute: ConsoleOrgIdFaqRouteRoute,
  ConsoleOrgIdFleetPortalRouteRoute:
    ConsoleOrgIdFleetPortalRouteRouteWithChildren,
  ConsoleOrgIdGetFileRouteRoute: ConsoleOrgIdGetFileRouteRoute,
  ConsoleOrgIdMsprRouteRoute: ConsoleOrgIdMsprRouteRouteWithChildren,
  ConsoleOrgIdReportingRouteRoute: ConsoleOrgIdReportingRouteRouteWithChildren,
  ConsoleOrgIdRiskRouteRoute: ConsoleOrgIdRiskRouteRouteWithChildren,
  ConsoleOrgIdToolsRouteRoute: ConsoleOrgIdToolsRouteRouteWithChildren,
  ConsoleOrgIdToolsOnlyHomePageRoute: ConsoleOrgIdToolsOnlyHomePageRoute,
  ConsoleOrgIdUserSettingsRouteRoute:
    ConsoleOrgIdUserSettingsRouteRouteWithChildren,
  ConsoleOrgIdWorkloadManagerRouteRoute:
    ConsoleOrgIdWorkloadManagerRouteRouteWithChildren,
  ConsoleOrgIdDebugIndexRoute: ConsoleOrgIdDebugIndexRoute,
};

const ConsoleOrgIdRouteRouteWithChildren =
  ConsoleOrgIdRouteRoute._addFileChildren(ConsoleOrgIdRouteRouteChildren);

const rootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminConsentRoute: AdminConsentRoute,
  AttestationRouteRoute: AttestationRouteRouteWithChildren,
  InviteRouteRoute: InviteRouteRoute,
  LodgeRouteRoute: LodgeRouteRouteWithChildren,
  MaintenanceRoute: MaintenanceRoute,
  NotFoundRoute: NotFoundRoute,
  NotSupportedRoute: NotSupportedRoute,
  OauthRouteRoute: OauthRouteRouteWithChildren,
  OrgSwitchedRoute: OrgSwitchedRoute,
  PublicRouteRoute: PublicRouteRouteWithChildren,
  StatusRoute: StatusRoute,
  TermsAcceptanceRouteRoute: TermsAcceptanceRouteRoute,
  authenticationAdminLoginRoute: authenticationAdminLoginRoute,
  authenticationCallbackRoute: authenticationCallbackRoute,
  authenticationLoginRoute: authenticationLoginRoute,
  authenticationLogoutRoute: authenticationLogoutRoute,
  authenticationLogoutinRoute: authenticationLogoutinRoute,
  authenticationOrgMismatchRoute: authenticationOrgMismatchRoute,
  authenticationPaymentPendingRoute: authenticationPaymentPendingRoute,
  authenticationTrialExpiredRoute: authenticationTrialExpiredRoute,
  ConsoleOrgIdRouteRoute: ConsoleOrgIdRouteRouteWithChildren,
  DocumentSourcesConsentRoute: DocumentSourcesConsentRoute,
  PasswordResetRequestRoute: PasswordResetRequestRoute,
  PasswordResetResetRoute: PasswordResetResetRoute,
  WhatsNewReleaseIdRoute: WhatsNewReleaseIdRoute,
  authenticationChangeOrgOrgIdRoute: authenticationChangeOrgOrgIdRoute,
};
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren);
